
import { state } from '@angular/animations';
import { Component, ElementRef, Input, OnInit, OnChanges, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
// import { DecimalPipe, KeyValue } from '@angular/common';
import SignaturePad from 'signature_pad';
// import { Modal } from 'bootstrap';
import { DecimalPipe, KeyValue, formatNumber } from "@angular/common";
import { error } from 'jquery';
import { PhoneFormatPipe } from "../../pipes/phone-format.pipe";
import { DatePipe } from "@angular/common";
import { floatWith2Decimals, groupBy, sumBy, adjustWith2DecimalsForUI } from "../../common-functions";
import { Title } from '@angular/platform-browser';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { CommonPatternsService } from './../../common-patterns.service';
import { LoggerService } from 'src/app/services/logger.service';
import { CustomDatePipe } from './../../pipes/customdate.pipe'
import { loadLanguageData } from 'src/app/state/actions';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadMemberDataSuccess } from 'src/app/state/actions/members.actions';
import { loadCorporateDataSuccess } from 'src/app/state/actions/corporates.actions';




declare var $: any
@Component({
  selector: 'app-add-employee',
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.css'],
  providers: [DecimalPipe, PhoneFormatPipe, DatePipe, CustomDatePipe],
  // encapsulation: ViewEncapsulation.None
})




export class AddEmployeeComponent implements OnChanges, OnInit {
  greenValue: any;
  yellowValue: any;
  public formData: any;
  public allFormData: any = {};
  public lastUpdatedType: any = "";
  public signUpData: any = {};
  public premiums: any = {};
  names: any[] = [
    { label: 'Guaranteed', position: 10 },    // Display "Start" at 0%
    { label: 'Pending', position: 0 }, // Display "Quarter" at 25%

  ];
  addeditbenficiary = false
  benficiaryCount = false;
  showaddmorebenficiary = true;
  benficiaryCountMessage: any;
  beneficariesDetails: any;
  benficiary = false;
  editBenficiaryIndex: any;
  showBenificiaryForm = true;
  showbenificaryTable = false;
  addbenificaryData: any = []
  showSpouseSignature = false;
  showIAFGerrorMessage = false;
  rangeValues: any = [];
  productobj: any;
  minValue = 0;
  maxValue: any;
  public planssummarymainLife: any = [];
  showyellowbar = false
  myDateOfBirth: Date;
  myDateOfHire: Date;
  spouseDateOfBirth: Date;
  childDateOfBirth: Date;
  graduationDate: Date;
  configprovinceres: any;
  currencySymbol: any;
  languageTokensArray: any;
  lang1: any = {};
  lang: any = {};
  selectedLanguage: any;
  configresults: any;
  configPlanEnrollmentDate: any;
  requireDentalHealthCoverage: any = true;
  brokerTermsConditions: any;
  disclosureAgreement_dynamicData: any;
  disclosureAgreement: any;
  term_and_conditions: any;
  formid: any;
  postalvalue: any;
  provincialZipcodes: any;
  invalidpostalcodeprivince: boolean;
  pdfvisibletermsandconditions: boolean;
  // phoneNoFormat: any;
  public applicantDateofBirth: any = new Date(2000, 3, 1);
  provincialHealthcareUrl: any;
  state_id: number;
  statename: any;
  gsPlans: boolean = false;
  eqPlans: boolean = false;
  gsRegistration: boolean = true;
  gsMembershipId: any;
  eqRegistration: boolean = true;
  eqCertificateId: any;
  kixRegistration: boolean = true;
  flexRegistration: boolean = true;
  waddellRegistration: boolean = true;
  showWaddellPlans: boolean = false;

  kixCertificateId: any;
  flexCertificateId: any;
  showEquitable: boolean = false;
  showKixcarePlans: boolean = false;
  showFlexPlans: boolean = false;
  // QCproviance: any;
  checkstudenthealthcardstatus_UHIP: boolean;
  checkhealthcardstatus: boolean = false;
  checkstudenthealthcardstatus: boolean;
  checkhealthcardstatusuhip: boolean;
  spouseinformation: boolean;
  spousehealthcardinfo: boolean;
  parentalhelathinsuranecheck: boolean;
  childrenhealthinformation: boolean;
  childInfoAddDataArray: any = [];
  planssummary: any[] = [];

  // childTableRowsLength: any;
  applicanthavingchildren: any;
  pdfvisibleadvisouredisclosure: boolean = true;
  Shared: any;
  applicantfirstname: any;
  countrydetails: any;
  selectedTab: any = "tab1";
  planAmount: any = 0;
  specialpackages: any;
  tab1Img: boolean;
  minDate: any;
  maxDate: any;
  applicantChildrenname: any;
  completeapplicantinfo: string;
  marital_status: any;
  pdfvisibletermsandcodionsmodel: boolean = true;
  padAgrementLoad: boolean = true;
  withSignLoad: boolean = true;
  graducationdaycheck: boolean = false;
  public plansnexttab: boolean = true;
  cartcheckvalue: boolean;
  allproducts: any;
  // private _decimalPipe: any;
  paymentfirstname: any;
  paymentemail: any;
  homeaddresscheckvalue: boolean = false;
  homeaddressEnrollmentVal: boolean;
  planssummarymain: any;
  planssummaryopt: any;
  studentplanssummarymain: any;
  studentplanssummarymain1: any[];
  paymentMethodSelectCC: boolean;
  bankDetailsNames: string;
  enrollmentBankDetailedVerify: boolean;
  bankDetailsError: string;
  bankDetailsVerifyStatus: boolean;
  bankverifyDetails: any;
  signaturePadClear: boolean = false;
  signaturemessagecc: boolean;
  oldvaluenumber: any;
  childrenDetailsArray: any;
  childTableEditRowIndex: number = 0;
  noOfChildrenChangedValue: number = 1;
  childTableRowsLength: number = 0;
  dependentchildInsurenceval: boolean;
  // childTableEditRowIndex: any;
  childInfoModalAddAndUpdateButton: string;
  provincelistid: any;
  invalidenrollmentpostalcodeprovince: boolean;
  childrenenrollement: boolean;
  isFileUploaded: boolean;
  imagedisplay: any;
  bankfile: any;
  pdfview: boolean;
  public mainarray: any = [];
  mainarrayValues: any = [];
  mainarrayFinal: any = []

  normalview: boolean;
  showSignAndAgreeOrAgree: boolean;
  padAgreementSignaturePadClear: boolean;
  padAgreementSignaturemessagecc: boolean;
  generatePADaggrement: any;
  agreestatus: boolean;
  signaturestatus: boolean;
  signatureImgcc: any;
  publicapikey: any;
  customerid: any;
  displayStudentId: boolean = false;
  hoursperweek: boolean = false;
  hourperweekvalue: boolean = false;
  displatGig: boolean = false;
  firstName: any;
  lastName: any;
  primaryEmail: any;
  primaryPhone: any;
  country: any;
  line1: any;
  line2: any;
  city: any;
  state: any;
  postalZip: any;
  brokers: any;
  showBrokersList: boolean = false;
  formsList: any;
  forms: any = [];
  showForm: boolean = false;
  showGreenShiled: boolean = false;
  showinvitationmail: boolean = false;
  // phoneNoFormat: any;

  public companypaidproductid = [];
  public disabledcompanypaidproductid = [];
  public removedisabledcompanypaidproductid = [];
  public adddisabledcompanypaidproductid = [];
  public packagesInBlocks: any;
  plansskumain: any[] = [];
  plandetailsobjvalue: any;
  optionstitle: any[] = [];
  optionmessage: any;
  showoptions: boolean = false;
  disabledelement: string;
  fusebill_paymentMethod: any = "CC";
  minDateHire: any;
  minDatechild: Date = new Date();;
  maxDatechild: Date = new Date();;
  compName: any;
  employercheck: any;
  brokerid: any;

  public showPaymenthMethod: boolean = false;
  public showPaymenthMethod1: boolean = true;
  isExecutiveCP: boolean;
  public isDisabledplan: boolean = false;
  public creditcardform: boolean = false;
  public bankpaymentmethod: any;
  public directpayCCplansarr: any = [];
  public payrollCCplansarr: any = [];
  public employeeDealingPlansarr: any = [];
  public companySelectedPlans = [];
  public companyCoveredPlans = [];
  public EmployeeSelectedPlans = [];
  public allSelectedPlans = [];
  public companyDealingPlans = [];

  public coveredEmployeeShare: any = 0;
  public paidEmployeeShare: any = 0;
  public totalEmployeeShare: any = 0;
  public cartDisplayAmount: any = 0;
  public allPlansAmountTotal: any = 0;
  public allPlansTotal: any = 0;
  public allPlansTotaltax: any = 0;
  public allCPPlansAmountTotal: any = 0;
  public allCCPlansAmountTotal: any = 0;
  public allEPPlansAmountTotal: any = 0;
  public allCPTaxTotal: any = 0;
  public allCCTaxTotal: any = 0;
  public allEPTaxTotal: any = 0;
  public companyPaidTotal: any = 0;
  public companyCoveredTotal: any = 0;
  public paidEmployeedTotal: any = 0;
  public companyCoveredCompanyShareTotal: any = 0;
  public companyCoveredCompanySharePlanAmountTotal: any = 0;
  public companyCoveredCompanyShareTaxTotal: any = 0;
  public companyCoveredEmployeeShareTotal: any = 0;
  public companyCoveredEmployeeSharePlanAmountTotal: any = 0;
  public companyCoveredEmployeeShareTaxTotal: any = 0;
  public effectiveCompanyTotalContibution: any = 0;
  public effectiveEmployeeTotalContibution: any = 0;
  public effectiveCompanyPlansAmountTotal: any = 0;
  public effectiveCompanyTaxTotal: any = 0;
  basepackages: any;
  public alloptinplans = [];
  payrollCCPlantaxTotal: any;
  empDirectpayPlanamountTotal: any;
  empDirectpayPlantaxTotal: any;
  payrollCCPlansAmountTotal: any;
  payrollCCPlangrandTotal: any;
  empDirectpayPlangrandTotal: any;
  DirectCCpayPlanamountTotal: any;
  DirectCCpayPlantaxTotal: any;
  DirectCCpayPlangrandTotal: any;
  companydealingplansTotal: any;
  companydealingplanstaxTotal: any;
  companydealingplansgrandTotal: any;
  deltaCompanyTax: any;
  corporateAutoPlanSelection: any;
  employername: any;
  countries: any;
  public modifiedBlocksCoveredByCompany: any;


  public CORP_PAYROLL_NOT_MANDATORY_PACKAGES: any = [2, 8, 9];
  public CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS: any = [19, 20, 21, 23, 25, 26];
  plansummary: any;
  companyId: number;
  companyName: any;
  corporateStateId: any;
  ShowNextButton: boolean = true;
  paidEmployeedTotalDub: any;
  working_provinces: any;
  studentPlaceHolder: any;
  studentPlaceHolderln: any;
  role: string;
  plancheckboxcheck: any;
  myDateValue1: Date;
  myDateValue2: Date;

  showlandedimgratestatus: boolean;
  showlandeddependentDetails: boolean;
  showdependentdetails: boolean;
  showdependentlandedstatus: boolean;
  showCowan: boolean;
  cwRegistraion: boolean;
  cwCertificateId: string;
  cwPlans: boolean = false;
  kixPlans: boolean = false;
  flexPlans: boolean = false;
  savedGs: boolean = false;
  savedEq: boolean = false;
  savedKIX: boolean = false;
  savedFLEX: boolean = false;
  savedCw: boolean = false;
  savedWADDELL: boolean = false;
  waddellPlans: boolean = false;
  applicantSpousename: any;
  iafgplansCheck: any = [];
  voluntryplansCheck: boolean = false;
  upgradeplansCheck: boolean = false;
  working_provincelistid: any;
  modifiedBlocksPaidByCompany: any;
  elementcvValues: any;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();
  planobjdata: any = {};
  planobjdataobj: any = {};
  planoptionsValues: any = [];
  planOptionsModel = false;
  paymentlastName: any;
  signatureNeeded: any = true;
  beneficiaryError = false;
  beneficiaryErrorMessage = ''

  constructor(private logger: LoggerService,
    private http: HttpClient,
    private fb: FormBuilder,
    private childInfoFormBuilder: FormBuilder,
    private _CustomDatePipe: CustomDatePipe,
    private toastrService: ToastrService,
    private enrollmentFormBuilder: FormBuilder,
    private bankPayFormBuilder: FormBuilder,
    private creditCardFormBuilder: FormBuilder,
    private router: Router,
    private _decimalPipe: DecimalPipe,
    private datePipe: DatePipe,
    private greenShildBuilder: FormBuilder,


    // private phoneNoFormat1: PhoneNoFormatPipe,
    // private studentService: StudentService,
    // private Shared: SharedService,
    // private _decimalPipe: DecimalPipe,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private el: ElementRef,
    private phoneNoFormat: PhoneFormatPipe,
    private commonPatternsService: CommonPatternsService,
    private store: Store<{ languageData: [] }>

  ) {
    this.minDate = moment().subtract(74, "years").calendar();
    this.maxDate = moment().subtract(16, "years").calendar();
    this.languageData$ = store.select(selectLanguageData);
  }
  signaturePadCC: any = SignaturePad;
  padAggsignaturePadCC: any = SignaturePad;
  @ViewChild('dependentWithSpecialNeeds') dependentWithSpecialNeeds: any;
  @ViewChild(' PADpafaggrementModal') PADpafaggrementModalpopup: any;
  @ViewChild('PADpafaggrementModalSign') PADpafaggrementModalpopupSign: any;
  @ViewChild('signaturePadagreementModal') signaturePadagreementModalPopup: any;
  @ViewChild('postSecondaryStudent') postSecondaryStudentVal: any;
  @ViewChild('signaturePadCanvas') signaturePadCanvasEl?: ElementRef;
  @ViewChild('padAgreementSignaturePadCanvas') padAgreementSignaturePadCanvasEl?: ElementRef;
  @ViewChild('dependentChildInfo') dependentChildInfo?: ElementRef;
  @ViewChild('QCproviance') QCproviance: any;
  @ViewChild('checkuhipstatusModal') checkuhipstatusModal: any;
  @ViewChild('checkphcpstatusModal') checkphcpstatusModal: any;
  // @ViewChild('childInfoModal') childInfoModal: any;
  @ViewChild('advisoranddisclousreModal') advisoranddisclousreModal: any;
  @ViewChild('termsAndConditionsModal') termsAndConditionsModal: any;
  @ViewChild('optionNumberInput') optionNumberInput!: ElementRef;
  @ViewChild('optionPlanDetailsObj') optionPlanDetailsObj!: ElementRef;

  @ViewChild('dp') dpicker: ElementRef;
  @Input() valuFormChaild: any;
  // @ViewChild('signaturePadCanvas') signaturePadCanvasEl?: ElementRef;
  // @ViewChild('padAgreementSignaturePadCanvas') padAgreementSignaturePadCanvasEl?: ElementRef;

  ngOnInit(): void {
    this.getLanguageTokens();
    this.myDateOfBirth = new Date();
    this.myDateOfHire = new Date();
    this.spouseDateOfBirth = new Date();
    this.childDateOfBirth = new Date();
    this.graduationDate = new Date();
    this.countries = this.commonPatternsService.countries
    this.role = sessionStorage.getItem('role');
    this.minDate = moment().subtract(74, "years").calendar();
    this.maxDate = moment().subtract(16, "years").calendar();
    this.studentPlaceHolder = this.lang.name_as_shown_on_provincial_health_card;
    this.studentPlaceHolderln = this.lang.name_as_shown_on_provincial_health_card;

    this.minDate = new Date(this.minDate);

    this.maxDate = new Date(this.maxDate);

    this.minDateHire = moment().subtract(60, "years").calendar();

    this.minDateHire = new Date(this.minDateHire);



    this.minDatechild = new Date();
    const today = new Date();
    this.minDatechild.setFullYear(today.getFullYear() - 21);
    this.minDatechild.setMonth(0); // January
    this.minDatechild.setDate(1); // 1st

    // Set maxDate to December 31st, 2030
    // const today = new Date();
    // let today1 = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    this.maxDatechild = new Date();
    this.maxDatechild.setFullYear(today.getFullYear());
    this.maxDatechild.setMonth(new Date().getMonth()); // December
    this.maxDatechild.setDate(new Date().getDate()); // 31st
    this.compName = sessionStorage.getItem("compName");
    this.getFormConfig();
    this.userFormGroup();
    this.childInfoValidators();
    this.enrolmentFormValidator();
    this.bankPayFormValidator();
    this.greenShiledFormValidations();
    this.EquitableFormValidations();
    this.KixCareValidations()
    this.FlexValidations()
    this.waddellPlanValidations()
    this.welcomeinvitationmail();
    // this.memberInfoFormGropu();

    // alert('aaaaaaaaaa')
  }

  ngOnChanges() {
    this.logger.log('enter to ng on change');
    this.userForm.reset();
    // this.memberInfo.reset();
    this.enrollmentForm.reset();

  }
  ngAfterViewInit() {
    this.logger.log('ngAfterViewInit()')
    this.userForm.reset();
    // this.memberInfo.reset();
    this.enrollmentForm.reset();
  }
  ngDocheck() {
    this.logger.log('enter to ng onDo')
    this.userForm.reset();
    // this.memberInfo.reset();
    this.enrollmentForm.reset();
  }



  getFormConfig() {
    // let formLink = environment.app.formLink
    var accessToken = sessionStorage.getItem('accessToken');
    var endPoint = '/api/ap/customer/coporate/formConfig';
    let dataInput = {
      "coporateId": parseInt(sessionStorage.getItem('corpId')),
      "formId": parseInt(sessionStorage.getItem('compFormId')),
    }

    //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/customer/coporate/formConfig'

    // let configData: string = "https://testadminapi.groupbenefitz.aitestpro.com/api/ap/customer/formConfig_2"

    let lang = "en";
    this.http.post(environment.apiUrl + endPoint, dataInput, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    })
      .subscribe(
        (result: any) => {
          // this.isLoaded =true
          if (result.status == "200") {
            let states;
            states = result.data.states.filter((country) => {
              return country.countryId == 1
            });
            result.data.states = states;
            this.logger.log(JSON.stringify(states));
            this.configprovinceres = result.data.states.sort((a: any, b: any) =>
              a.shortName > b.shortName ? 1 : -1
            );
            // this.provincelist
            this.currencySymbol = result.data.countries[0].currencySymbol;
            this.companyName = result.data.form.broker?.name;
            this.corporateStateId = result.data.corporateStateId;
            this.companyId = result.data.form.broker?.fusebillCorporateCustomerId;
            this.working_provinces = result.data.working_provinces;
            this.working_provinces = this.working_provinces.sort((a: any, b: any) =>
              a.shortName > b.shortName ? 1 : -1
            );
            this.logger.log('working_provinces', this.working_provinces);

            this.logger.log("result: " + JSON.stringify(result))
            this.employercheck = result.data.form.requireEmployerName == true ? true : false;
            if (this.employercheck) {
              this.userForm.get('employername').setValidators([Validators.required]);
              this.userForm.get('employername').updateValueAndValidity();
            } else {
              this.userForm.get('employername').clearValidators();
              this.userForm.get('employername').updateValueAndValidity();
            }

            this.languageTokensArray =
              result.data.languageDetails_2.languageTokens;
            this.lang1 = {};
            for (let token of this.languageTokensArray) {
              const langValue: any = token['value'];
              if (typeof langValue === 'string') {
                this.lang1[token['key']] = langValue.trim();
              } else {
                this.lang1[token['key']] = langValue;
              }
              // this.lang[token['key']] = token['value'];
            }

            this.configresults = result.data;

            sessionStorage.setItem("provincelist", result.data.broker_licensed_provinces);
            sessionStorage.setItem("countrydetails", JSON.stringify(result.data.countries));



            this.logger.log("this.lang: " + JSON.stringify(this.lang1));
            sessionStorage.setItem("langTokens", JSON.stringify(this.lang1));
            this.configPlanEnrollmentDate =
              result.data.validations.customer.planEnrollmentDatesFullMonth;

            this.brokerTermsConditions = result.data?.links?.brokerTermsConditions;
            this.disclosureAgreement_dynamicData = result.data?.links?.disclosureAgreement;
            this.disclosureAgreement = this.disclosureAgreement_dynamicData;
            this.logger.log("lang token: " + sessionStorage.getItem("lanToken"))
            if (sessionStorage.getItem("lanToken") == "en") {

              this.term_and_conditions = this.brokerTermsConditions;
            } else {

              this.term_and_conditions = this.brokerTermsConditions;
            }
            this.formid = result.data.form?.id;
            this.brokerid = result.data.form?.brokerId;

          }
          else {
            Swal.fire({
              title: this.lang?.Info,
              // icon: 'warning',
              html: `<div class="custom-content">${result.message ? result.message : result.error}</div>`,
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonText: "OK",
              confirmButtonAriaLabel: 'Thumbs up, great!',
              cancelButtonText:
                '<i class="fa fa-thumbs-down"></i>',
              cancelButtonAriaLabel: 'Thumbs down'
            })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang?.Error ?? 'Error',
              text: error.error.error.message,
              showCancelButton: false,
              showDenyButton: false,
              confirmButtonText: this.lang?.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang?.Error, text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );


  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "manageCorporates/addEmployee"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       // console.log(response)
    //       this.lang = {};
    //       // this.selectedLanguage = "English"
    //       this.selectedLanguage = sessionStorage.getItem('language') || 'English'
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //       console.log(this.lang)
    //     }
    //   )

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          // this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        }, 0)
      }
    })
  }

  userForm: FormGroup = new FormGroup({
    planEnrollmentDate: new FormControl(''),
    studentId: new FormControl(''),
    employername: new FormControl(''),
    givenname: new FormControl(''),
    lastname: new FormControl(''),
    email: new FormControl(''),
    phonenumber: new FormControl(''),
    apt_suite: new FormControl(''),
    streetaddress: new FormControl(''),
    streetaddressline2: new FormControl(''),
    city: new FormControl(''),
    province: new FormControl(''),
    workingProvince: new FormControl(''),
    postalcode: new FormControl(''),
    dateofbirth: new FormControl(''),
    dateofhire: new FormControl(''),
    gender: new FormControl(''),
    foreignStudent: new FormControl(''),
    parentalinsurance: new FormControl(''),
    havingspouse: new FormControl(''),
    Dependentchildren: new FormControl(''),
    uhipprovincialhealth: new FormControl(''),
    provincialhealth: new FormControl(''),
    spousefirstname: new FormControl(''),
    spouselastname: new FormControl(''),
    spousegender: new FormControl(''),
    spousedateofbirth: new FormControl(''),
    spousehealthcard: new FormControl(''),
    workinghours: new FormControl(''),
    hoursperweek: new FormControl(''),
    fusbillId: new FormControl(''),
    formrname: new FormControl(''),
    brokername: new FormControl(''),
    memberType: new FormControl(''),
    dateOfArrival: new FormControl(''),
    isEmployeeImigrant: new FormControl(''),
    applylandedstaus: new FormControl(''),
    countryOrigin: new FormControl(''),
    coverageRequiredOfEmployee: new FormControl(''),
    dependentdateOfArrival: new FormControl(''),
    coverageRequiredOfDependents: new FormControl(''),
    dependentcountryOrigin: new FormControl(''),
    dependentLandedImigrant: new FormControl(''),
    dependentapplylandedstaus: new FormControl(''),
    dependentMorethan3years: new FormControl(''),

  });

  // memberInfo: FormGroup=new FormGroup({
  //   memberType: new FormControl(''),
  //   brokername:new FormControl(''),
  //   fusbillId:new FormControl(''),

  // })
  // memberInfoFormGropu(){
  //   this.memberInfo=this.fb.group({
  //     memberType:['',Validators.compose([Validators.required])],
  //     brokername:['',],
  //     fusbillId:['',Validators.compose([Validators.required])]
  //   })
  // }

  userFormGroup() {
    this.userForm = this.fb.group({
      planEnrollmentDate: ['', [Validators.required]],
      studentId: [''],
      employername: ["", Validators.compose([Validators.required, Validators.minLength(1)])],
      givenname: ["", Validators.compose([Validators.required, Validators.minLength(1)])],
      lastname: ["", Validators.compose([Validators.required, Validators.minLength(1)])],
      email: ["", Validators.compose([Validators.required, Validators.pattern(this.commonPatternsService.emailPattern)
      ])],

      phonenumber: ["", Validators.compose([Validators.required, Validators.minLength(17), Validators.maxLength(17)])],
      apt_suite: [""],
      streetaddress: ["", Validators.compose([Validators.required])],
      streetaddressline2: [""],
      city: ["", Validators.compose([Validators.required])],
      province: ["", Validators.required],
      workingProvince: ["", Validators.required],
      postalcode: ["", Validators.compose([Validators.required, postalcodeValidator])],
      dateofbirth: ["", Validators.compose([Validators.required, dateofbirthvalidation])],
      gender: ["", Validators.required],
      dateofhire: ["", Validators.required],
      foreignStudent: [""],
      parentalinsurance: [""],
      havingspouse: ["", Validators.required],

      uhipprovincialhealth: [''],
      provincialhealth: ['', Validators.compose([Validators.required])],

      dateOfArrival: [""],
      isEmployeeImigrant: [""],
      applylandedstaus: [""],
      countryOrigin: [""],
      coverageRequiredOfEmployee: [""],

      dependentdateOfArrival: [""],
      coverageRequiredOfDependents: [""],
      dependentcountryOrigin: [""],
      dependentLandedImigrant: [""],
      dependentapplylandedstaus: [""],
      dependentMorethan3years: [""],

      spousefirstname: [''],
      spouselastname: [''],
      spousegender: [""],
      spousedateofbirth: ['04-01-2000'],
      spousehealthcard: [''],

      Spousenameofthecarrier: [''],
      spousecob: [''],

      Dependentchildren: ["", Validators.required],
      enrolledunversity: [""],
      childdsiablility: [""],
      graducationday: [""],
      noofchildren: [''],
      termsandconditions: [""],
      disclouseradvisor: [""],
      recaptchaReactivePerInfo: [""],
      childrenDetails: this.fb.array([this.initChildDetails()]),
      workinghours: ['', Validators.compose([Validators.required])],
      // hoursperweek:[''],
      hoursperweek: [
        "40",
        Validators.compose([Validators.required, validatehoursperweek]),
      ],
      fusbillId: [''],
      formrname: [''],
      brokername: [''],
      memberType: ['']
    });
  }
  greenShiledForm: FormGroup = new FormGroup({
    showGreenShieldProv: new FormControl(),
    greenShiledNumber: new FormControl()
  });
  greenShiledFormValidations() {
    this.greenShiledForm = this.greenShildBuilder.group({
      showGreenShieldProv: ['', [Validators.required]],
      greenShiledNumber: ['']
    })
  }

  EquitableForm: FormGroup = new FormGroup({
    EquitableFormProv: new FormControl(),
    EquitableNumber: new FormControl()
  });
  KixCareForm: FormGroup = new FormGroup({
    KixCareFormProv: new FormControl(),
    // KixCareNumber: new FormControl()
  });
  FlexForm: FormGroup = new FormGroup({
    FlexFormProv: new FormControl(),
    FlexMembershipId: new FormControl()
  });
  waddellPlanForm: FormGroup = new FormGroup({
    waddellFormProv: new FormControl(),
    // KixCareNumber: new FormControl()
  });
  cowanForm: FormGroup = new FormGroup({
    cowanFormProv: new FormControl(),
    cowanNumber: new FormControl()
  });
  InvitationForm: FormGroup = new FormGroup({
    invitationStatus: new FormControl(),
    invitationEmail: new FormControl(),
  });
  welcomeinvitationmail() {
    this.InvitationForm = this.fb.group({
      invitationStatus: ['', [Validators.required]],
      invitationEmail: ['', [Validators.pattern(this.commonPatternsService.emailPattern)]],

    })
  }
  EquitableFormValidations() {
    this.EquitableForm = this.greenShildBuilder.group({
      EquitableFormProv: ['', [Validators.required]],
      EquitableNumber: ['']
    })
  }
  KixCareValidations() {
    this.KixCareForm = this.greenShildBuilder.group({
      KixCareFormProv: ['', [Validators.required]],
      // KixCareNumber: ['']
    })
  }
  FlexValidations() {
    this.FlexForm = this.greenShildBuilder.group({
      FlexFormProv: ['', [Validators.required]],
      FlexMembershipId: ['']
    })
  }


  waddellPlanValidations() {
    this.waddellPlanForm = this.greenShildBuilder.group({
      waddellFormProv: ['', [Validators.required]],
      // KixCareNumber: ['']
    })
  }

  cowanFormValidations() {
    this.cowanForm = this.greenShildBuilder.group({
      cowanFormProv: ['', [Validators.required]],
      cowanNumber: ['']
    })
  }

  enrollmentForm: FormGroup = new FormGroup({
    enrollmentSummaryEmail: new FormControl(''),
    ///enrolmentForm
    enrollmentSummaryCardHolderFirstName: new FormControl(''),
    enrollmentSummaryCardHolderLastName: new FormControl(''),
    enrollmentSummaryCardNumnber: new FormControl(''),
    enrollmentSummaryExpirymonth: new FormControl(''),
    enrollmentSummaryExpiryyear: new FormControl(''),
    enrollmentSummaryCVV: new FormControl(''),
    ////******** */
    homeAddressSameasBillingAddress: new FormControl(''),
    enrollmentSummaryApartSuite: new FormControl(''),
    enrollmentSummaryStreetAddress: new FormControl(''),
    enrollmentSummaryStreetAddressLane2: new FormControl(''),
    enrollmentSummaryCity: new FormControl(''),
    enrollmentSummaryProvince: new FormControl(''),
    enrollmentSummaryPostalCode: new FormControl(''),

  });

  enrolmentFormValidator() {
    this.enrollmentForm = this.enrollmentFormBuilder.group({
      enrollmentSummaryEmail: [''],
      homeAddressSameasBillingAddress: [''],
      enrollmentSummaryApartSuite: ['', Validators.compose([apt_suitecheck, Validators.maxLength(50)])],
      enrollmentSummaryStreetAddress: ['', Validators.compose([Validators.required])],
      enrollmentSummaryStreetAddressLane2: [''],
      enrollmentSummaryCity: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      enrollmentSummaryProvince: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      enrollmentSummaryPostalCode: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      recaptchaReactive: [''],

      //enrollmentSummaryApartSuite: ["", Validators.compose([apt_suitecheck, Validators.maxLength(50)])],
      // enrollmentSummaryStreetAddress: ['', [Validators.required]],
      // enrollmentSummaryStreetAddressLane2: ['', [Validators.required]],
      //enrollmentSummaryCity: ['', [Validators.required]],
      // enrollmentSummaryProvince: ['', [Validators.required]],
      // enrollmentSummaryPostalCode: ["", Validators.compose([Validators.required, postalcodeValidator])],
      // recaptchaReactive: ["",],
      // recaptchaReactive: ["", Validators.required],
      // creditCardFormValid: this.creditCardForm,
      //enrollment
      enrollmentSummaryCardHolderFirstName: [''], //['', Validators.compose([Validators.required, Validators.pattern("^(?!\\s)[A-Za-z\\s]+$")])],
      enrollmentSummaryCardHolderLastName: [''], //['', Validators.compose([Validators.required, Validators.pattern("^(?!\\s)[A-Za-z\\s]+$")])],
      enrollmentSummaryCardNumnber: [''],// ["", Validators.compose([Validators.required, creditcardvalidation]),],
      enrollmentSummaryExpirymonth: [''],// ['', [Validators.required]],
      enrollmentSummaryExpiryyear: [''],// ['', [Validators.required]],
      // enrollmentSummaryCVV: ['', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(4)])],
      enrollmentSummaryCVV: ['']


    })
  }
  bankPayForm: FormGroup = new FormGroup({
    enrollmentSummaryBankNumber: new FormControl(''),
    enrollmentSummaryTransitNumber: new FormControl(''),
    enrollmentSummaryAccontNumber: new FormControl(''),
    enrollmentBankTextdescription: new FormControl(''),
    reviewAndSignThePadAgreementBtn: new FormControl(''),
    enrollmentSummaryvoidCheckUpload: new FormControl(''),
  })

  bankPayFormValidator() {
    this.bankPayForm = this.bankPayFormBuilder.group({
      enrollmentSummaryBankNumber: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]],
      enrollmentSummaryTransitNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      enrollmentSummaryAccontNumber: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(12)]],
      enrollmentBankTextdescription: ['', [Validators.required]],
      enrollmentSummaryvoidCheckUpload: ['', [Validators.required]],
      // reviewAndSignThePadAgreementBtn:['',[Validators.required]],
      reviewAndSignThePadAgreementBtn: ['',],
    })
  }

  childFormGroup: FormGroup = new FormGroup({
    childInfoFirstName: new FormControl(''),
    childInfoLastName: new FormControl(''),
    childInfoGender: new FormControl(''),
    childInfoDOB: new FormControl(''),
    childdisablility: new FormControl(''),
    childInfoCarrierName: new FormControl(''),
    childPostGraduate: new FormControl(''),
    childInfoGraduationday: new FormControl(''),
    DependentchildInsurence: new FormControl(''),
  });

  childInfoValidators() {
    this.childFormGroup = this.childInfoFormBuilder.group({
      childInfoFirstName: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      childInfoLastName: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      childInfoGender: ["", [Validators.required]],
      childInfoDOB: ['', [Validators.required]],
      childdisablility: [''],
      childInfoCarrierName: [''],
      childPostGraduate: [''],
      childInfoGraduationday: [''],
      DependentchildInsurence: ['', Validators.required]
    })
  }



  initChildDetails() {
    return this.childFormGroup = this.childInfoFormBuilder.group({
      childInfoFirstName: [''],
      childInfoLastName: [''],
      childInfoGender: [""],
      childInfoDOB: [''],
      childdisablility: [''],
      childInfoCarrierName: [''],
      childPostGraduate: [''],
      childInfoGraduationday: [''],
      DependentchildInsurence: ['']
    });
  }



  alphaNumarics(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (event.currentTarget.value.length == 0) {//for first latter not allow space
      if ((charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 192 && charCode <= 255)
        || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 192 && charCode <= 255) || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95 ||
        charCode === 32
      )
        return true;
      else return false;
    }

  }

  alphabatesOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if ((charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
    else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) || ((charCode >= 192 && charCode <= 255)) ||
        charCode === 32 || charCode == 46 || charCode == 45 || charCode == 39 || charCode == 95)
        return true;
      else return false;
    }
  }
  alphanumericOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length === 0) {
      if (
        (charCode >= 48 && charCode <= 57) || // Numbers
        (charCode >= 65 && charCode <= 90) || // Uppercase letters
        (charCode >= 97 && charCode <= 122) || // Lowercase letters
        ((charCode >= 192 && charCode <= 255)) ||
        charCode === 46 || charCode === 45 || charCode === 39 || charCode === 95
      )
        return true;
      else return false;
    } else {
      if (
        (charCode >= 48 && charCode <= 57) || // Numbers
        (charCode >= 65 && charCode <= 90) || // Uppercase letters
        (charCode >= 97 && charCode <= 122) || // Lowercase letters
        ((charCode >= 192 && charCode <= 255)) ||
        charCode === 32 || charCode === 46 || charCode === 45 || charCode === 39 || charCode === 95
      )
        return true;
      else return false;
    }
  }



  numberOnly(event: any): boolean {
    //we have numeric 48 to 57 it return true when enter number

    const charCode = event.which ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      //if(charCode>48&&charCode<57)
      return false;
    } else return true;
  }


  // phoneFormat(event: any) {
  //   const inputValue = this.userForm.get("phonenumber")?.value;
  //   this.userForm.get("phonenumber")?.setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });


  // }

  phoneFormat(event: any) {
    const inputValue = this.userForm.get("phonenumber").value;

    this.userForm
      .get("phonenumber")
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  termsandconditionsLoaded(event: any) {
    this.logger.log("termsandconditionsLoaded here")
    this.pdfvisibletermsandconditions = false;
  }

  closeFormPopup(id: any, form: FormGroup) {
    this.closePopup(id);
    // this.closePopupModel(id)
    form.reset();
  }
  changeShowGreenShieldProv(event: any) {
    if (event.target.value == 'true') {
      this.showGreenShiled = true;
      this.greenShiledForm.get('greenShiledNumber').setValidators([Validators.required]);
    } else {
      this.showGreenShiled = false;
      this.greenShiledForm.get('greenShiledNumber').clearValidators();
    }
    this.greenShiledForm.get('greenShiledNumber').updateValueAndValidity();
  }
  changeinvitationemail(event: any) {
    if (event.target.value == "true") {
      this.showinvitationmail = false;
      this.InvitationForm.get('invitationEmail').clearValidators();
      this.InvitationForm.get('invitationEmail').updateValueAndValidity();
      this.InvitationForm.get('invitationEmail')?.setValue('')


    } else if (event.target.value == "false") {
      this.showinvitationmail = false;
      this.InvitationForm.get('invitationEmail').clearValidators();
      this.InvitationForm.get('invitationEmail').updateValueAndValidity();
      this.InvitationForm.get('invitationEmail')?.setValue('')


    } else {
      this.showinvitationmail = true;
      this.InvitationForm.get('invitationEmail').setValidators([Validators.required, Validators.pattern(this.commonPatternsService.emailPattern)]);
      this.InvitationForm.get('invitationEmail').updateValueAndValidity();
    }
  }

  saveGsPlans(id: any) {
    this.greenShiledForm.markAllAsTouched();
    if (this.greenShiledForm.valid) {
      this.gsRegistration = this.greenShiledForm.get('showGreenShieldProv').value == 'false' ? true : false;
      this.gsPlans = true;
      this.gsMembershipId = this.greenShiledForm.get('greenShiledNumber').value || "";
      this.eqRegistration = false;
      this.eqPlans = false
      this.eqCertificateId = "";

      // this.kixRegistration = false;
      // this.kixPlans = false
      // this.kixCertificateId = "";

      this.savedGs = true
      this.cwPlans && !this.savedCw ? this.selectedTab = 'tab2' : this.selectedTab = 'tab3';
      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }

  changeShowEquitableProv(event: any) {
    if (event.target.value == 'true') {
      this.showEquitable = true;
      this.EquitableForm.get('EquitableNumber').setValidators([Validators.required]);
      this.EquitableForm.get('EquitableNumber')?.setValue('')
    } else {
      this.showEquitable = false;
      this.EquitableForm.get('EquitableNumber').clearValidators();
    }
    this.EquitableForm.get('EquitableNumber').updateValueAndValidity();
  }

  saveeqPlans(id: any) {
    this.EquitableForm.markAllAsTouched();
    if (this.EquitableForm.valid) {

      this.eqRegistration = this.EquitableForm.get('EquitableFormProv').value == 'false' ? true : false;
      this.eqPlans = true
      this.eqCertificateId = this.EquitableForm.get('EquitableNumber').value || "";
      this.gsRegistration = false;
      this.gsPlans = false;
      this.gsMembershipId = '';

      this.savedEq = true
      this.cwPlans && !this.savedCw ? this.selectedTab = 'tab2' : this.selectedTab = 'tab3';
      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }
  changeKixCareProv(event: any) {
    // if (event.target.value == 'true') {
    //   this.showKixcarePlans = true;
    //   this.KixCareForm.get('KixCareNumber').setValidators([Validators.required]);
    //   this.KixCareForm.get('KixCareNumber')?.setValue('')
    // } else {
    //   this.showKixcarePlans = false;
    //   this.KixCareForm.get('KixCareNumber').clearValidators();
    // }
    // this.KixCareForm.get('KixCareNumber').updateValueAndValidity();
  }
  changeFlexPlanProv(event: any) {
    if (event.target.value == 'true') {
      this.showFlexPlans = true;
      this.FlexForm.get('FlexMembershipId').setValidators([Validators.required]);
      this.FlexForm.get('FlexMembershipId')?.setValue('')
    } else {
      this.showFlexPlans = false;
      this.FlexForm.get('FlexMembershipId').clearValidators();
    }
    this.FlexForm.get('FlexMembershipId').updateValueAndValidity();
  }

  saveKixCarePlans(id: any) {
    this.KixCareForm.markAllAsTouched();
    if (this.KixCareForm.valid) {

      this.kixRegistration = this.KixCareForm.get('KixCareFormProv').value == 'false' ? true : false;
      this.kixPlans = true
      // this.kixCertificateId = this.KixCareForm.get('KixCareNumber').value || "";
      // this.gsRegistration = false;
      // this.gsPlans = false;
      // this.eqRegistration = false;
      // this.eqPlans = false;
      // this.gsMembershipId = '';

      // this.gsPlans = Response.data.gsPlans;
      // this.eqPlans = Response.data.eqPlans;
      // this.cwPlans = Response.data?.phrPlan;
      // this.kixPlans = Response.data?.kixcarePlan;

      if (this.gsPlans) {

      }
      this.savedKIX = true;


      (this.eqPlans && this.savedEq) || (this.gsPlans && this.savedGs) || (this.waddellPlans && this.savedWADDELL) || (this.kixPlans && this.savedKIX) ? this.selectedTab = 'tab3' : this.selectedTab = 'tab2';
      (!this.eqPlans && !this.gsPlans) ? this.selectedTab = 'tab3' : '';


      // if(this.kixPlans && this.savedKIX ){
      // this.selectedTab = 'tab3'
      // }else{
      // this.selectedTab = 'tab2';
      // }
      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }
  saveFlexPlans(id: any) {
    this.FlexForm.markAllAsTouched();
    if (this.FlexForm.valid) {

      this.flexRegistration = this.FlexForm.get('FlexFormProv').value == 'false' ? true : false;
      this.flexPlans = true
      this.flexCertificateId = this.FlexForm.get('FlexMembershipId').value || "";
      // this.gsRegistration = false;
      // this.gsPlans = false;
      // this.eqRegistration = false;
      // this.eqPlans = false;
      // this.gsMembershipId = '';

      // this.gsPlans = Response.data.gsPlans;
      // this.eqPlans = Response.data.eqPlans;
      // this.cwPlans = Response.data?.phrPlan;
      // this.kixPlans = Response.data?.kixcarePlan;

      if (this.gsPlans) {

      }
      this.savedFLEX = true;


      (this.eqPlans && this.savedEq) || (this.gsPlans && this.savedGs) || (this.waddellPlans && this.savedWADDELL) || (this.kixPlans && this.savedKIX) || (this.flexPlans && this.savedFLEX) ? this.selectedTab = 'tab3' : this.selectedTab = 'tab2';
      (!this.eqPlans && !this.gsPlans) ? this.selectedTab = 'tab3' : '';


      // if(this.kixPlans && this.savedKIX ){
      // this.selectedTab = 'tab3'
      // }else{
      // this.selectedTab = 'tab2';
      // }
      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }

  saveWaddellPlans(id: any) {
    this.waddellPlanForm.markAllAsTouched();
    if (this.waddellPlanForm.valid) {

      this.waddellRegistration = this.waddellPlanForm.get('waddellFormProv').value == 'false' ? true : false;
      this.waddellPlans = true
      // this.kixCertificateId = this.KixCareForm.get('KixCareNumber').value || "";
      // this.gsRegistration = false;
      // this.gsPlans = false;
      // this.eqRegistration = false;
      // this.eqPlans = false;
      // this.gsMembershipId = '';

      // this.gsPlans = Response.data.gsPlans;
      // this.eqPlans = Response.data.eqPlans;
      // this.cwPlans = Response.data?.phrPlan;
      // this.kixPlans = Response.data?.kixcarePlan;

      if (this.gsPlans) {

      }
      this.savedWADDELL = false;

      (this.kixPlans && this.savedKIX) || (this.eqPlans && this.savedEq) || (this.gsPlans && this.savedGs) || (this.waddellPlans && this.savedWADDELL) ? this.selectedTab = 'tab3' : this.selectedTab = 'tab2';
      (!this.eqPlans && !this.gsPlans) ? this.selectedTab = 'tab3' : '';
      // if(this.cwPlans && !this.savedCw && this.gsPlans && !this.savedGs && this.eqPlans && !this.savedEq){
      // this.selectedTab = 'tab3'
      // }else{
      // this.selectedTab = 'tab2';
      // }
      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }

  changeWaddellProv(event: any) {

  }
  changeShowCowanProv(event: any) {
    if (event.target.value == 'true') {
      this.showCowan = true;
      this.cowanForm.get('cowanNumber').setValidators([Validators.required]);
      this.cowanForm.get('cowanNumber')?.setValue('')
    } else {
      this.showCowan = false;
      this.cowanForm.get('cowanNumber').clearValidators();
    }
    this.cowanForm.get('cowanNumber').updateValueAndValidity();
  }

  savecwPlans(id: any) {
    this.cowanForm.markAllAsTouched();
    if (this.cowanForm.valid) {

      this.cwRegistraion = this.cowanForm.get('cowanFormProv').value == 'false' ? true : false;;
      this.cwPlans = true
      this.cwCertificateId = this.cowanForm.get('cowanNumber').value || "";
      this.savedCw = true;
      (this.eqPlans && this.savedEq) || (this.gsPlans && this.savedGs) || (this.kixPlans && this.savedKIX) ? this.selectedTab = 'tab3' : this.selectedTab = 'tab2';
      (!this.eqPlans && !this.gsPlans) ? this.selectedTab = 'tab3' : '';

      console.log(this.selectedTab)
      this.closePopup(id);
    }
    else {
      return false;
    }

  }

  enrollmentForActivePlans() {

    let inputData: any = sessionStorage.getItem('Data');
    let validationInputData = typeof inputData != 'object' ? JSON.parse(inputData) : inputData;
    inputData = JSON.parse(inputData);

    validationInputData['plans'] = this.customerPlansActiveData;
    validationInputData['fusebillCountryId'] = 124
    let companypaidplansCheck = validationInputData['plans'].filter(plan => plan.PaidByCompany === 1);
    if (companypaidplansCheck) {
      validationInputData["failed"] = []
    } else {
      validationInputData["failed"] = [this.fusebill_paymentMethod + "Failed"]
    }
    // validationInputData["failed"] = [this.fusebill_paymentMethod + "Failed"]

    validationInputData['fusebill_paymentMethod'] = this.fusebill_paymentMethod;
    let enrollmentSummaryProvinceval: string =
      this.enrollmentFormControl['enrollmentSummaryProvince'].value;
    //this.paymentMethodSelectCC it means credit card
    if (this.paymentMethodSelectCC) {
      // validationInputData['marital_status'] = this.marital_status;
      validationInputData.signature =
        sessionStorage.getItem('signatureCC') ?? '';
    } else {
    }

    let provincelist = sessionStorage.getItem('provincelist') || '';
    if (provincelist.includes(inputData.province_id)) {
    } else {
      if (this.configresults.assign_default_form == true) {
        inputData.formId = this.configresults.default_form.id;
        inputData.brokershipTransfered = true;
        inputData.originalFormId = this.configresults.form.id;
      } else {
      }
    }

    var fusebillCustomerAddressId = sessionStorage.getItem(
      'fusebillCustomerAddressId'
    );
    if (fusebillCustomerAddressId && fusebillCustomerAddressId.length > 0) {
      inputData['fusebillCustomerAddressId'] =
        sessionStorage.getItem('fusebillCustomerAddressId') || null;
    }
    var fusebillCustomerId = sessionStorage.getItem('fusebillCustomerId');
    if (fusebillCustomerId && fusebillCustomerId.length > 0) {
      inputData.fusebillCustomerId =
        sessionStorage.getItem('fusebillCustomerId') || null;
    }
    var fusebillCustomerBillingAddressId = sessionStorage.getItem(
      'fusebillCustomerBillingAddressId'
    );
    if (
      fusebillCustomerBillingAddressId &&
      fusebillCustomerBillingAddressId.length > 0
    ) {
      inputData.fusebillCustomerBillingAddressId =
        sessionStorage.getItem('fusebillCustomerBillingAddressId') || null;
    }
    var customerId = sessionStorage.getItem('customerId');

    if (customerId && customerId.length > 0) {
      inputData.customerId = sessionStorage.getItem('customerId') || null;
    }

    let statesData: any = this.configprovinceres.filter(
      (item: { shortName: any }) => {
        return (
          item.shortName ===
          (enrollmentSummaryProvinceval == '' || enrollmentSummaryProvinceval == null
            ? validationInputData.province
            : this.enrollmentFormControl['enrollmentSummaryProvince'].value)
        );
      }
    );

    if (
      typeof validationInputData === 'object' &&
      validationInputData !== null
    ) {
      validationInputData['marital_status'] =
        this.marital_status !== '' ? this.marital_status : '';
      validationInputData['billing_sameas_homeAddress'] = this
        .homeaddressEnrollmentVal
        ? true
        : false; //this.enrollmentFormControl['homeAddressSameasBillingAddress'].value == 'true' ? true : false;
      if (!validationInputData['billing_sameas_homeAddress']) {
        validationInputData['billing_address'] = {
          line1:
            this.enrollmentFormControl['enrollmentSummaryStreetAddress']
              .value == undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryStreetAddress']
                .value,
          line2:
            this.enrollmentFormControl['enrollmentSummaryStreetAddressLane2']
              .value == undefined
              ? ''
              : this.enrollmentFormControl[
                'enrollmentSummaryStreetAddressLane2'
              ].value,
          city:
            this.enrollmentFormControl['enrollmentSummaryCity'].value ==
              undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryCity'].value,
          state: statesData.length != 0 ? statesData[0].name : '',
          state_id: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          stateId: statesData.length != 0 ? parseInt(statesData[0].id) : '',
          country: 'Canada',
          country_id: 1,
          countryId: 1,
          fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
          fusebillCountryId: 124,
          apt:
            this.enrollmentFormControl['enrollmentSummaryApartSuite'].value ==
              undefined
              ? ''
              : this.enrollmentFormControl['enrollmentSummaryApartSuite'].value,
        };
      } else {
        validationInputData['billing_address'] = {
          // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
          // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
          line1: inputData.street_address_line1 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddress"].value || "",
          line2: inputData.street_address_line2 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddressLane2"].value || "",
          city: inputData.city || '', //this.enrollmentFormControl["enrollmentSummaryCity"].value || "",
          state: inputData.province || '', //this.enrollmentFormControl["enrollmentSummaryProvince"].value || "",
          state_id: parseInt(statesData[0].id) || "",
          stateId: parseInt(statesData[0].id) || "",
          country: "Canada",
          country_id: 1,
          countryId: 1,
          fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
          fusebillCountryId: 124,
          postal_zip: inputData.postal_code || '',//this.enrollmentFormControl["enrollmentSummaryPostalCode"].value || "",
          apt: inputData.apt || '',//this.enrollmentFormControl["enrollmentSummaryApartSuite"].value || "",
        };
      }
    } else {
      console.error('Data in sessionStorage is not a valid JSON object.');
    }
    this.logger.log('validationInputData: ' + JSON.stringify(validationInputData));
    let formValid = true;

    if (this.homeaddressEnrollmentVal) {
      this.enrollmentForm
        .get('homeAddressSameasBillingAddress')
        ?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddress')
        ?.clearValidators();
      this.enrollmentForm
        .get('enrollmentSummaryStreetAddressLane2')
        ?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();
      for (let control of Object.keys(this.enrollmentForm.controls)) {
        this.enrollmentForm.get(control).clearValidators();
        this.enrollmentForm.get(control).updateValueAndValidity();
      }
    }

    if (this.enrollmentForm.valid) {
      // var endPoint = '/api/ap/customer/registration';
      var endPoint = '/api/ap/v3/member/registration';

      var accessToken = sessionStorage.getItem('accessToken');

      this.planssummarymain =
        JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

      var total = 0;
      var amount = 0;
      var tax = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].total);
        amount += parseFloat(this.planssummarymain[i].amount);

        tax += parseFloat(this.planssummarymain[i].tax);

      }


      let array = []

      // alert(this.InvitationForm.get('invitationEmail')?.value)


      if (this.InvitationForm.get('invitationEmail')?.value.length > 0) {
        array.push(this.InvitationForm.get('invitationEmail')?.value)
      }


      validationInputData["planAllAmount"] = amount
      validationInputData["taxAllAmount"] = tax
      validationInputData["totalAllAmount"] = total
      validationInputData["totalAmount"] = total;

      validationInputData["gsRegistration"] = this.gsRegistration;
      validationInputData["gsPlans"] = this.gsPlans;
      validationInputData["gsMembershipId"] = this.gsMembershipId;
      validationInputData["eqRegistration"] = this.eqRegistration;
      validationInputData["eqPlans"] = this.eqPlans;
      validationInputData["eqCertificateId"] = this.eqCertificateId;

      validationInputData["kixRegistration"] = this.kixRegistration;
      validationInputData["kixPlans"] = this.kixPlans;

      validationInputData["flexgsRegistration"] = this.flexRegistration;
      validationInputData["flexgsPlans"] = this.flexPlans;
      validationInputData["flexgsMembershipId"] = this.flexCertificateId;


      validationInputData["waddellPlan"] = this.waddellPlans;
      // validationInputData["kixCertificateId"] = this.kixCertificateId;


      validationInputData["phrRegistration"] = this.cwRegistraion;
      validationInputData["phrPlan"] = this.cwPlans;
      validationInputData["phrCertificateId"] = this.cwCertificateId;
      validationInputData["welcomeMail"] = this.InvitationForm.get('invitationStatus')?.value == "true" ? true : false
      validationInputData["welcomeMailSender"] = array || []

      this.logger.log('validationInputData', JSON.stringify(validationInputData));
      this.http
        .post(environment.apiUrl + endPoint, validationInputData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {

              Swal.fire({
                title: this.lang?.Info,
                // html: error.error.message ? error.error.message : error.error.error,
                html: response.message,
                // icon: "warning",
                width: "30%",
                showCancelButton: true,
                confirmButtonText: this.lang?.View_Member,
                cancelButtonText: this.lang?.Add_Another_Member
              }).then((result) => {
                if (result.value) {
                  const id = response.data.customer.id
                  this.logger.log("result.value: " + result.value, id);
                  this.router.navigate([`/manageMembers/employee/${id}/details`]);
                } else {
                  window.location.reload();
                }
              })
            } else {
              Swal.fire({ title: this.lang?.Info, text: response.message || response.data.error || response.error || response.error.error })
            }
          },
          (error) => {
            Swal.fire({
              title: this.lang?.Error,
              // html: error.error.message ? error.error.message : error.error.error,
              html: `<div class="custom-content">${error.error.message ? error.error.message : error.error.error
                }</div>`,
              // icon: "warning",
              width: '30%',
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.value) {
                this.logger.log('result.value: ' + result.value);
              }
            });
          }
        );
    } else {
    }

  }

  public workingProvincelist(event: any) {
    // alert(event.target.value)

    if (event.target.value == 'QC') {
      // jQuery("#provinceinfo-modal").modal("show");
    }

    this.working_provinces.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.working_provincelistid = element.id;
      }
    });



  }
  sendwelcomeinvitation(form: any) {

    this.InvitationForm.markAllAsTouched();
    if (this.InvitationForm.valid) {
      $('#confirmwelcomeemail').hide();
      let inputData: any = sessionStorage.getItem("Data");
      inputData = JSON.parse(inputData);
      let employeePaidPlansExisting = false;

      let validationInputData = typeof (inputData) != 'object' ? JSON.parse(inputData) : inputData;
      console.log(this.paidEmployeedTotalDub, validationInputData)

      let enrollmentSummaryProvinceval: string = this.enrollmentFormControl['enrollmentSummaryProvince'].value;
      //this.paymentMethodSelectCC it means credit card
      if (this.paymentMethodSelectCC) {
        // validationInputData['marital_status'] = this.marital_status;
        validationInputData.signature = sessionStorage.getItem("signatureCC") ?? "";
      } else {

      }

      let provincelist = sessionStorage.getItem("provincelist") || "";
      if (provincelist.includes(inputData.province_id)) {
      } else {
        if (this.configresults.assign_default_form == true) {
          inputData.formId = this.configresults.default_form.id;
          inputData.brokershipTransfered = true;
          inputData.originalFormId = this.configresults.form.id;
        } else {
        }
      }

      var fusebillCustomerAddressId = sessionStorage.getItem("fusebillCustomerAddressId");
      if (
        fusebillCustomerAddressId &&
        fusebillCustomerAddressId.length > 0
      ) {
        inputData["fusebillCustomerAddressId"] =
          sessionStorage.getItem("fusebillCustomerAddressId") || null;
      }
      var fusebillCustomerId = sessionStorage.getItem("fusebillCustomerId");
      if (
        fusebillCustomerId &&
        fusebillCustomerId.length > 0
      ) {
        inputData.fusebillCustomerId =
          sessionStorage.getItem("fusebillCustomerId") || null;
      }
      var fusebillCustomerBillingAddressId = sessionStorage.getItem("fusebillCustomerBillingAddressId");
      if (
        fusebillCustomerBillingAddressId &&
        fusebillCustomerBillingAddressId.length > 0
      ) {
        inputData.fusebillCustomerBillingAddressId =
          sessionStorage.getItem("fusebillCustomerBillingAddressId") || null;
      }
      var customerId = sessionStorage.getItem("customerId");

      if (customerId && customerId.length > 0) {
        inputData.customerId = parseInt(sessionStorage.getItem("customerId")) || null;
      }

      let statesData: any = this.configprovinceres.filter((item: { shortName: any; }) => {
        return item.shortName === (enrollmentSummaryProvinceval == '' || enrollmentSummaryProvinceval == null ? validationInputData.province : this.enrollmentFormControl['enrollmentSummaryProvince'].value);
      });

      let plansMain = ''

      // if(this.isCorporate==true){
      plansMain = sessionStorage.getItem("allSelectedPlans") ? JSON.parse(sessionStorage.getItem("allSelectedPlans") || '') : []

      // }else{
      // plansMain = sessionStorage.getItem("plansummarymain")?JSON.parse(sessionStorage.getItem("plansummarymain")||''):[]

      // }
      // let plansMain = sessionStorage.getItem("plansummarymain")?JSON.parse(sessionStorage.getItem("plansummarymain")||''):[]
      let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []

      validationInputData['plans'] = plansMain.concat(plansLife)
      validationInputData['fusebillCountryId'] = 124
      validationInputData['working_province_id'] = this.working_provincelistid
      validationInputData['corporateStateId'] = parseInt(sessionStorage.getItem("companyStateId"))
      validationInputData['employeeWorkingStateId'] = parseInt(sessionStorage.getItem("corporateStateId"))
      // validationInputData["failed"] = [this.fusebill_paymentMethod + "Failed"]
      let companypaidplansCheck = validationInputData['plans'].filter(plan => plan.PaidByCompany === 1);
      if (companypaidplansCheck) {
        validationInputData["failed"] = []
      } else {
        validationInputData["failed"] = [this.fusebill_paymentMethod + "Failed"]
      }

      // validationInputData['fusebillStateId']=statesData
      // validationInputData['fusebillCountryId']=states

      if (typeof validationInputData === 'object' && validationInputData !== null) {
        validationInputData['marital_status'] = this.marital_status !== '' ? this.marital_status : '';
        validationInputData['billing_sameas_homeAddress'] = this.paidEmployeedTotalDub > 0 ? this.homeaddressEnrollmentVal : true; //this.enrollmentFormControl['homeAddressSameasBillingAddress'].value == 'true' ? true : false;
        if (!validationInputData['billing_sameas_homeAddress']) {
          validationInputData['billing_address'] = {
            "line1": this.enrollmentFormControl['enrollmentSummaryStreetAddress'].value,
            "line2": this.enrollmentFormControl['enrollmentSummaryStreetAddressLane2'].value,
            "city": this.enrollmentFormControl['enrollmentSummaryCity'].value,
            "state": statesData.length != 0 ? statesData[0].name : '',
            "country": "Canada",
            "state_id": statesData.length != 0 ? parseInt(statesData[0].id) : '',
            "stateId": statesData.length != 0 ? parseInt(statesData[0].id) : '',
            "country_id": 1,
            "countryId": 1,
            fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
            fusebillCountryId: 124,

            "apt": this.enrollmentFormControl['enrollmentSummaryApartSuite'].value,
          }
        }
        else {
          validationInputData['billing_address'] = {
            // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
            // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
            line1: inputData.street_address_line1 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddress"].value || "",
            line2: inputData.street_address_line2 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddressLane2"].value || "",
            city: inputData.city || '', //this.enrollmentFormControl["enrollmentSummaryCity"].value || "",
            state: inputData.province || '', //this.enrollmentFormControl["enrollmentSummaryProvince"].value || "",
            state_id: parseInt(statesData[0].id) || "",
            stateId: parseInt(statesData[0].id) || "",
            country: "Canada",
            country_id: 1,
            countryId: 1,
            fusebillStateId: statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
            fusebillCountryId: 124,
            postal_zip: inputData.postal_code || '',//this.enrollmentFormControl["enrollmentSummaryPostalCode"].value || "",
            apt: inputData.apt || '',//this.enrollmentFormControl["enrollmentSummaryApartSuite"].value || "",
          };
        }


      } else {
        console.error("Data in sessionStorage is not a valid JSON object.");
      }
      this.logger.log("validationInputData: " + JSON.stringify(validationInputData));
      let formValid = true;

      if (!(this.paidEmployeedTotalDub > 0 && !this.homeaddressEnrollmentVal)) {
        this.enrollmentForm.get('homeAddressSameasBillingAddress')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryStreetAddressLane2')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();
        for (let control of Object.keys(this.enrollmentForm.controls)) {
          this.enrollmentForm.get(control).clearValidators();
          this.enrollmentForm.get(control).updateValueAndValidity();
        }
      }
      if (this.homeaddressEnrollmentVal) {
        this.enrollmentForm.get('homeAddressSameasBillingAddress')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryStreetAddressLane2')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();
        this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();
        for (let control of Object.keys(this.enrollmentForm.controls)) {
          this.enrollmentForm.get(control).clearValidators();
          this.enrollmentForm.get(control).updateValueAndValidity();
        }
      }


      if (this.enrollmentForm.valid) {
        // if (formValid) {
        //  let personalinfo: string = `${environment.app.grp}api/students/registration`;
        var endPoint = '/api/ap/v3/corporate/customer/registration';


        var accessToken = sessionStorage.getItem('accessToken');
        this.planssummarymain =
          JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

        var total = 0;
        var amount = 0;
        var tax = 0;
        for (let i = 0; i < this.planssummarymain.length; i++) {
          total += parseFloat(this.planssummarymain[i].total);
          amount += parseFloat(this.planssummarymain[i].amount);

          tax += parseFloat(this.planssummarymain[i].tax);

        }


        let plans = []
        this.plansummary = JSON.parse(sessionStorage.getItem("allSelectedPlans"))
        // this.optplansummary = JSON.parse(sessionStorage.getItem("allSelectedOptPlans"))

        this.plansummary.forEach(element => {



          element.totalPrice = this._decimalPipe.transform(element.totalPrice, "1.2-2").replace(/,/g, "")
          element.total = this._decimalPipe.transform(element.totalPrice, "1.2-2").replace(/,/g, "")
          element.tax = this._decimalPipe.transform(element.tax, "1.2-2").replace(/,/g, "")
          element.amount = this._decimalPipe.transform(element.amount, "1.2-2").replace(/,/g, "")
          element.planLevelName = element.groupName
          plans.push(element)
        });

        let array = []

        // alert(this.InvitationForm.get('invitationEmail')?.value)


        if (this.InvitationForm.get('invitationEmail')?.value.length > 0) {
          array.push(this.InvitationForm.get('invitationEmail')?.value)
        }





        validationInputData["corporateStateId"] = this.corporateStateId;
        validationInputData['plans'] = plans;
        //************** */
        validationInputData['equitableRegistrationStatus'] = "";
        validationInputData['equitableCertificateId'] = '';
        validationInputData['greenshieldMemberId'] = '';
        validationInputData['greenshieldRegistrationStatus'] = '';
        validationInputData['isCorporateAccount'] = true;
        validationInputData['provincialHealthcardName'] = '';
        validationInputData['terminationReason'] = '';
        validationInputData['paymentMethod'] = this.fusebill_paymentMethod;
        validationInputData['paymentMethodId'] = '';
        validationInputData['paymentMethodName'] = 'true';
        validationInputData["gsRegistration"] = this.gsRegistration;
        validationInputData["gsPlans"] = this.gsPlans;
        validationInputData["gsMembershipId"] = this.gsMembershipId;
        validationInputData["eqRegistration"] = this.eqRegistration;
        validationInputData["eqPlans"] = this.eqPlans;
        validationInputData["eqCertificateId"] = this.eqCertificateId;
        validationInputData["kixRegistration"] = this.kixRegistration;
        validationInputData["kixPlans"] = this.kixPlans;
        validationInputData["flexgsRegistration"] = this.flexRegistration;
        validationInputData["flexgsPlans"] = this.flexPlans;
        validationInputData["flexgsMembershipId"] = this.flexCertificateId;
        validationInputData["waddellPlan"] = this.waddellPlans;
        // validationInputData["kixCertificateId"] = this.kixCertificateId;
        validationInputData["phrRegistration"] = this.cwRegistraion;
        validationInputData["phrPlan"] = this.cwPlans;
        validationInputData["phrCertificateId"] = this.cwCertificateId;
        validationInputData["welcomeMail"] = this.InvitationForm.get('invitationStatus')?.value == "true" ? true : false
        validationInputData["welcomeMailSender"] = array || []

        validationInputData['fusebill_paymentMethod'] = this.fusebill_paymentMethod;

        let employeePaidPlansExisting = false;

        for (let p of plans) {
          if (p.categorization.coveredByCompany || p.categorization.paidByEmployee) {
            employeePaidPlansExisting = true
            break;
          }

        }

        if (!employeePaidPlansExisting) {
          validationInputData['paymentMethod'] = 'NONE';
          validationInputData['fusebill_paymentMethod'] = 'NONE'
        }

        this.logger.log('validationInputData', validationInputData);


        //  this.studentService.login1(validationInputData)
        this.http.post(environment.apiUrl + endPoint, validationInputData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe(
          (response: any) => {
            if (response.status == "200") {
              // this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => { })
              // this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => { })
              // this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => { })
              this.store.dispatch(loadCorporateDataSuccess({ corporateData: [] }));

              // this.http.post(environment.apiUrl + '/api/ap/v2/global/set-adminMembers', { wait: true }).subscribe((newResponse) => {
              //   this.store.dispatch(loadMemberDataSuccess({ memberData: [] }));
              //   // this.store.dispatch(loadMemberData());
              // })
              this.http.post(environment.reportApiUrl + '/websocket/member/notification-to-others', {
                "message": "Members information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => { })
              Swal.fire({
                title: this.lang?.Info,
                // html: error.error.message ? error.error.message : error.error.error,
                html: "Employee Enrolled  Successfully",
                // icon: "warning",
                width: "30%",
                showCancelButton: true,
                confirmButtonText: this.lang?.View_Member,
                cancelButtonText: this.lang?.Add_Another_Member
              }).then((result) => {
                if (result.value) {
                  this.logger.log(result, response)
                  this.router.navigate([response.portalLink || `/manageMembers`]);
                  // this.router.navigate([`/manageMembers`]);
                  // this.router.navigate([`/manageMembers/employee/${response.id}/details`]);
                  this.logger.log("result.value: " + result.value);
                } else {
                  window.location.reload();
                }
              })
            }
            else {
              Swal.fire({ title: this.lang?.Info, text: response.message || response.error || response.data.error })

            }

          },
          (error) => {

            Swal.fire({
              title: this.lang?.Error,
              // html: error.error.message ? error.error.message : error.error.error,
              html: `<div class="custom-content">${error.error.message ? error.error.message : error.error.error}</div>`,
              // icon: "warning",
              width: "30%",
              showCancelButton: false,
              confirmButtonText: "Ok",

            }).then((result) => {
              if (result.value) {
                this.logger.log("result.value: " + result.value)
              }
            })

          });
      } else {


      }
    }
  }

  enrollmentFormSubmit(value1: any) {
    // Retrieve the data from sessionStorage and parse it into an object
    let inputData: any = sessionStorage.getItem("Data");
    inputData = JSON.parse(inputData);
    let validationInputData = typeof (inputData) != 'object' ? JSON.parse(inputData) : inputData;
    validationInputData['fusebill_paymentMethod'] = this.paidEmployeedTotalDub > 0 ? this.fusebill_paymentMethod : 'NONE';
    let enrollmentSummaryProvinceval: string = this.enrollmentFormControl['enrollmentSummaryProvince'].value;
    //this.paymentMethodSelectCC it means credit card
    if (this.paymentMethodSelectCC) {
      // validationInputData['marital_status'] = this.marital_status;
      validationInputData.signature = sessionStorage.getItem("signatureCC") ?? "";
    } else {

    }

    let provincelist = sessionStorage.getItem("provincelist") || "";
    if (provincelist.includes(inputData.province_id)) {
    } else {
      if (this.configresults.assign_default_form == true) {
        inputData.formId = this.configresults.default_form.id;
        inputData.brokershipTransfered = true;
        inputData.originalFormId = this.configresults.form.id;
      } else {
      }
    }

    var fusebillCustomerAddressId = sessionStorage.getItem("fusebillCustomerAddressId");
    if (
      fusebillCustomerAddressId &&
      fusebillCustomerAddressId.length > 0
    ) {
      inputData["fusebillCustomerAddressId"] =
        sessionStorage.getItem("fusebillCustomerAddressId") || null;
    }
    var fusebillCustomerId = sessionStorage.getItem("fusebillCustomerId");
    if (
      fusebillCustomerId &&
      fusebillCustomerId.length > 0
    ) {
      inputData.fusebillCustomerId =
        sessionStorage.getItem("fusebillCustomerId") || null;
    }
    var fusebillCustomerBillingAddressId = sessionStorage.getItem("fusebillCustomerBillingAddressId");
    if (
      fusebillCustomerBillingAddressId &&
      fusebillCustomerBillingAddressId.length > 0
    ) {
      inputData.fusebillCustomerBillingAddressId =
        sessionStorage.getItem("fusebillCustomerBillingAddressId") || null;
    }
    var customerId = sessionStorage.getItem("customerId");

    if (customerId && customerId.length > 0) {
      inputData.customerId = parseInt(sessionStorage.getItem("customerId")) || null;
    }

    let statesData: any = this.configprovinceres.filter((item: { shortName: any; }) => {
      return item.shortName === (enrollmentSummaryProvinceval == '' || enrollmentSummaryProvinceval == null ? validationInputData.province : this.enrollmentFormControl['enrollmentSummaryProvince'].value);
    });

    if (typeof validationInputData === 'object' && validationInputData !== null) {
      validationInputData['marital_status'] = this.marital_status !== '' ? this.marital_status : '';
      validationInputData['billing_sameas_homeAddress'] = this.paidEmployeedTotalDub > 0 ? this.homeaddressEnrollmentVal : true; //this.enrollmentFormControl['homeAddressSameasBillingAddress'].value == 'true' ? true : false;
      if (!validationInputData['billing_sameas_homeAddress']) {
        validationInputData['billing_address'] = {
          "line1": this.enrollmentFormControl['enrollmentSummaryStreetAddress'].value,
          "line2": this.enrollmentFormControl['enrollmentSummaryStreetAddressLane2'].value,
          "city": this.enrollmentFormControl['enrollmentSummaryCity'].value,
          "state": statesData.length != 0 ? statesData[0].name : '',
          "state_id": statesData.length != 0 ? parseInt(statesData[0].fusebillId) : '',
          "country": "Canada",
          "country_id": 124,
          "apt": this.enrollmentFormControl['enrollmentSummaryApartSuite'].value,
        }
      }
      else {
        validationInputData['billing_address'] = {
          // "customer_id": parseInt(sessionStorage.getItem("customerId")) || null,
          // "fusebill_customer_id": parseInt(sessionStorage.getItem("fusebillCustomerId")) || null,
          line1: inputData.street_address_line1 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddress"].value || "",
          line2: inputData.street_address_line2 || '', //this.enrollmentFormControl["enrollmentSummaryStreetAddressLane2"].value || "",
          city: inputData.city || '', //this.enrollmentFormControl["enrollmentSummaryCity"].value || "",
          state: inputData.province || '', //this.enrollmentFormControl["enrollmentSummaryProvince"].value || "",
          state_id: parseInt(statesData[0].fusebillId) || "",
          country: "Canada",
          country_id: 124,
          postal_zip: inputData.postal_code || '',//this.enrollmentFormControl["enrollmentSummaryPostalCode"].value || "",
          apt: inputData.apt || '',//this.enrollmentFormControl["enrollmentSummaryApartSuite"].value || "",
        };
      }


    } else {
      console.error("Data in sessionStorage is not a valid JSON object.");
    }
    this.logger.log("validationInputData: " + JSON.stringify(validationInputData));
    let formValid = true;

    if (!(this.paidEmployeedTotalDub > 0 && !this.homeaddressEnrollmentVal)) {
      this.enrollmentForm.get('homeAddressSameasBillingAddress')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryStreetAddressLane2')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();
      for (let control of Object.keys(this.enrollmentForm.controls)) {
        this.enrollmentForm.get(control).clearValidators();
        this.enrollmentForm.get(control).updateValueAndValidity();
      }
    }
    if (this.homeaddressEnrollmentVal) {
      this.enrollmentForm.get('homeAddressSameasBillingAddress')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryStreetAddressLane2')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();
      for (let control of Object.keys(this.enrollmentForm.controls)) {
        this.enrollmentForm.get(control).clearValidators();
        this.enrollmentForm.get(control).updateValueAndValidity();
      }
    }


    if (this.enrollmentForm.valid) {
      $('#confirmwelcomeemail').show();
      return false;
      // if (formValid) {
      //  let personalinfo: string = `${environment.app.grp}api/students/registration`;
      var endPoint = '/api/ap/corporate/customer/registration/backdate';

      var accessToken = sessionStorage.getItem('accessToken');
      this.planssummarymain =
        JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

      var total = 0;
      var amount = 0;
      var tax = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].total);
        amount += parseFloat(this.planssummarymain[i].amount);

        tax += parseFloat(this.planssummarymain[i].tax);

      }


      let plans = []
      this.plansummary = JSON.parse(sessionStorage.getItem("allSelectedPlans"))
      // this.optplansummary = JSON.parse(sessionStorage.getItem("allSelectedOptPlans"))

      this.plansummary.forEach(element => {



        element.totalPrice = this._decimalPipe.transform(element.totalPrice, "1.2-2").replace(/,/g, "")
        element.total = this._decimalPipe.transform(element.totalPrice, "1.2-2").replace(/,/g, "")
        element.tax = this._decimalPipe.transform(element.tax, "1.2-2").replace(/,/g, "")
        element.amount = this._decimalPipe.transform(element.amount, "1.2-2").replace(/,/g, "")
        element.planLevelName = element.groupName
        plans.push(element)
      });

      let array = []

      // alert(this.InvitationForm.get('invitationEmail')?.value)


      if (this.InvitationForm.get('invitationEmail')?.value.length > 0) {
        array.push(this.InvitationForm.get('invitationEmail')?.value)
      }







      validationInputData["corporateStateId"] = parseInt(sessionStorage.getItem("corporateStateId"))
      validationInputData['plans'] = plans;
      //************** */
      validationInputData['equitableRegistrationStatus'] = "";
      validationInputData['equitableCertificateId'] = '';
      validationInputData['greenshieldMemberId'] = '';
      validationInputData['greenshieldRegistrationStatus'] = '';
      validationInputData['isCorporateAccount'] = true;
      validationInputData['provincialHealthcardName'] = '';

      validationInputData['terminationReason'] = '';
      validationInputData['paymentMethod'] = '';
      validationInputData['paymentMethodId'] = '';
      validationInputData['paymentMethodName'] = 'true';
      validationInputData["gsRegistration"] = this.gsRegistration;
      validationInputData["gsPlans"] = this.gsPlans;
      validationInputData["gsMembershipId"] = this.gsMembershipId;
      validationInputData["eqRegistration"] = this.eqRegistration;
      validationInputData["eqPlans"] = this.eqPlans;
      validationInputData["eqCertificateId"] = this.eqCertificateId;
      validationInputData["kixRegistration"] = this.kixRegistration;
      validationInputData["kixPlans"] = this.kixPlans;
      validationInputData["kixCertificateId"] = this.kixCertificateId;
      validationInputData["welcomeMail"] = this.InvitationForm.get('invitationStatus')?.value ? true : false
      validationInputData["welcomeMailSender"] = array || []


      this.logger.log('validationInputData', JSON.stringify(validationInputData));

      //  this.studentService.login1(validationInputData)
      this.http.post(environment.apiUrl + endPoint, validationInputData, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe(
        (result: any) => {
          if (result.status == "200") {
            Swal.fire({
              title: this.lang?.Info,
              // html: error.error.message ? error.error.message : error.error.error,
              html: "Enrolled Employee Successfully",
              // icon: "warning",
              width: "30%",
              showCancelButton: true,
              confirmButtonText: "View Employee",
              cancelButtonText: 'Add Another Employee'
            }).then((result) => {
              if (result.value) {
                this.router.navigate(["/manageMembers"]);
                this.logger.log("result.value: " + result.value);
              } else {
                window.location.reload();
              }
            })


          }
          else {
            Swal.fire({ title: this.lang?.Info, text: result.message || result.error || result.data.error })

          }

        },
        (error) => {

          Swal.fire({
            title: this.lang?.Error,
            // html: error.error.message ? error.error.message : error.error.error,
            html: `<div class="custom-content">${error.error.message ? error.error.message : error.error.error}</div>`,
            // icon: "warning",
            width: "30%",
            showCancelButton: false,
            confirmButtonText: "Ok",

          }).then((result) => {
            if (result.value) {
              this.logger.log("result.value: " + result.value)
            }
          })

        });
    } else {


    }
  }

  public bankformsubmitdetails() {
    var formData: any = new FormData();

    let personalInfo = JSON.parse(sessionStorage.getItem("Data") ?? '');


    let inputData = {
      customerId: parseInt(sessionStorage.getItem("normalcustomerid") ?? ''),
      bankCode: this.bankPayForm.get('enrollmentSummaryBankNumber')?.value,
      branchCode: this.bankPayForm.get('enrollmentSummaryTransitNumber')?.value,
      accountNumber: this.bankPayForm.get("enrollmentSummaryAccontNumber")?.value,

      amount: this._decimalPipe.transform(sessionStorage.getItem("totalAmount") ?? "", "1.2-2")?.replace(/,/g, ""),
      totalAmount: this._decimalPipe?.transform(sessionStorage.getItem("totalAmount") ?? '', "1.2-2")?.replace(/,/g, ""),

      totalAmountUI: sessionStorage.getItem("totalAmountUI"),
      enrollmentDate: sessionStorage.getItem("enrollmentdate"),
      customerName: personalInfo.firstName + " " + personalInfo.lastName,
    };

    this.logger.log(inputData)

    var encBank = btoa(JSON.stringify(inputData));
    formData.append("session", encBank);
    formData.append("timestamp", new Date().getTime());
    formData.append("files", this.bankfile);

    //this.logger.log(this.bankfile)

    sessionStorage.setItem("session", encBank);

    this.router.navigate(["/signupcomplete"]);

    return false;
  }
  public areYouInternationalStudent(value: any) {
    if (value == this.lang?.Yes) {
      this.userForm.get('provincialhealth')?.reset();
      this.userForm.get('provincialhealth')?.clearValidators();
      this.userForm.get('provincialhealth')?.updateValueAndValidity();
      this.userForm.get('uhipprovincialhealth')?.reset();
      this.userForm.get('uhipprovincialhealth')?.clearValidators();
      this.userForm.get('uhipprovincialhealth')?.setValidators([Validators.required]);

      this.checkstudenthealthcardstatus = true;
      this.checkstudenthealthcardstatus_UHIP = false;
      this.checkhealthcardstatus = false;

    }
    else {
      this.userForm.get('provincialhealth')?.reset();
      this.userForm.get('provincialhealth')?.clearValidators();
      this.userForm.get('provincialhealth')?.setValidators([Validators.required]);
      this.userForm.get('uhipprovincialhealth')?.reset();
      this.userForm.get('uhipprovincialhealth')?.clearValidators();
      this.userForm.get('uhipprovincialhealth')?.updateValueAndValidity();
      this.checkstudenthealthcardstatus = false;
      this.checkstudenthealthcardstatus_UHIP = true;

      this.checkhealthcardstatusuhip = false;

    }
  }





  public havingchildrenDependentInsurence(event: any) {

    let childrenVal = event.target.value;
    this.logger.log("havingchildrenDependentInsurence: " + childrenVal)
    if (childrenVal == 'true') {
      this.dependentchildInsurenceval = true;
      this.childFormGroup.get('childInfoCarrierName')?.setValidators([Validators.required]);
    } else {
      this.childFormGroup.get('childInfoCarrierName')?.reset();
      this.childFormGroup.get('childInfoCarrierName')?.clearValidators();
      this.childFormGroup.get('childInfoCarrierName')?.updateValueAndValidity();
      this.dependentchildInsurenceval = false;
    }
  }


  //

  validateDateforGraduation = (control: AbstractControl): { [key: string]: any } | null => {
    if (this.childFormGroup) {
      let dobControl = this.childFormGroup.get('childInfoDOB');
      this.logger.log({ dobControl })
      // if (!dobControl.value) {
      //   return { dateOfBirth: true };
      // }
      if (dobControl) {
        let dob = new Date(dobControl.value);
        if (new Date(control.value) < dob) {
          return { validGraduationDate: true };
        }
      }
    }
    return null;
  };

  checkForGraduationDate(event) {
    const graduationDayControl = this.childFormGroup.get('childInfoGraduationday');
    if (graduationDayControl.value) {
      graduationDayControl.updateValueAndValidity();
    }
  }

  public enrolledunversity(event: any) {
    this.logger.log("enrolledUnv: " + event.target.checked)
    if (event.target.checked == true) {
      this.graducationdaycheck = true;
      this.childFormGroup.get('childInfoGraduationday')?.setValidators(Validators.compose([Validators.required, this.validateDateforGraduation]));
    } else {
      this.childFormGroup.get('childInfoGraduationday')?.reset();
      this.childFormGroup.get('childInfoGraduationday')?.clearValidators();
      this.childFormGroup.get('childInfoGraduationday')?.updateValueAndValidity();
      this.graducationdaycheck = false;
    }
  }

  closePopup(id: any) {
    $(`#${id}`).hide();
    // $('#gsPlans').hide();
    // $('#eqPlans').hide();
    // $('#kixPlans').hide();
  }

  closePopupModel(id: any) {

    $('#gsPlans').hide();
    $('#eqPlans').hide();
    $('#kixPlans').hide();
    $('#waddellPlans').hide();
  }




  provincelist12345(event: any) {
    // alert(event.target.value)
    // if (event.target.value == "QC") {
    //   $('#QCproviance').show();
    // }
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(",");
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });

    // //this.logger.log(this.userForm.get('postalcode').value)
    if (this.userForm.get("postalcode")?.value) {
      if (
        this.provincialZipcodes.indexOf(
          this.userForm.get("postalcode")?.value[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.userForm.get("postalcode")?.markAsTouched();
      } else {
        this.invalidpostalcodeprivince = false;
      }

      if (this.userForm.get("postalcode")?.value.length == 0) {
        this.invalidpostalcodeprivince = false;
      }
    }
    // alert(this.postalvalue)
  }

  // provincelist12345(event:any){
  //   alert('121212');
  // }



  public checkparentalhealthinsuarnce(value: any) {
    this.logger.log("value >" + value.target.value)
    if (value.target.value == "false") {
      this.parentalhelathinsuranecheck = false;
    } else {
      this.parentalhelathinsuranecheck = true;
    }
  }

  public avisordisclosure() {

    ///need to check
    if (this.Shared.getlangdiscloure()) {
      if (sessionStorage.getItem("lanToken") == "en") {

        this.disclosureAgreement = this.disclosureAgreement_dynamicData;
      } else {
        this.disclosureAgreement = this.disclosureAgreement_dynamicData;

      }
    } else {
    }
    // const model=new Modal(this.advisoranddisclousreModal.nativeElement);
    // model.show();
  }

  public childdob(value: any) {
    let dob = new Date(value.target.value);
    var res = diff_years(dob);

    if (res > 18) {
      this.childrenenrollement = true;
    } else {
      this.childrenenrollement = false;
    }
  }

  public childdsiablility(value: any) {
    // this.childendisability = value.target.checked;
  }

  public dependentchildspecialinfo() {
    // jQuery("#dependentchildspecialinfo-modal").modal("show");
  }
  public showpadaggrement() {


    return false
    this.showSignAndAgreeOrAgree = false;
    this.PADpafaggrementModalShow();
    this.generatePADaggrement = '';
    //     if(sessionStorage.getItem("fileurl") && sessionStorage.getItem("filename") && sessionStorage.getItem("signature")){
    // this.showmodelsign()
    //     }
    //     else{

    let Data = JSON.parse(sessionStorage?.getItem('Data') || "")
    this.agreestatus = false
    this.signaturestatus = true
    // if(this.bankdetailsverify == true){

    //   this.bankdetailsverify =true
    // }

    // this.Shared.getMessage()
    if (this.Shared.getMessage()) {
      this.isFileUploaded = false
    }
    else {
      this.isFileUploaded = true
    }

    // alert(this.bankdetailsverify)
    this.logger.log("homeAddressSameasBillingAddress " + this.enrollmentForm.get('homeAddressSameasBillingAddress')?.valid);
    if (this.enrollmentForm.get('homeAddressSameasBillingAddress')?.valid) {
      let addressobject = {
        "address1": this.enrollmentForm.get("enrollmentSummaryStreetAddress")?.value || Data.street_address_line1 || sessionStorage.getItem("addressline1") || "",
        "address2": this.enrollmentForm.get("enrollmentSummaryStreetAddressLane2")?.value || Data.street_address_line2 || "",
        "apt": this.enrollmentForm.get("enrollmentSummaryApartSuite")?.value || Data.apt || "",
        "city": this.enrollmentForm.get("enrollmentSummaryCity")?.value || Data.city || sessionStorage.getItem("billingaddresscity") || "",
        "province": this.enrollmentForm.get("enrollmentSummaryProvince")?.value || Data.province || this.bankPayForm.get("enrollmentSummaryProvince")?.value || "",
        "postalCode": this.enrollmentForm.get("enrollmentSummaryPostalCode")?.value || Data.postal_code || sessionStorage.getItem("enrollmentSummaryPostalCode") || "",
        "phone": Data.phone_number,
        "email": Data.email,
      }
      this.logger.log("addressobject: " + JSON.stringify("addressobject: " + addressobject))

      let bankAddress = this.bankverifyDetails.address
      let bankAdressArr = bankAddress.split(",")
      let bankCity = bankAdressArr[bankAdressArr.length - 2].replace(" ", '');
      let provincePostal = bankAdressArr[bankAdressArr.length - 1];
      let provincePostalArr = provincePostal.split(" ")
      let bankProvince = provincePostalArr[provincePostalArr.length - 3]
      let bankPostalCode = provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1]

      let bankobject =
      {
        "name": this.bankverifyDetails.bank.name,
        "address": this.bankverifyDetails.bank.address.split(",")[0],
        "city": bankAdressArr[bankAdressArr.length - 2].replace(" ", ''),
        "province": provincePostalArr[provincePostalArr.length - 3],
        "postalCode": provincePostalArr[provincePostalArr.length - 2] + " " + provincePostalArr[provincePostalArr.length - 1]
      }
      this.logger.log("bankobject: " + bankobject)

      let inputData1 = {
        "bankCode": this.bankPayForm.get("enrollmentSummaryBankNumber")?.value,
        "branchCode": this.bankPayForm.get("enrollmentSummaryTransitNumber")?.value,
        "accountNumber": this.bankPayForm.get("enrollmentSummaryAccontNumber")?.value,
      };
      this.logger.log("inputData1: " + inputData1)

      var fileExtension = '.' + this.bankfile.name.split('.').pop();

      var encBank = btoa(JSON.stringify(inputData1));
      var formData: any = new FormData();
      formData.append("firstName", Data.firstName);
      formData.append("lastName", Data.lastName);
      formData.append("address", JSON.stringify(addressobject));
      formData.append("bank", JSON.stringify(bankobject));
      formData.append("files", this.bankfile, "void_cheque_" + Date.now() + fileExtension.toLowerCase());
      // formData.append("files", this.bankfile.name,"void.pdf");
      formData.append("session", encBank) || "";
      formData.append("timestamp", new Date().getTime());


      // let padAggrement: string = `${environment.app.grp}api/students/generatePAD`;
      let padAggrement: string = "";

      //this.studentService.padaddgrementdetails(formData).
      this.http.post(padAggrement, formData, {})
        .subscribe((result: any) => {
          if (result.status == "200") {
            this.generatePADaggrement = result.data.url;
            this.logger.log("generatePADaggrement: " + this.generatePADaggrement);
            this.generatePADaggrement = "https://testapi.groupbenefitz.aitestpro.com/app/server/PAD_Agreement_l_1700036759458.pdf";
            // jQuery("#PADpafaggrement-modal").modal("show");
            sessionStorage.setItem("fileurl", result.data.url)
            sessionStorage.setItem("filename", result.data.filename)
          }
          else {
            Swal.fire({
              title: this.lang?.Error,
              text: result.message ? result.message : result.error,
              width: "30%",
              showCancelButton: false,
              confirmButtonText: "Ok",
            }).then((result) => {
              if (result.value) {
              } else {
                // this.router.navigate(['pages/signup-form']);
              }
            });
          }
        })
    }
    else {

      this.bankPayForm.markAsTouched();
      this.bankPayForm.get("enrollmentSummaryBankNumber")?.markAsTouched();
      this.bankPayForm.get("enrollmentSummaryTransitNumber")?.markAsTouched();
      this.bankPayForm.get("enrollmentSummaryAccontNumber")?.markAsTouched();
      this.bankPayForm.get("enrollmentSummaryvoidCheckUpload")?.markAsTouched();
      // this.bankPayForm.get("checkbankdetails").markAsTouched();
      this.enrollmentForm.get("enrollmentSummaryApartSuite")?.markAsTouched();
      this.enrollmentForm.get("enrollmentSummaryStreetAddress")?.markAsTouched();
      this.enrollmentForm.get("enrollmentSummaryCity")?.markAsTouched();
      this.enrollmentForm.get("enrollmentSummaryProvince")?.markAsTouched();
      this.enrollmentForm.get("enrollmentSummaryPostalCode")?.markAsTouched();

      // if (this.signaturecheck == true) {
      //   this.signaturemessage = true;
      // }
    }
  }

  dependentWithSpecialNeedsShow() {
    $('#dependentWithSpecialNeeds').show();
  }
  PADpafaggrementModalShow() {
    //see that using ViewChildren you use nativeElement
    //const modal = new Modal(this.PADpafaggrementModalpopup.nativeElement);
    //modal.show();
  }

  PADpafaggrementModalShowSign() {
    //see that using ViewChildren you use nativeElement
    //const modal = new Modal(this.PADpafaggrementModalpopupSign.nativeElement);
    //modal.show();
  }
  PADpafaggrementModalClose() {
    //see that using ViewChildren you use nativeElement
    this.logger.log("PADpafaggrementModalClose working this function")
    //const modal = new Modal(this.PADpafaggrementModalpopup.nativeElement);
    // modal.hide();

    // const modalElement = this.PADpafaggrementModalpopup.nativeElement;
    // modalElement.parentNode.removeChild(modalElement);
  }
  signaturePadagreementModalShow() {
    //see that using ViewChildren you use nativeElement
    this.clearSignature();
    this.padAgreementClearSignature();
    //const modal = new Modal(this.signaturePadagreementModalPopup.nativeElement);
    //modal.show();
  }
  padAgreementClearSignature() {
    this.padAggsignaturePadCC.clear();
    this.padAgreementSignaturePadClear = false;

    this.padAgreementSignaturemessagecc = true;
  }

  startSigning(event: any) {
    if (event.target.touched) {
      this.logger.log('sign touched')
      this.signaturemessagecc = false;
    } else {
      this.logger.log('sign not toched')
    }
    this.signaturePadClear = true;
    this.signaturemessagecc = false;

    const base64Data = this.signaturePadCC.toDataURL();
    this.signatureImgcc = base64Data;
    sessionStorage.setItem("signatureCC", this.signatureImgcc);
  }


  postSecondaryShow() {
    $('#postSecondaryStudent').show();
  }
  // this.createCutomerPADagreement(data)
  // }

  public padLoaded(event: any) {

  }
  public voidcheckupload(event: any) {


    var fileExtension = '.' + event.target.files[0].name.split('.').pop();

    // event.target.files[0].name ="void_cheque_"+Date.now()+fileExtension

    // "void_cheque_"+Date.now()+fileExt
    //this.logger.log(event)
    this.isFileUploaded = true
    this.imagedisplay = null;
    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.bankfile = event.target.files[0];
    // this.bankfile.name = (this.bankfile.name,"void_cheque_"+Date.now()+fileExtension)
    // alert(fileExtension.toLowerCase())
    this.Shared.setMessage(this.bankfile);
    var allowedMimes = [
      "image/jpeg",
      "image/pjpeg",
      "image/png",
      "application/pdf",
    ];

    let error = false;

    let message = "";

    if (allowedMimes.includes(this.bankfile.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.bankfile.size <= maxFileSize) {
        //300KB

        error = false;
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang?.File_size_is_too_large_maximum_file_size_is_5MB;
      }
    } else {
      error = true;


      message = this.lang?.Invalid_file_type_Only_pdf_files_is_allowed;
    }

    if (error) {
      Swal.fire({
        title: this.lang?.Error,
        html: message,
        width: "50%",
        showCancelButton: false,
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {

          this.bankPayForm.get('enrollmentSummaryvoidCheckUpload')?.reset();
          this.isFileUploaded = true
        } else {
        }
      });
    }

    else {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      if (event.target.files[0].type == "application/pdf") {
        // alert("1")
        this.pdfview = true;
        this.normalview = false;
      } else {
        this.pdfview = false;
        this.normalview = true;
      }

      reader.onload = (_event) => {
        this.imagedisplay = reader.result;
        this.logger.log("imgedisplay :", this.imagedisplay);
      };

      // let id = parseInt(sessionStorage.getItem("normalcustomerid"));
    }

    // sessionStorage.setItem("files", event.target.files[0]);
    // localStorage.setItem("files", JSON.stringify(event.target.files[0]));

    // sessionStorage.setItem("voidCheque",this.bankfile)
  }



  public spousehealthcard(event: any) {
    // alert("spousehealthcard")
    if (event.target.value == "true") {
      this.spousehealthcardinfo = true;
      this.userForm.get('Spousenameofthecarrier')?.reset();
      this.userForm.get('Spousenameofthecarrier')?.clearValidators();
      this.userForm.get('Spousenameofthecarrier')?.setValidators(Validators.compose([Validators.required,
      ]));

      this.userForm.get('spousecob')?.reset();
      this.userForm.get('spousecob')?.clearValidators();
      this.userForm.get('spousecob')?.setValidators([Validators.required]);

    } else {
      this.spousehealthcardinfo = false;

      this.userForm.get('Spousenameofthecarrier')?.reset();
      this.userForm.get('Spousenameofthecarrier')?.clearValidators();
      this.userForm.get('Spousenameofthecarrier')?.updateValueAndValidity();

      this.userForm.get('spousecob')?.reset();
      this.userForm.get('spousecob')?.clearValidators();
      this.userForm.get('spousecob')?.updateValueAndValidity();
    }
  }
  public childAddFun() {
    this.childInfoModalAddAndUpdateButton = "Add";
    this.dependentchildInsurenceval = false;
    this.childFormGroup.get("childInfoFirstName")?.setValidators(Validators.compose([Validators.required, Validators.minLength(1)]));
    this.childFormGroup.get("childInfoLastName")?.setValidators(Validators.compose([Validators.required, Validators.minLength(1)]));

    this.childFormGroup.get("childInfoGender")?.clearValidators();
    this.childFormGroup.get("childInfoGender")?.setValidators(Validators.required);

    this.childFormGroup.get('childInfoDOB')?.clearValidators();
    // this.childFormGroup.get("childInfoDOB")?.setValidators(Validators.required);
    this.childFormGroup.get("childInfoDOB").setValidators(Validators.compose([Validators.required, this.childrenminimumAgeValidator]));


    this.childFormGroup.get('DependentchildInsurence')?.clearValidators();
    this.childFormGroup.get('DependentchildInsurence')?.setValidators(Validators.required);

    // const model=new Modal(this.childInfoModal.nativeElement);
    // model.show();
    this.childFormGroup.reset();
    $('#childInfoModal').show();

  }

  childrenminimumAgeValidator = (control: AbstractControl): { [key: string]: any } | null => {

    const birthDate = new Date(control.value);

    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();



    if (age == 55) {
      return { childrenminimumAge: false };
    }
    if (age > 21 || age < 0) {
      return { childrenminimumAge: true };
    }


    return null;

  }

  advisourediscloserLoaded(event: any) {
    this.pdfvisibleadvisouredisclosure = false;
  }

  public termandconditions() {
    this.logger.log("termscondition***********************");
    if (this.Shared.getlangterms()) {
      if (sessionStorage.getItem("lanToken") == "en") {
        this.term_and_conditions = this.brokerTermsConditions;
      }
      else {
        this.term_and_conditions = this.brokerTermsConditions;
      }
      this.logger.log("url print: " + this.term_and_conditions)
    } else {
    }
    // document.getElementById('termsAndConditionsModal')?.show();
    // const model=new Modal(this.termsAndConditionsModal.nativeElement);
    // model.show();
  }

  changeTextToUppercase(field: any) {
    this.logger.log("studentId field: " + field)
    this.userForm.get(field)?.setValue(this.userForm.controls[field].value.toUpperCase());
  }

  changeTextToUppercasePostalCode(field: any, event: any) {

    this.userForm.get(field)?.setValue(this.userForm.controls[field].value.toUpperCase());

    this.postalvalue = event.target.value;
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      this.invalidpostalcodeprivince = true;
    } else {
      this.invalidpostalcodeprivince = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }
  }

  changeTextToUppercaseenrollmentPostalCode(field: any, event: any) {
    this.enrollmentForm.get(field)?.setValue(this.enrollmentForm.controls[field].value.toUpperCase());
    this.postalvalue = event.target.value;
    this.logger.log("postalvalue12212: " + this.postalvalue);
    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      this.invalidenrollmentpostalcodeprovince = true;
    } else {
      this.invalidenrollmentpostalcodeprovince = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidenrollmentpostalcodeprovince = false;
    }
  }


  public async personalInfoSubmit() {


    // let validationdataClear: string = `${environment.apiUrl}/api/ap/corporate/customer/validation`;

    let validationdataClear: string = `${environment.apiUrl}/api/ap/customer/v3/plans`;
    this.logger.log("userForm validations1233 " + JSON.stringify(this.userForm.value));
    this.logger.log("userformcontrols", this.userForm.controls)
    if (this.userForm.invalid) {
      this.logger.log("userformcontrols", this.userForm.controls)
      this.logger.log(this.userForm.value);
      return;
    }



    let userFormDetails = this.userForm.value;
    let childInfo = this.childInfoAddDataArray;

    // this.logger.log("childInfo",childInfo);

    let childInfoArray = [];

    for (let childData of childInfo) {
      let childObject: any = {
        "first_name": childData.childInfoFirstName,
        "last_name": childData.childInfoLastName,
        "firstName": childData.childInfoFirstName,
        "lastName": childData.childInfoLastName,
        "gender": childData.childInfoGender,
        "date_of_birth": moment(childData.childInfoDOB).format('YYYY-MM-DD'),
        "dob": moment(childData.childInfoDOB).format('YYYY-MM-DD'),
        "is_child_having_healthcard": JSON.parse(childData.DependentchildInsurence ? childData.DependentchildInsurence : 'false'), //== 'true' ? true : false,
        "child_carrier_name": childData.childInfoCarrierName,
        "enrolledInUniversity": JSON.parse(childData.childPostGraduate ? childData.childPostGraduate : 'false'),
        "isDisabled": JSON.parse(childData.childdisablility ? childData.childdisablility : 'false'),

        "graduationDay": moment(childData.childInfoGraduationday).format('YYYY-MM-DD'),

      }
      // this.logger.log('forArry',childObject)
      childInfoArray.push(childObject);
    }

    this.logger.log("userFormDetails.havingspouse: " + userFormDetails.havingspouse)
    let spouseInfo = {};
    if (userFormDetails.havingspouse) {
      spouseInfo = {
        first_name: userFormDetails.spousefirstname,
        last_name: userFormDetails.spouselastname,
        firstName: userFormDetails.spousefirstname,
        lastName: userFormDetails.spouselastname,
        // email:userFormDetails.spouseemail || "",
        email: "",
        date_of_birth: moment(userFormDetails.spousedateofbirth).format('YYYY-MM-DD'),
        dob: moment(userFormDetails.spousedateofbirth).format('YYYY-MM-DD'),
        gender: userFormDetails.spousegender,
        is_spouse_having_healthcard: userFormDetails.havingspouse == 'true' ? true : false,
        spouse_carrier_name: userFormDetails.Spousenameofthecarrier,
        cobCoverage: userFormDetails.spousecob,
      }
    } else {
      spouseInfo = {}
    }

    let statesData = this.configprovinceres.filter((item: { shortName: any; }) => {
      return item.shortName === userFormDetails.province;
    });
    let statesId: any;
    let statesName: any;
    let fusebillStateId: any
    if (statesData.length > 0) {
      statesId = statesData[0].id;
      fusebillStateId = parseInt(statesData[0].fusebillId),
        statesName = statesData[0].name;
    } else {
      statesId = '';
      fusebillStateId = '';
      statesName = '';
    }
    // this.logger.log("configprovinceres: "+JSON.stringify(this.configprovinceres))
    this.logger.log("state id: " + statesData)
    this.logger.log("state id: " + JSON.stringify(statesData))

    let phrDetails = {
      "dateOfArrival": this.datePipe.transform(userFormDetails.dateOfArrival, "yyyy-MM-dd") || "",
      "countryOfOrigin": userFormDetails.countryOrigin || "",
      "isLandedImmigrant": Boolean(userFormDetails.isEmployeeImigrant) || "",
      "coverageRequired": Boolean(userFormDetails.coverageRequiredOfEmployee) || "",
      "applyingForLandingStatus": userFormDetails.applylandedstaus ? Boolean(userFormDetails.applylandedstaus) : false,
      ...(this.showlandeddependentDetails == true ? {
        "dependentDetails": {
          "coverageRequired": Boolean(userFormDetails.coverageRequiredOfDependents) || "",
          "dateOfArrival": userFormDetails.coverageRequiredOfDependents == "true" ? this.datePipe.transform(userFormDetails.dependentdateOfArrival, "yyyy-MM-dd") : '',
          "countryOfOrigin": userFormDetails.coverageRequiredOfDependents == "true" ? userFormDetails.dependentcountryOrigin : '',
          "isLandedImmigrant": userFormDetails.coverageRequiredOfDependents == "true" ? Boolean(userFormDetails.dependentLandedImigrant) : false,
          "applyingForLandingStatus": userFormDetails.dependentMorethan3years ? Boolean(userFormDetails.dependentMorethan3years) : false,
          "stayFor3Months": userFormDetails.coverageRequiredOfDependents == "true" ? Boolean(userFormDetails.dependentMorethan3years) : false
        }
      } : {})
    }


    let personalInfoData = {
      "isStudent": false,
      "recaptchaCheck": false,
      "g_recaptcha_response": "test",
      "fusebillCustomerId": this.userForm.get('fusbillId').value || null,

      "planEnrollmentDate": this.datePipe.transform(userFormDetails.planEnrollmentDate, 'yyyy-MM-dd'), //userFormDetails.planEnrollmentDate,
      "enrollmentDate": this.datePipe.transform(userFormDetails.planEnrollmentDate, 'yyyy-MM-dd'), //userFormDetails.planEnrollmentDate,
      "EnrollmentDate": this.datePipe.transform(userFormDetails.planEnrollmentDate, 'yyyy-MM-dd'), //userFormDetails.planEnrollmentDate,
      // "planEnrollmentDate":moment(userFormDetails.planEnrollmentDate,"DD-MMM-YYYY").format("YYYY-MM-DD"), //userFormDetails.planEnrollmentDate,
      // "enrollmentDate":moment(userFormDetails.planEnrollmentDate,"DD-MMM-YYYY").format("YYYY-MM-DD"), //userFormDetails.planEnrollmentDate,
      // "EnrollmentDate":moment(userFormDetails.planEnrollmentDate,"DD-MMM-YYYY").format("YYYY-MM-DD"), //userFormDetails.planEnrollmentDate,

      "first_name": userFormDetails.givenname,
      "firstName": userFormDetails.givenname,
      "last_name": userFormDetails.lastname,
      "lastName": userFormDetails.lastname,
      "email": userFormDetails.email,
      "phone_number": userFormDetails.phonenumber,
      "street_address_line1": userFormDetails.streetaddress,
      "street_address_line2": userFormDetails.streetaddressline2 == undefined ? '' : userFormDetails.streetaddressline2,
      "city": userFormDetails.city,
      "province": userFormDetails.province,
      "province_id": statesId,
      "country": "Canada",
      "country_id": 124,
      "countryId": 124,
      "postal_code": userFormDetails.postalcode,
      "date_of_birth": moment(userFormDetails.dateofbirth).format('YYYY-MM-DD'),
      "dob": moment(userFormDetails.dateofbirth).format('YYYY-MM-DD'),
      "gender": userFormDetails.gender,
      "workingProvince": userFormDetails.workingProvince,
      "working_province_id": this.working_provincelistid,
      // "universityName": "AUSU" || "",
      "enrolmentProgramName": "",
      // "date_of_hiring": moment(userFormDetails.planEnrollmentDate,"DD-MMM-YYYY").format("YYYY-MM-DD"),//userFormDetails.planEnrollmentDate,
      "working_20hours": true,
      "weeklyHours": 0,
      "hours_per_week": 40,//userFormDetails.hoursperweek==undefiend?''userFormDetails.hoursperweek:
      // "foreignStudent": userFormDetails.foreignStudent == 'true' ? true : false,
      // "isUHIP": userFormDetails.uhipprovincialhealth == 'true' ? true : false,
      "coveredParentalHealthInsurance": userFormDetails.parentalinsurance == 'true' ? true : false,
      "provincial_health_coverage": userFormDetails.provincialhealth == 'true' ? true : false,
      "work_visa": "",
      "having_spouse": userFormDetails.havingspouse == 'true' ? true : false,
      "spouse_details": userFormDetails.havingspouse == 'false' ? {} : spouseInfo,
      "having_dependent_children": userFormDetails.Dependentchildren == 'true' ? true : false,
      "no_of_children": userFormDetails.Dependentchildren == 'true' ? (this.noOfChildrenChangedValue) : 0,
      "children_details": childInfoArray.length > 0 ? childInfoArray : "",
      "signature": "digiSign",
      "fusebillCustomer": true,
      "formId": parseInt(this.formid),
      "brokerId": parseInt(this.brokerid),
      // "formId":parseInt(userFormDetails.formrname),//this.formid,
      "termsandconditions": '',//userFormDetails.termsandconditions,
      "disclouseradvisor": true,
      "state": statesName,
      "stateId": statesId,
      "state_id": statesId,
      "fusebillStateId": fusebillStateId,

      "currency": "CAD",
      "currencySymbol": "$",
      "apt": userFormDetails.apt_suite == undefined ? '' : userFormDetails.apt_suite,
      "studentId": userFormDetails.studentId,
      "beneficiaries_details": [

      ],
      "employeeKey": "",
      "employeeGeneric": true,
      "employerName": userFormDetails.employername || "",
      "date_of_hiring": this.datePipe.transform(userFormDetails.dateofhire, 'yyyy-MM-dd'),
      "isCorporate": true
    }

    if (this.showExtrafeilds == true) {
      personalInfoData['phrDetails'] = phrDetails
    }
    this.employername = userFormDetails.employername
    this.logger.log("personalInfoData: " + JSON.stringify(personalInfoData))

    this.applicantfirstname = userFormDetails.givenname;
    let dependent_info = true;
    if (this.userForm.get('Dependentchildren')?.value === 'true') {
      if (this.childTableRowsLength > 0)
        dependent_info = true;
      else
        dependent_info = false;
    }
    else {
      dependent_info = true;
    }

    if (this.userForm.valid && !this.invalidpostalcodeprivince && dependent_info && !this.checkhealthcardstatus && this.hourperweekvalue) {
      //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/customer/plans
      // let validationdata: string = `${environment.apiUrl}/api/ap/corporate/customer/validation`;
      // let validationdata: string = `${environment.apiUrl}/api/ap/corporate/customer/validation`;
      let validationdata: string = `${environment.apiUrl}/api/ap/customer/v3/plans`;

      var accessToken = sessionStorage.getItem('accessToken');
      //this.studentService.validation(personalInfoData)
      this.http.post(validationdata, personalInfoData,
        {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          }
        })
        .subscribe(
          (result: any) => {
            this.logger.log("json result: " + JSON.stringify(result))
            if (result.status == '200') {
              this.allFormData = {}
              this.formData = {}
              this.mainarray = [];
              this.mainarrayValues = [];
              this.mainarrayFinal = [];
              this.modifiedBlocksPaidByCompany = ''
              this.modifiedBlocksCoveredByCompany = '',

                this.selectedTab = this.customerPlansInActive ? 'tab3' : 'tab2';

              sessionStorage.setItem(
                "customerTierId",
                result.data.customer.customerTierId
              );
              sessionStorage.setItem("employeeshare", "0");



              sessionStorage.setItem('plansummaryLife', '[]');
              sessionStorage.setItem('planssummarymainLife', '[]');

              sessionStorage.setItem("planDetailsArrayBlock", "[]");
              this.effectiveEmployeeTotalContibution = 0;
              sessionStorage.setItem("totalAmount", "0");
              sessionStorage.setItem("totalAmountUI", "0");

              sessionStorage.setItem("allSelectedPlans", "[]");


              sessionStorage.setItem("plansummary", "[]");
              sessionStorage.setItem("selectedPlans", "{}");
              sessionStorage.setItem("selectedPlansLife", "{}");
              sessionStorage.setItem("plansummarymain", "[]");
              sessionStorage.setItem("plansummaryopt", "[]");
              sessionStorage.removeItem("Spousesignature")


              sessionStorage.setItem(
                "corporateStateId",
                result.data.workingProvince.id
              );
              sessionStorage.setItem(
                "corporateStateName",
                result.data.workingProvince.name
              );
              sessionStorage.setItem(
                "companyStateId",
                result.data.corporateProvince.id
              );
              // sessionStorage.removeItem("paymentMethod")   ////here
              sessionStorage.removeItem("paymentfail");
              this.companypaidproductid = [];
              this.disabledcompanypaidproductid = [];
              this.removedisabledcompanypaidproductid = [];
              this.adddisabledcompanypaidproductid = [];
              // this.applicantfirstname = this.capitalize(value.givenname);
              // this.planssummary = JSON.parse(
              //   sessionStorage.getItem("plansummary")
              // );


              // this.applicantSpousename = spouseInfo.first_name || "";
              this.applicantfirstname = personalInfoData.firstName;

              // console.log(this.applicantfirstname)


              sessionStorage.setItem(
                "completeapplicantinfo",
                this.completeapplicantinfo
              );


              this.specialpackages = [];
              this.packagesInBlocks = result.data.blocks;
              this.basepackages = result.data.packages;
              let companyplans = this.convertpackagesToPlans2(
                this.packagesInBlocks
              )[1];
              let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
              this.calculateBasePlanDeltasforCCplans(
                this.packagesInBlocks.coveredByCompany,
                baseplans,
                companyplans
              );
              this.calculateBasePlanCPplans(
                this.packagesInBlocks.paidByCompany,
                baseplans,
                companyplans
              );

              // //console.log(this.packagesInBlocks.paidByCompany)
              // //console.log(this.modifiedBlocksPaidByCompany)
              this.mainarrayValues = this.cobminedcommonfunction(
                // this.packagesInBlocks.paidByCompany,
                this.modifiedBlocksPaidByCompany,
                this.modifiedBlocksCoveredByCompany,
                this.packagesInBlocks.paidByEmployee
              );

              let allPackages = [];
              for (let key in this.mainarrayValues) {
                //this.consoleMessage(key)
                allPackages.push(this.mainarrayValues[key]);
              }
              // this.mainarray = allPackages;





              let filteredMainArray = allPackages
                .map((element: any) => {
                  // Map the groups
                  let filteredGroups = element.groups.map((group: any) => {
                    // Map the plans
                    let filteredPlans = group.plans.map((plan: any) => {
                      // Filter the productAddonss


                      let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                        (acc: any, key) => {

                          // Filter the products where display is true
                          // let filteredProducts = plan.productAddonss[key].map((product: any) => {
                          //   // Check if the 'display' key exists and is true
                          //   if (product.hasOwnProperty('display') && product.display) {
                          //     return product; // Keep the object as-is if display is true
                          //   }
                          //   const newProduct = {};
                          //   // console.log("Product replaced with empty object:", product, "New product:", newProduct);
                          //   return newProduct;
                          // });
                          let filteredProducts = plan.productAddonss[key].filter((product: any) =>
                            product.hasOwnProperty('display') && product.display
                          );
                          console.log(filteredProducts)
                          const containsOnlyEmptyObjects = filteredProducts.every(
                            (product: any) => Object.keys(product).length === 0
                          );

                          if (containsOnlyEmptyObjects) {
                            console.log("filteredProducts contains only empty objects.");
                          } else {
                            acc[key] = filteredProducts;
                            console.log("filteredProducts contains non-empty objects.");
                          }
                          // if (filteredProducts.length > 0) {
                          //   acc[key] = filteredProducts;
                          // }
                          return acc;
                        },
                        {}
                      );
                      return {
                        ...plan,
                        productAddonss: filteredProductAddonss,
                      };
                    }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

                    return {
                      ...group,
                      plans: filteredPlans,
                    };
                  }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

                  return {
                    ...element,
                    groups: filteredGroups,
                  };
                })
                .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


              console.log(filteredMainArray)

              this.mainarrayFinal = filteredMainArray

              console.log(this.mainarrayFinal)

              // this code needs to comment for single single in
              this.mainarrayFinal.forEach((element: any) => {
                element.groups.forEach((group: any) => {
                  group.plans.forEach((plan: any) => {
                    if (plan.productAddonss) {
                      Object.keys(plan.productAddonss).forEach((key) => {
                        // plan.productAddonss[key].forEach((product) => {
                        const keys = ['planCoverage'];
                        const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                          self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                        );
                        plan.productAddonss[key] = filteredData
                        // });
                      });
                    }
                  });

                });
              });

              this.mainarrayFinal.forEach((element: any) => {
                element.groups.forEach((group: any) => {
                  if (group.categorization.paidByCompany == 1) {
                    group.plans.forEach((plan: any) => {
                      let pl = { ...plan, ...group.categorization }
                      Object.keys(plan.productAddonss).forEach((key) => {
                        let productLength = plan.productAddonss[key]?.display
                        let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length

                        plan.productAddonss[key].forEach((product: any) => {

                          if (pl.isBundle) {
                            this.companypaidproductid.push(pl);
                          }
                          else {
                            this.companypaidproductid.push(product.planlevel);
                          }


                          const dom: HTMLElement = this.elementRef.nativeElement;

                          const plan: any = dom.querySelector("#plancheck" + product.id);

                          if (plan) {
                            plan.checked = false;
                          }
                          // $("#plancheck" + product.id).prop("checked", false);
                        });
                      });
                    });
                  }

                  setTimeout(() => {
                    if (group.categorization.coveredByCompany == 1) {
                      group.plans.forEach((plan: any) => {
                        Object.keys(plan.productAddonss).forEach((key) => {
                          plan.productAddonss[key].forEach((product: any) => {
                            // $("#plancheck" + product.id).prop("checked", false);
                            const dom: HTMLElement = this.elementRef.nativeElement;

                            const plan: any = dom.querySelector("#plancheck" + product.id);

                            if (plan) {
                              plan.checked = false;
                            }
                          });
                        });
                      });
                    }
                    if (group.categorization.paidByEmployee == 1) {
                      group.plans.forEach((plan: any) => {

                        if (plan.productAddonss) {
                          Object.keys(plan.productAddonss).forEach((key) => {
                            plan.productAddonss[key].forEach((product: any) => {
                              // $("#plancheck" + product.id).prop("checked", false);
                              const dom: HTMLElement = this.elementRef.nativeElement;

                              const plan: any = dom.querySelector("#plancheck" + product.id);

                              if (plan) {
                                plan.checked = false;
                              }
                            });
                          });
                        }
                      });
                    }
                  }, 1000);
                });
              });


              this.planAmount = ''
              this.plansnexttab = true;
              sessionStorage.setItem("stateid", result.data.province.id);


              sessionStorage.setItem(
                "planDetailsArray",
                JSON.stringify(this.specialpackages)
              );
              sessionStorage.setItem(
                "planDetailsArrayBlock",
                JSON.stringify(this.mainarrayFinal)
              );
              this.autoSelectCompanyPaidPlans();
              setTimeout(() => {
                sessionStorage.setItem("Data", JSON.stringify(personalInfoData));


                sessionStorage.setItem(
                  "enrollmentdate",
                  result.data.planEnrollmentDate
                );

              }, 2000);

              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                  "message": "Corporates information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
              })

              // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {
              //   this.http.post(environment.reportApiUrl+'/websocket/corporate/notification-to-others',{
              //     "message": "Corporates information has been updated. Please refresh screen."
              //   }, { headers: {
              //     Authorization: 'Bearer ' + accessToken,
              //     'Content-Type': 'application/json',
              //   } }).subscribe((res)=>{
              //     console.log({res})
              //   })
              // })

            }
            else {
              Swal.fire({
                title: this.lang?.Error,
                text: result.message ? result.message : result.error,
                width: "30%",
                showCancelButton: false,
                confirmButtonText: "Ok",
              }).then((result) => {
                if (result.value) {
                } else {
                  // this.router.navigate(['pages/signup-form']);
                }
              });
            }
          }, (error) => {
            this.logger.log(this.lang?.Error, error);
            if (error.error.errorCode == "GBS_CV_0009_A" || error.error.errorCode == "GBS_CV_0010") {//"GBS_CV_0010"
              this.logger.log(this.lang?.Error, error);//409
              Swal.fire({
                title: this.lang?.Error,
                // html: error.error.message ? error.error.message : error.error.error,
                html: `<div class="custom-content">${error.error.message ? error.error.message : error.error.error}</div>`,

                showCancelButton: true,
                confirmButtonText: "Visit Portal",

                // text:'codes',
              }).then((result) => {
                if (result.value) {
                  let link = error.error.customerportalLink != undefined ||
                    error.error.customerportalLink != null || error.error.customerportalLink != "" ?
                    error.error.customerportalLink : error.error.data.customerportalLink;

                  window.open(link);
                  // let url=this.location['origin']
                  // this.router.navigate([url+'/portal/']);
                  // this.router.navigate(['/portal/']);
                  if (
                    error.error.message.includes("incomplete") ||
                    error.error.message.includes("The email address already exists")
                  ) {
                    let formLink = sessionStorage.getItem("formlink");
                    // sessionStorage.clear();

                    // this.router.navigate([formLink]);
                    // window.location.reload();
                  }
                } else {
                }
              });
            }
            else {
              this.logger.log(this.lang?.Error, error);//409
              Swal.fire({
                title: this.lang?.Error,
                // html: error.error.message ? error.error.message : error.error.error,
                html: `<div class="custom-content">${error.error.error.message ? error.error.error.message : error.error.error.error}</div>`,
                // icon: "warning",
                width: "30%",
                showCancelButton: false,
                // confirmButtonText: "Visit Portal",

              }).then((result) => {
                if (result.value) {
                  // let link=error.error.customerportalLink!=undefined||
                  // error.error.customerportalLink!=null||error.error.customerportalLink!=""?
                  // error.error.customerportalLink:error.error.data.customerportalLink;

                  // window.open(link);
                  // let url=this.location['origin']
                  // this.router.navigate([url+'/portal/']);
                  // this.router.navigate(['/portal/']);
                  if (
                    error.error.message.includes("incomplete") ||
                    error.error.message.includes("The email address already exists")
                  ) {
                    let formLink = sessionStorage.getItem("formlink");
                    // sessionStorage.clear();

                    // this.router.navigate([formLink]);
                    // window.location.reload();
                  }
                } else {
                }
              });
            }
          });
    } else {
      this.scrollToFirstInvalidControl1();
    }
  }

  private scrollToFirstInvalidControl1() {

    // const firstInvalidControl: HTMLElement =
    //   this.el.nativeElement.querySelector(
    //     "form .ng-invalid" || "form .ng-untouched"
    //   );
    // // //this.logger.log(firstInvalidControl);
    // window.scroll({
    //   top: this.getTopOffset(firstInvalidControl),
    //   left: 0,
    //   behavior: "smooth",
    // });
  }
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 300;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  public uhipprovincialhealth(value: any) {
    this.logger.log("value: " + value);
    if (value.target.value == "true") {
      //const modal = new Modal(this.checkphcpstatusModal.nativeElement);//checkuhipstatusModal
      //modal.show();

      this.checkhealthcardstatusuhip = false;
    } else {
      $('#checkphcpstatusModal').show();
      this.checkhealthcardstatusuhip = true;
    }
  }

  public closeoptionsselection() {
    // //console.log(this.optionstitle)
    this.planOptionsModel = false

    let plandetailsobj = this.optionPlanDetailsObj.nativeElement.value.split("##");

    // //this.consoleMessage(plandetailsobj[19])
    // //this.consoleMessage(plandetailsobj[20])
    //console.log(plandetailsobj)

    // $("#plancheck" + plandetailsobj[19]).prop("checked", false);
    const planCheck = this.renderer.selectRootElement("#plancheck" + plandetailsobj[7]);
    // // this.renderer.setProperty(planCheck, 'checked', false);

    // console.log(planCheck)
    // planCheck.click()

    this.companypaidproductid = this.companypaidproductid.filter(
      (item: any) => item !== undefined && item !== null
    );

    let privateHealth = this.companypaidproductid.filter(
      (item: any) => item.packageId == 5
    );
    const dom: HTMLElement = this.elementRef.nativeElement;


    privateHealth.forEach((element: any, index: any) => {


      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + element.id);
        // this.renderer.selectRootElement("#plancheck" + element.id).click()



        if (element.isBundle) {



          let productKeyArray: any = Object.keys(element.productAddonss)


          for (let productkey of productKeyArray) {
            //console.log(productkey)
            //console.log(element.productAddonss)
            //console.log(productKeyArray)
            for (let i = 0; i < element.productAddonss[productkey].length; i++) {
              //console.log(element.productAddonss[productkey][i])
              let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
              //console.log(coverage)
              if (coverage && coverage != "DIRECT") {
                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    coverage;
                  if (element.package_id == 5) {
                    const targetElement = this.renderer.selectRootElement(elementSelector, true); // Use the second argument 'true' to avoid throwing an error if the element is not found
                    targetElement.click();

                  }
                  else {
                    const targetElement = this.renderer.selectRootElement(elementSelector, true); // Use the second argument 'true' to avoid throwing an error if the element is not found
                    targetElement.click();
                    break;
                  }

                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + coverage).click()

              }
              else {

                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    element.productAddonss[productkey][i].planCoverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true); // Use the second argument 'true' to avoid throwing an error if the element is not found
                  targetElement.click();
                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + element.productAddonss[productkey][i].planCoverage).click()

              }

            }

          }



        }
        else {
          this.renderer.selectRootElement("#plancheck" + element.id).click()
        }



      }, 100);

    });


    let optionumber = this.optionNumberInput.nativeElement.value;


    for (let i = 1; i <= optionumber; i++) {
      // $(".optionselectionmethod-" + i + ":checked").prop("checked", false);
      const radioButton = this.renderer.selectRootElement(".optionselectionmethod-" + i + ":checked", true);
      this.renderer.setProperty(radioButton, 'checked', false);

    }
  }
  public planoptionselection(event: any, optionvalue: any, optionid: any, optionvalueid: any, index: any, className: any) {

    let obj = {
      id: optionid,
    }

    this.planoptionsValues.push(obj)

    const radioButton = this.renderer.selectRootElement(".optionselectionmethod-" + optionid);
    this.renderer.setProperty(radioButton, 'checked', false);



    const elements = document.querySelectorAll(`.${className}` + optionid);
    elements.forEach((element: Element) => {
      this.renderer.setProperty(element, 'checked', false);
    });



    const radioButtonID = this.renderer.selectRootElement("#planselectionvalue-" + optionvalueid + "-" + optionid, true);
    this.renderer.setProperty(radioButtonID, 'checked', true);


    this.optionmessage = "";
  }
  public confirmoptionsselection() {
    // let optionumber = $("#optionumber").val();

    // let optionumber: any = this.optionstitle
    // //this.consoleMessage($("#plandetailsobj").val())

    // let plandetailsobj = this.plandetailsobjvalue.split("##");



    // let array = [];

    // let optionarray = [];


    // let checkvalue = true;

    // for (let i = 1; i <= optionumber; i++) {
    //   checkvalue = checkvalue && this.planoptionsValues.val();
    // }

    // if (!checkvalue) {
    //   this.optionmessage = this.lang.Please_select_all_plan_options;
    //   return;
    // } else {
    //   this.optionmessage = "";
    // }

    // // jQuery("#showplanoptions-modal").modal("hide");

    // this.planOptionsModel = false


    // for (let i = 1; i <= optionumber; i++) {
    //   let optionobj: any = {};

    //   let selectedOptionValues = JSON.parse(this.planoptionsValues)

    //   // ////this.consoleMessage(selectedOptionValues)
    //   optionobj = selectedOptionValues;

    //   optionobj.name = selectedOptionValues.planOptionName;
    //   optionobj.value = selectedOptionValues.value;
    //   optionobj.planOptionsValueId = selectedOptionValues.planOptionsValueId;

    //   optionarray.push(optionobj);
    // }
    let optionumber: any = this.optionNumberInput.nativeElement.value;


    let plandetailsobj = this.optionPlanDetailsObj.nativeElement.value.split("##");



    let array = [];

    let optionarray = [];


    let checkvalue = true;



    //     for (let i = 1; i <= optionumber; i++) {

    //  checkvalue = checkvalue &&   this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value;
    //     }

    for (let i = 1; i <= optionumber; i++) {
      // //console.log(this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value)
      // checkvalue = checkvalue &&   this.renderer.selectRootElement(".optionselectionmethod-" + i +":checked").value;
      const dom: HTMLElement = this.elementRef.nativeElement;
      const selector = `.optionselectionmethod-${i}:checked`;
      const element = dom.querySelector(selector);

      if (!element) {
        checkvalue = false; // Set to false if any element is not checked
        break; // Exit the loop early since we found an unchecked element
      }
    }
    if (!checkvalue) {

      this.optionmessage = this.lang.Please_select_all_plan_options;
      return;
    } else {
      this.optionmessage = "";
    }

    // jQuery("#showplanoptions-modal").modal("hide");

    this.planOptionsModel = false

    $('#showplanoptions-modal').modal('hide');


    for (let i = 1; i <= optionumber; i++) {
      let optionobj: any = {};

      let selectedOptionValues = JSON.parse(
        this.renderer.selectRootElement(".optionselectionmethod-" + i + ":checked").value
      );

      optionobj = selectedOptionValues;

      optionobj.name = selectedOptionValues.planOptionName;
      optionobj.value = selectedOptionValues.value;
      optionobj.planOptionsValueId = selectedOptionValues.planOptionsValueId;

      optionarray.push(optionobj);
    }
    // let plandetailsobj = $("#plandetailsobj").val().split(",");

    let obj = {
      isBundle: "true",
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: optionarray || [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
        // elementcv.checked =false
      }
    }

    let obj1 = {}
    let e = {}
    //this.consoleMessage(obj)

    console.log(this.planobjdataobj)
    console.log(this.planobjdata)

    let selectplans = JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";

    // for (let i = 0; i < selectplans.length; i++) {

    //   if (selectplans[i].groupName == "Complete Executive Care") {
    //     selectplans.splice(i, 1)
    //   }

    // }
    // sessionStorage.setItem("plansummary", JSON.stringify(selectplans));


    setTimeout(() => {
      // this.addtoplansummary(obj, this.planobjdata, this.elementcvValues)
      let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

      for (let i = 0; i < planSummary.length; i++) {
        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = obj.options
        }
      }

      console.log(planSummary)
      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
      sessionStorage.setItem('plansummarymain', JSON.stringify(planSummary));
    }, 1000);






  }
  // public confirmoptionsselection() {
  //   let optionumber = $('#optionumber').val();
  //   this.logger.log('plandetailsobj', $('#plandetailsobj').val());

  //   let plandetailsobj = $('#plandetailsobj').val().split('##');

  //   let array = [];

  //   let optionarray = [];

  //   let checkvalue = true;

  //   for (let i = 1; i <= optionumber; i++) {
  //     checkvalue =
  //       checkvalue && $('.optionselectionmethod-' + i + ':checked').val();
  //   }

  //   if (!checkvalue) {
  //     this.optionmessage = 'Please select all plan options';
  //     return;
  //   } else {
  //     this.optionmessage = '';
  //   }

  //   $('#showplanoptions-modal').hide();

  //   if (sessionStorage.getItem('maritalStatus') == plandetailsobj[2]) {
  //   } else {
  //     if (sessionStorage.getItem('brokerType') == 'EXECUTIVE') {
  //       $('#insuranceconfirmation-modal').modal('show');
  //     }
  //   }

  //   for (let i = 1; i <= optionumber; i++) {
  //     let optionobj: any = {};

  //     let selectedOptionValues = JSON.parse(
  //       $('.optionselectionmethod-' + i + ':checked').val()
  //     );
  //     // //this.logger.log(selectedOptionValues)
  //     optionobj = selectedOptionValues;

  //     optionobj.name = selectedOptionValues.planOptionName;
  //     optionobj.value = selectedOptionValues.value;
  //     optionobj.planOptionsValueId = selectedOptionValues.planOptionsValueId;

  //     optionarray.push(optionobj);
  //   }

  //   // let plandetailsobj = $("#plandetailsobj").val().split(",");

  //   let obj = {
  //     // enrollmentDate: moment(
  //     //   this.userForm.get('planEnrollmentDate')?.value,
  //     //   'DD-MMM-YYYY'
  //     // ).format('YYYY-MM-DD'),
  //     enrollmentDate: sessionStorage.getItem('enrollmentdate'),
  //     // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
  //     name: plandetailsobj[14],
  //     details: plandetailsobj[0],
  //     packagename: plandetailsobj[0],
  //     groupName: plandetailsobj[1],
  //     amount: parseFloat(plandetailsobj[3]),
  //     planCoverage: plandetailsobj[2],
  //     planPrice: parseFloat(plandetailsobj[3]),
  //     amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
  //     gst:
  //       plandetailsobj[4] == null ||
  //         plandetailsobj[4] == '' ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == 'null'
  //         ? 0
  //         : parseFloat(plandetailsobj[4]),
  //     hst:
  //       plandetailsobj[5] == null ||
  //         plandetailsobj[5] == '' ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == 'null'
  //         ? 0
  //         : parseFloat(plandetailsobj[5]),
  //     pst:
  //       plandetailsobj[6] == null ||
  //         plandetailsobj[6] == '' ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == 'null'
  //         ? 0
  //         : parseFloat(plandetailsobj[6]),
  //     qst:
  //       plandetailsobj[17] == null ||
  //         plandetailsobj[17] == '' ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == 'null'
  //         ? 0
  //         : parseFloat(plandetailsobj[17]),
  //     gstCheck:
  //       plandetailsobj[4] == null ||
  //         plandetailsobj[4] == '' ||
  //         plandetailsobj[4] == undefined ||
  //         plandetailsobj[4] == 'null'
  //         ? false
  //         : true,
  //     hstCheck:
  //       plandetailsobj[5] == null ||
  //         plandetailsobj[5] == '' ||
  //         plandetailsobj[5] == undefined ||
  //         plandetailsobj[5] == 'null'
  //         ? false
  //         : true,
  //     pstCheck:
  //       plandetailsobj[6] == null ||
  //         plandetailsobj[6] == '' ||
  //         plandetailsobj[6] == undefined ||
  //         plandetailsobj[6] == 'null'
  //         ? false
  //         : true,
  //     qstCheck:
  //       plandetailsobj[17] == null ||
  //         plandetailsobj[17] == '' ||
  //         plandetailsobj[17] == undefined ||
  //         plandetailsobj[17] == 'null'
  //         ? false
  //         : true,
  //     id: parseFloat(plandetailsobj[7]),
  //     fusebillPlanID:
  //       plandetailsobj[8] == null ||
  //         plandetailsobj[8] == '' ||
  //         plandetailsobj[8] == undefined ||
  //         plandetailsobj[8] == 'null'
  //         ? 0
  //         : parseFloat(plandetailsobj[8]),
  //     planFrequencyID:
  //       plandetailsobj[9] == null ||
  //         plandetailsobj[9] == '' ||
  //         plandetailsobj[9] == undefined ||
  //         plandetailsobj[9] == 'null'
  //         ? 0
  //         : parseFloat(plandetailsobj[9]),
  //     optIn: plandetailsobj[10] == 'true' ? true : false,
  //     planname: plandetailsobj[14],
  //     planLevel: parseInt(plandetailsobj[15]),
  //     packageId: parseInt(plandetailsobj[16]),
  //     options: optionarray || [],
  //     //  "disallowedPlanLevels":plandetailsobj[11]
  //   };
  //   if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
  //     if (plandetailsobj[11].includes(plandetailsobj[12])) {
  //       // elementcv.checked =false
  //     }
  //   }

  //   let obj1 = {};
  //   this.logger.log(obj);
  //   let e = {}
  //   this.addtoplansummary(obj, this.planobjdata, this.elementcvValues);
  // }

  // public closeoptionsselection() {
  //   $('#showplanoptions-modal').hide()
  //   let plandetailsobj = $('#plandetailsobj').val().split('##');

  //   this.logger.log(plandetailsobj[19]);
  //   // this.logger.log(plandetailsobj[20])

  //   $('#plancheck' + plandetailsobj[19]).prop('checked', false);

  //   let optionumber = $('#optionumber').val();

  //   $('#showplanoptions-modal').hide()

  //   for (let i = 1; i <= optionumber; i++) {
  //     $('.optionselectionmethod-' + i + ':checked').prop('checked', false);
  //   }
  // }
  selectTab(tabName: string): void {
    this.planssummary = JSON.parse(sessionStorage.getItem("plansummarymain"));

    this.selectedTab = tabName;
    //this.logger.log(this.planssummary);

    if (tabName == 'tab1') {
      this.plancheckboxcheck = 100000

      const elements = this.elementRef.nativeElement.getElementsByClassName('imgdisplay1');
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none';
        // elements[i].style.display = 'inline';
      }
      const elements1 = this.elementRef.nativeElement.getElementsByClassName('imgdisplay2');
      for (let i = 0; i < elements1.length; i++) {
        elements1[i].style.display = 'none';
        // elements1[i].style.display = 'inline';
      }
    }

    //    if (this.planssummary) {

    //      this.planssummary.forEach((element,index) => {


    //        setTimeout(() => {
    //          const dom: HTMLElement = this.elementRef.nativeElement;
    //          const plan: any = dom.querySelector("#plancheck" + element.id);
    //          // //this.logger.log(element)
    //          if (element.options && element.options.length > 1) {
    //            element.products.forEach((products,index) => {
    //              $("#plancheck" + products.id).click();
    //            })
    // element.options.forEach(element1 => {

    //  setTimeout(() => {
    //    $("#planselectionvalue"+"-"+ element1.id+"-"+element1.planOptionsId).prop("checked", true);
    //   this.confirmoptionsselection()
    //  },10)


    // });

    //          } else {
    //            // $("#plancheck" + element.id).click();
    //            element.products.forEach((products,index) => {
    //              $("#plancheck" + products.id).click();
    //            })




    //            // $("#plancheck" + element.id).prop("checked", true);
    //          }

    //        }, 100);


    //      });


    //    }
    //     this.selectedTab = tabName;



    if (tabName == 'tab2') {

      // return false;
      let data: any = JSON.parse(sessionStorage.getItem("plansummary") || '[]');
      let obj = {};

      // if (data) {

      //   data.forEach((element: any, index: any) => {
      //     obj = {
      //       planid: element.id,
      //     };

      //     setTimeout(() => {

      //       const dom: HTMLElement = this.elementRef.nativeElement;
      //       const plan: any = dom.querySelector("#plancheck" + element.id);


      //       if (element.options && element.options.length > 0) {

      //         if (element.isBundle) {
      //           // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


      //           // this.renderer.setProperty(planCheck, 'checked', true);
      //           const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
      //           this.renderer.setProperty(plan, 'checked', true);

      //           if (element.paidByCompany == 1) {
      //             const dom: HTMLElement = this.elementRef.nativeElement;
      //             // const plan: any = dom.querySelector("#plancheck" + element.id);




      //             if (element.coverage) {
      //               const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
      //               if (plan) {
      //                 plan.disabled = true;
      //               }
      //             }
      //             else {
      //               const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
      //               if (plan) {
      //                 plan.disabled = true;
      //               }
      //             }
      //           }


      //         } else {
      //           element.products.forEach((products: any, index: any) => {
      //             // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


      //             // this.renderer.setProperty(planCheck, 'checked', true);
      //             if (element.coverage) {
      //               const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


      //               this.renderer.setProperty(plan, 'checked', true);
      //             }
      //             else {
      //               const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
      //               this.renderer.setProperty(planCheck, 'checked', true);

      //             }

      //             if (element.paidByCompany == 1) {
      //               const dom: HTMLElement = this.elementRef.nativeElement;
      //               // const plan: any = dom.querySelector("#plancheck" + products.planLevel);


      //               if (element.coverage) {
      //                 const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
      //                 if (plan) {
      //                   plan.disabled = true;
      //                 }
      //               }
      //               else {
      //                 const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
      //                 if (plan) {
      //                   plan.disabled = true;
      //                 }
      //               }
      //             }


      //           })
      //         }

      //       }

      //       else {

      //         if (element.isBundle) {
      //           const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);


      //           this.renderer.setProperty(plan, 'checked', true);
      //           // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

      //           // // console.log(planCheck)
      //           // this.renderer.setProperty(planCheck, 'checked', true);

      //           if (element.paidByCompany == 1) {
      //             const dom: HTMLElement = this.elementRef.nativeElement;
      //             if (element.coverage) {
      //               const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
      //               if (plan) {
      //                 plan.disabled = true;
      //               }
      //             }
      //             else {
      //               const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
      //               if (plan) {
      //                 plan.disabled = true;
      //               }
      //             }
      //           }


      //         }
      //         else {
      //           element.products.forEach((products: any, index: any) => {
      //             // $("#plancheck" + products.id).click();
      //             // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
      //             //   console.log(planCheck)
      //             // this.renderer.setProperty(planCheck, 'checked', true);
      //             if (element.coverage) {
      //               const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


      //               this.renderer.setProperty(plan, 'checked', true);
      //             }
      //             else {
      //               const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
      //               this.renderer.setProperty(planCheck, 'checked', true);

      //             }
      //             if (element.paidByCompany == 1) {
      //               const dom: HTMLElement = this.elementRef.nativeElement;
      //               if (element.coverage) {
      //                 const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
      //                 if (plan) {
      //                   plan.disabled = true;
      //                 }
      //               }
      //               else {
      //                 const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
      //                 if (plan) {
      //                   plan.disabled = true;
      //                 }
      //               }
      //             }
      //           })
      //         }
      //       }

      //       // $("#plancheck" + element.id).prop("checked", true);
      //       // plan.checked =true
      //     }, 100);

      //     // this.plancheckarray.push(element.id)
      //   });

      // }

      if (data) {

        data.forEach((element: any, index: any) => {
          obj = {
            planid: element.id,
          };

          setTimeout(() => {

            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + element.id);


            if (element.options && element.options.length > 0) {

              if (element.isBundle) {
                // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


                // this.renderer.setProperty(planCheck, 'checked', true);
                const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                this.renderer.setProperty(plan, 'checked', true);

                if (element.paidByCompany == 1) {
                  const dom: HTMLElement = this.elementRef.nativeElement;
                  // const plan: any = dom.querySelector("#plancheck" + element.id);




                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                  else {
                    const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                }
                if (element.disallowedPlanLevels != null) {
                  let disallowed_plans = element.disallowedPlanLevels.split(',');
                  const dom1: HTMLElement = this.elementRef.nativeElement;
                  for (let i = 0; i < disallowed_plans.length; i++) {
                    // console.log(disallowed_plans[i]);
                    // console.log(disallowed_plans[i]);
                    setTimeout(() => {
                      let elem: any = dom1.querySelectorAll(`#plancheck${disallowed_plans[i]}`)

                      console.log(elem)
                      elem.forEach((products: any, index: any) => {
                        if (products != null) {
                          if (!products.disabled) {

                            products.disabled = true
                          }
                        }
                      })

                    }, 100);

                  }
                }

              } else {
                element.products.forEach((products: any, index: any) => {
                  // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


                  // this.renderer.setProperty(planCheck, 'checked', true);
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                    this.renderer.setProperty(plan, 'checked', true);
                  }
                  else {
                    const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                    this.renderer.setProperty(planCheck, 'checked', true);

                  }

                  if (element.paidByCompany == 1) {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    // const plan: any = dom.querySelector("#plancheck" + products.planLevel);


                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                    else {
                      const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                  }


                })
                if (element.disallowedPlanLevels != null) {
                  let disallowed_plans = element.disallowedPlanLevels.split(',');
                  const dom1: HTMLElement = this.elementRef.nativeElement;
                  for (let i = 0; i < disallowed_plans.length; i++) {
                    // console.log(disallowed_plans[i]);
                    // console.log(disallowed_plans[i]);
                    setTimeout(() => {
                      let elem: any = dom1.querySelectorAll(`#plancheck${disallowed_plans[i]}`)

                      console.log(elem)
                      elem.forEach((products: any, index: any) => {
                        if (products != null) {
                          if (!products.disabled) {

                            products.disabled = true
                          }
                        }
                      })

                    }, 100);

                  }
                }
              }

            }

            else {

              if (element.isBundle) {
                const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);


                this.renderer.setProperty(plan, 'checked', true);
                // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

                // // //console.log(planCheck)
                // this.renderer.setProperty(planCheck, 'checked', true);

                if (element.paidByCompany == 1) {
                  const dom: HTMLElement = this.elementRef.nativeElement;
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + element.id + ".coverage" + element.coverage);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                  else {
                    const plan = this.renderer.selectRootElement("#plancheck" + element.id, true);
                    if (plan) {
                      plan.disabled = true;
                    }
                  }
                }

                if (element.disallowedPlanLevels != null) {
                  let disallowed_plans = element.disallowedPlanLevels.split(',');
                  const dom1: HTMLElement = this.elementRef.nativeElement;
                  for (let i = 0; i < disallowed_plans.length; i++) {
                    // console.log(disallowed_plans[i]);
                    // console.log(disallowed_plans[i]);
                    setTimeout(() => {
                      let elem: any = dom1.querySelectorAll(`#plancheck${disallowed_plans[i]}`)

                      console.log(elem)
                      elem.forEach((products: any, index: any) => {
                        if (products != null) {
                          if (!products.disabled) {

                            products.disabled = true
                          }
                        }
                      })

                    }, 100);

                  }
                }
              }
              else {
                element.products.forEach((products: any, index: any) => {
                  // $("#plancheck" + products.id).click();
                  // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                  //   //console.log(planCheck)
                  // this.renderer.setProperty(planCheck, 'checked', true);
                  if (element.coverage) {
                    const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);


                    this.renderer.setProperty(plan, 'checked', true);
                  }
                  else {
                    const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                    this.renderer.setProperty(planCheck, 'checked', true);

                  }
                  if (element.paidByCompany == 1) {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    if (element.coverage) {
                      const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                    else {
                      const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
                      if (plan) {
                        plan.disabled = true;
                      }
                    }
                  }
                })

                if (element.disallowedPlanLevels != null) {
                  let disallowed_plans = element.disallowedPlanLevels.split(',');
                  const dom1: HTMLElement = this.elementRef.nativeElement;
                  for (let i = 0; i < disallowed_plans.length; i++) {
                    // console.log(disallowed_plans[i]);
                    // console.log(disallowed_plans[i]);
                    setTimeout(() => {
                      let elem: any = dom1.querySelectorAll(`#plancheck${disallowed_plans[i]}`)

                      console.log(elem)
                      elem.forEach((products: any, index: any) => {
                        if (products != null) {
                          if (!products.disabled) {

                            products.disabled = true
                          }
                        }
                      })

                    }, 100);

                  }
                }
              }
            }

            // $("#plancheck" + element.id).prop("checked", true);
            // plan.checked =true
          }, 100);

          // this.plancheckarray.push(element.id)
        });

      }

      let dataLife: any = JSON.parse(sessionStorage.getItem("plansummaryLife") || '[]');

      if (dataLife) {

        dataLife.forEach((element: any, index: any) => {

          setTimeout(() => {

            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector("#planCheckLife" + element.planCoverage+"-"+coverage);



            element.products.forEach((products: any, index: any) => {
              // $("#plancheck" + products.id).click();
              if (element.coverage == 'MEMBER') {
                element.coverage = 'MEMBER'
                const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

                this.renderer.setProperty(planCheck, 'checked', true);
              } else {
                element.coverage = 'SPOUSE'
                const planCheck = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + element.coverage, true);

                this.renderer.setProperty(planCheck, 'checked', true);
                const planCheck1 = this.renderer.selectRootElement("#planCheckLife" + element.planCoverage + "-" + 'MEMBER', true);

                this.renderer.setProperty(planCheck1, 'checked', true);
              }

            })


            // $("#plancheck" + element.id).prop("checked", true);
            // plan.checked =true
          }, 100);

          // this.plancheckarray.push(element.id)
        });

      }
      // this.cartcheckvalue=false;
      // const elements = this.elementRef.nativeElement.getElementsByClassName('imgdisplay2');
      // for (let i = 0; i < elements.length; i++) {
      //   elements[i].style.display = 'none';
      //   // elements[i].style.display = 'inline';
      // }
      // sessionStorage.removeItem('studentsPlansArray');
      // this.planAmount=0;
      // sessionStorage.removeItem('totalAmount');

      // sessionStorage.setItem('totalAmount', this.planAmount);
      // setTimeout(() => {
      //   let selectedstudentPlans = JSON.parse(sessionStorage.getItem("allproducts") ?? "[]");
      //   // selectedstudentPlans.forEach((element: any) => {
      //   //   document.getElementById("plancheck" + element.id)?.click();
      //   //   // $('#plancheck'+element.id).click();
      //   // });
      //   sessionStorage.setItem('allproducts', '');
      // }, 100)

    }

  }

  termAndConditionsLoading(event: any) {
    this.pdfvisibletermsandcodionsmodel = false;
  }
  AdviserDisclosureloading(event: any) {
    this.pdfvisibleadvisouredisclosure = false;
  }

  padAgrementLoading(event: any) {
    this.padAgrementLoad = false;
  }

  padAgrementWithOutSignLoading(evenr: any) {
    this.withSignLoad = false;
  }
  get userFormControl() {
    // this.logger.log("form controls: "+this.userForm)
    return this.userForm.controls;
  }
  get childInfoControl() {
    return this.childFormGroup.controls;
  }

  public closeprovinceinfo() {
    this.userFormControl['province'].reset();
    this.userFormControl['province'].setValue('');
    //  document?.getElementById('Province')?.value='';
    const elements = this.elementRef.nativeElement.getElementsByClassName('ProvinceClass');
    for (let i = 0; i < elements.length; i++) {
      elements.value = '';
    }
  }
  public childrenPopupClose() {
    this.childFormGroup.reset();
    this.childFormGroup.get('childInfoGender')?.setValue('Select');
    // this.creditCardForm.get('enrollmentSummaryExpirymonth')?.setValue('01');
    this.childFormGroup.clearValidators();
    this.childFormGroup.updateValueAndValidity();
    // this.childFormGroup.get('childInfoGender')?.setValue('Select');
    this.graducationdaycheck = false;
  }

  pipeFunction = (
    a: KeyValue<string, [string]>,
    b: KeyValue<string, [string]>
  ): number => {
    return 0;
  };

  over() { }
  // public autoSelectCompanyPaidPlans() {
  //   // alert("auto select now")
  //   let packagesInBlocks: any = JSON.parse(sessionStorage.getItem("planDetailsArrayBlock"));
  //   this.logger.log(this.companypaidproductid)



  //   this.companypaidproductid.forEach((element, index) => {


  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       const plan: any = dom.querySelector("#plancheck" + element.id);

  //       $("#plancheck" + element.id).click();
  //       // $("#plancheck" + element.id).disabled = true;

  //     }, 100);

  //   });
  //   setTimeout(() => {
  //     let selectplans =
  //       JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

  //     this.logger.log(selectplans)
  //     selectplans.forEach((element) => {
  //       if (element.paidByCompany == 1) {
  //         element.products.forEach((product, index) => {
  //           const dom: HTMLElement = this.elementRef.nativeElement;
  //           const plan: any = dom.querySelector("#plancheck" + product.id);

  //           if (plan) {
  //             // plan.click()
  //             plan.disabled = true;
  //           }
  //         })

  //       }
  //     });
  //   }, 1000);

  //   this.mainarray.forEach((element) => {
  //     element.groups.forEach((group) => {
  //       group.plans.forEach((plan) => {
  //         Object.keys(plan.productAddonss).forEach((key) => {
  //           // plan.productAddonss[key].forEach((product) => {
  //           const keys = ['planCoverage'];
  //           const filteredData = plan.productAddonss[key].filter((value, index, self) =>
  //             self.findIndex(v => keys.every(k => v[k] === value[k])) === index
  //           );
  //           plan.productAddonss[key] = filteredData
  //           // });
  //         });
  //       });

  //     });
  //   });
  //   this.logger.log(this.mainarray)

  //   this.mainarray.forEach((element) => {
  //     element.groups.forEach((group) => {
  //       // //this.logger.log(element.groups)
  //       if (element.groups.length == 1) {
  //         // //this.logger.log(group)
  //         if (group.categorization.paidByCompany == 1) {
  //           group.plans.forEach((plan) => {
  //             Object.keys(plan.productAddonss).forEach((key) => {
  //               plan.productAddonss[key].forEach((product) => {
  //                 this.disabledcompanypaidproductid.push({ id: product.id });

  //                 $("#plancheck" + product.id).prop("checked", false);
  //               });
  //             });
  //           });
  //         }
  //       }
  //     });
  //   });



  //   this.disabledcompanypaidproductid.forEach((element, index) => {


  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       const plan: any = dom.querySelector("#plancheck" + element.id);

  //       // plan.disabled=true


  //     }, 100);

  //   });


  //   this.toastrService.success("Company paid plans are all selected", "");
  // }


  public autoSelectCompanyPaidPlans() {

    // console.log(this.companypaidproductid)
    this.companypaidproductid = this.companypaidproductid.filter(
      (item: any) => item !== undefined && item !== null
    );

    var result = this.companypaidproductid.reduce((unique: any, o: any) => {
      if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log(result);

    // this.companypaidproductid.forEach((element, index) => {

    result.forEach((element: any, index: any) => {


      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + element.id);
        // this.renderer.selectRootElement("#plancheck" + element.id).click()



        if (element.isBundle) {
          let productKeyArray: any = Object.keys(element.productAddonss)
          for (let productkey of productKeyArray) {
            //console.log(productkey)
            //console.log(element.productAddonss)
            //console.log(productKeyArray)
            for (let i = 0; i < element.productAddonss[productkey].length; i++) {
              //console.log(element.productAddonss[productkey][i])
              let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
              console.log(coverage)
              if (coverage && coverage != "DIRECT") {
                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    coverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  console.log(targetElement)
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                    break;
                  }
                  else {
                    targetElement.click();
                    break;
                  }




                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + coverage).click()

              }
              else {

                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    element.productAddonss[productkey][i].planCoverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  console.log(targetElement)
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                  }
                  else {
                    targetElement.click();
                  }

                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + element.productAddonss[productkey][i].planCoverage).click()

              }

            }

          }

          // Object.keys(element.productAddonss).forEach((key) => {
          //   element.productAddonss[key].forEach((product: any) => {
          //    //console.log(product)
          //    let coverage = element.companyPaidCoverage?.replace("SELECTIVE_","")
          //    //console.log(coverage)
          //   //  //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage))
          //   //   // //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + covergae))
          //     // this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage).click()

          //     if(coverage!="DIRECT"){
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage).click()

          //     }
          //     else{
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + product.planCoverage).click()
          //     }

          //   })
          // })

        }
        else {
          this.renderer.selectRootElement("#plancheck" + element.id).click()
        }



      }, 100);

    });


    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

      //this.consoleMessage(selectplans)

      //console.log(selectplans)
      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          element.products.forEach((product: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + product.id);

            if (plan) {
              plan.disabled = true;
            }
          })

        }
      });
    }, 2000);
    // this.mainarrayFinal.forEach((element: any) => {
    //   element.groups.forEach((group: any) => {
    //     group.plans.forEach((plan: any) => {
    //       if (plan.productAddonss) {
    //         Object.keys(plan.productAddonss).forEach((key) => {
    //           // plan.productAddonss[key].forEach((product) => {
    //           const keys = ['planCoverage'];
    //           const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
    //             self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
    //           );
    //           plan.productAddonss[key] = filteredData
    //           // });
    //         });
    //       }
    //     });

    //   });
    // });
    //this.consoleMessage(this.mainarray)

    this.mainarrayFinal.forEach((element: { groups: any[]; }) => {
      element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
        // //this.consoleMessage(element.groups)
        if (element.groups.length == 1) {
          // //this.consoleMessage(group)
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
              Object.keys(plan.productAddonss).forEach((key) => {
                plan.productAddonss[key].forEach((product: { id: any; }) => {
                  this.disabledcompanypaidproductid.push({ id: product.id });
                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                  // $("#plancheck" + product.id).prop("checked", false);
                });
              });
            });
          }
        }
      });
    });


    this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        const plan: any = dom.querySelector("#plancheck" + element.id);

        // plan.disabled=true
      }, 100);
    });
    // if (packagesInBlocks && packagesInBlocks.paidByCompany) {
    //   for (const cpPackage of packagesInBlocks.paidByCompany) {
    //     for (const cpGroup of cpPackage.groupsCP) {
    //       for (const cpPlan of cpGroup.plans) {

    //         for(const product1 in cpPlan.productAddonss){
    //           //this.consoleMessage(product1)
    //           //this.consoleMessage(cpPlan.productAddonss[product1])
    //           $("#plancheck"+cpPlan.productAddonss[product1][0].id).click();

    //         }

    //       }
    //     }
    //   }
    // }
    // this.toastrService.success("Company paid plans are all selected", "");

  }

  public paymentpage(tabid: number) {
    let benficiryData = JSON.parse(sessionStorage.getItem('addbenificaryData') || '[]');
    let inputData = JSON.parse(sessionStorage.getItem('Data') || '[]');
    let Data = JSON.parse(sessionStorage.getItem('plansummarymain') || '[]');
    let iafgData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    let phrPlanSelected = Data.filter((p: any) => p.packageId == 10);
    let healthPlanSelected = Data.filter((p: any) => p.packageId == 1);
    let iafgDataSelectedPlan = iafgData.filter((p: any) => p.packageId == 13);
    let iafgTermplanCheck = iafgData.filter((p: any) => p.planLevel == 44);
    let benficiaryList = JSON.parse(sessionStorage.getItem('addbenificaryData') || '[]')
    this.paymentemail = inputData.email || this.userForm.get('email')?.value
    this.paymentfirstname = this.capitalize(inputData.firstName) || this.userForm.get('firstName')?.value;
    this.paymentlastName = this.capitalize(inputData.lastName) || this.userForm.get('lastName')?.value

    let iafgTermplanSpouseCheck = iafgData.filter((p: any) => p.coverage == 'MEMBER & SPOUSE');


    let completeExecutiveplan = Data.filter((p: any) => p.planLevel == 18);
    let lavieplancheck = Data.filter((p: any) => p.planproductname.includes("La Vie"));
    // alert(this.FormbrokerType)

    if (completeExecutiveplan.length > 0) {
      if (completeExecutiveplan && completeExecutiveplan[0].options && completeExecutiveplan[0].options.length > 0) {

      } else {
        // this.planOptionsModel = true
        this.showoptions = true;
        $('#showplanoptions-modal').modal('show');

        return false
      }
    }

    if (lavieplancheck && lavieplancheck.length > 0) {
      if (completeExecutiveplan && completeExecutiveplan.length > 0) {

      }
      else {
        Swal.fire({
          title: this.lang.Info,
          text: "Select Complete Executive Care Plan along with La Vie"
        })
        return false
      }

    }

    if (iafgTermplanCheck && iafgTermplanCheck.length > 0) {

      if (this.addbenificaryData.length > 0) {
        this.benficiary = false;

        const validateBeneficiaries = this.addbenificaryData.reduce((acc: any, obj: any) => {
          const compositeKey = `${obj.customerType}_${obj.type}`;
          if (!acc[compositeKey]) {
            acc[compositeKey] = 0;
          }
          acc[compositeKey] += parseFloat(obj.percentage);
          return acc;
        }, {});

        let beneficiaryError = "";
        for (const key in validateBeneficiaries) {
          if (validateBeneficiaries.hasOwnProperty(key)) {
            const [customerType, type] = key.split("_");
            //console.log(`The customerType ${customerType} and type ${type} with perc: ${validateBeneficiaries[key]}`);

            if (validateBeneficiaries[key] != 100) {
              beneficiaryError += `CustomerType ${customerType} and type ${type} has percentage issue. \n`
            }
          }
        }




        if (beneficiaryError != "") {
          this.benficiaryCount = true
          this.benficiaryCountMessage = "Distributed percentages must equal 100%, and not more"
          return false;
        }

        else {
          this.benficiary = false
          if (iafgTermplanSpouseCheck.length > 0) {

            if (sessionStorage.getItem("Spousesignature") || "") {
              // this.gotosumamrypageLogic()
            } else {
              this.showSpouseSignature = true
              // this.signatureNeeded = this.signaturePad.isEmpty();


            }
          }
        }


      }


      else {
        this.benficiary = true;
        if (this.addbenificaryData.length > 0) {

        } else {
          this.showBenificiaryForm = true
        }


        return false;

      }

    } else {
      this.addbenificaryData = []
      // this.gotosumamrypageLogic()
    }
    if (inputData.provincial_health_coverage == false) {

      if (phrPlanSelected.length > 0) {
        if (healthPlanSelected.length > 0) {
          if (iafgDataSelectedPlan.length > 0) {

            if (healthPlanSelected.length > 0) {

              if (iafgTermplanCheck.length > 0) {

                var total = 0;
                for (let i = 0; i < benficiryData.length; i++) {
                  total += parseFloat(benficiryData[i].percentage);
                }

                if (!this.beneficiaryError) {
                  this.benficiary = false
                  this.showbenificaryTable = false;
                  this.gotosumamrypageLogic()
                } else {
                  this.benficiary = true
                  this.showbenificaryTable = true;
                  this.showaddmorebenficiary = true;

                }

              }
              else {
                this.gotosumamrypageLogic()
              }



            }
            else {
              Swal.fire({ title: this.lang.Info, text: "Please select a Health & Dental Insurance Plan along with a Life or Critical Insurance Plan." })

            }
          }
          else {
            this.gotosumamrypageLogic()
          }
        }
        else {
          Swal.fire({ title: this.lang.Info, text: "Please select a Provincial Health Replacement Plan along with a Health & Dental Insurance Plan." })


        }

      }


      else {
        if (healthPlanSelected.length > 0) {
          Swal.fire({ title: this.lang.Info, text: "Please select a Provincial Health Replacement Plan." })



        }
        else {
          Swal.fire({ title: this.lang.Info, text: "Please select a Provincial Health Replacement Plan along with a Health & Dental Insurance Plan." })

        }


      }
    }
    else {

      if (iafgDataSelectedPlan.length > 0) {

        if (healthPlanSelected.length > 0) {

          if (iafgTermplanCheck.length > 0) {

            var total = 0;
            for (let i = 0; i < benficiryData.length; i++) {
              total += parseFloat(benficiryData[i].percentage);
            }

            if (!this.beneficiaryError) {
              this.benficiary = false
              this.showbenificaryTable = false;


              this.gotosumamrypageLogic()
            } else {
              this.benficiary = true
              this.showbenificaryTable = true;
              this.showaddmorebenficiary = true;

            }

          }
          else {

            this.gotosumamrypageLogic()
          }



        }
        else {
          // this.ShowModelPopup = true
          // this.ShowModelPopupMessage = this.lang.Please_select_a_Health_Dental_Insurance_Plan_along_with_a_Life_or_Critical_Insurance_Plan;
          // this.ShowModelPopupTitle = this.lang.Info
          this.gotosumamrypageLogic()
        }
      }
      else {
        this.gotosumamrypageLogic()
      }

    }
  }


  public gotosumamrypageLogic() {

    this.paymentfirstname = this.userFormControl?.['givenname'].value;
    this.paymentfirstname = this.userFormControl?.["lastname"].value;
    this.paymentemail = this.userFormControl?.["email"].value.toLowerCase();

    // if (sessionStorage.getItem("homeAddress") == "true") {
    //   this.homeaddresscheckvalue = true;
    //   this.aptcheck = this.userForm.get("apt_suite").value;
    //   this.streetaddress = this.userForm.get("streetaddress").value;
    //   this.streetaddress2 = this.userForm.get("streetaddressline2").value;
    //   this.city = this.userForm.get("city").value;
    //   this.province = this.userForm.get("province").value;
    //   this.postalcode = this.userForm.get("postalcode").value;

    //   this.paymentForm.get("aptcheck").disable();
    //   this.paymentForm.get("streetaddress").disable();
    //   this.paymentForm.get("streetaddressline2").disable();
    //   this.paymentForm.get("city").disable();
    //   this.paymentForm.get("province").disable();
    //   this.paymentForm.get("postalcode").disable();
    // }
    // this.paymenttab = 0;

    // jQuery("html, body").scrollTop(0);


    //'



    this.homeaddresscheckvalue = false;
    this.homeaddressEnrollmentVal = false;
    this.planssummarymain = JSON.parse(sessionStorage.getItem("plansummarymain") ?? "[]") || "";
    this.planssummaryopt = JSON.parse(sessionStorage.getItem("plansummaryopt") ?? "[]");

    let healthplan = []
    let healthplanvol = []
    this.studentplanssummarymain =
      JSON.parse(sessionStorage.getItem("plansummarymain") ?? "[]").sort((a: { id: any; }, b: { id: any; }) => a.id - b.id) || "";

    const combinedArray = [];
    const groupedByParent: any = {};

    for (const obj of this.studentplanssummarymain) {

      const name = obj.name;

      const products = obj.products;
      if (!groupedByParent[name]) {
        groupedByParent[name] = [];
      }
      groupedByParent[name] = groupedByParent[name].concat(products);
    }

    for (const name in groupedByParent) {
      combinedArray.push({ name, products: groupedByParent[name] });
    }

    this.studentplanssummarymain1 = combinedArray;
    setTimeout(() => {
      this.allproducts = JSON.parse(sessionStorage.getItem("allproducts") ?? "[]");
      var total = 0;
      for (let i = 0; i < this.allproducts.length; i++) {
        total += this.allproducts[i].calculatedTax?.total;
      }
      this.logger.log(total);
      this.planAmount = this._decimalPipe?.transform(total, "1.2-2")?.replace(/,/g, "");
      sessionStorage.setItem("totalAmount", this.planAmount);
      this.cartcheckvalue = this.planAmount > 0 ? true : false;
      // alert(this.planAmount)
    }, 1000);


    setTimeout(() => {
      this.signaturePadCC = new SignaturePad(this.signaturePadCanvasEl?.nativeElement);
      this.padAggsignaturePadCC = new SignaturePad(this.padAgreementSignaturePadCanvasEl?.nativeElement);
    }, 1000);

    this.enrollmentForm.reset();
    // this.creditCardForm.reset();
    this.enrollmentForm.get('enrollmentSummaryExpirymonth')?.setValue('');
    this.enrollmentForm.get('enrollmentSummaryExpiryyear')?.setValue('');
    this.bankPayForm.reset();
    this.paymentMethodSelectCC = true;
    this.enrollmentBankDetailedVerify = false;
    this.bankDetailsNames = "";
    const elements = this.elementRef.nativeElement.getElementsByClassName('imgdisplay2');
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.display = 'block';
      elements[i].style.display = 'inline';
    }
    sessionStorage.setItem("paymentMethod", "CC");
    this.logger.log("***********tab3: " + this.studentplanssummarymain1);


    let endPoint = `/api/ap/customer/validatePlans`;
    let url = `${environment.apiUrl}${endPoint}`;
    var accessToken = sessionStorage.getItem('accessToken');

    let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
    let plansLife = sessionStorage.getItem("planssummarymainLife") ? JSON.parse(sessionStorage.getItem("planssummarymainLife") || '') : []
    let data = { plans: plansMain.concat(plansLife) };

    // let data = { "plans": JSON.parse(sessionStorage.getItem("plansummarymain")) }
    this.http.post(url, data, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe((Response: any) => {
      if (Response.status == '200') {
        this.homeaddresscheckvalue = false;
        this.homeaddressEnrollmentVal = false;
        this.planssummarymain = JSON.parse(sessionStorage.getItem("plansummarymain") ?? "[]") || "";
        this.planssummaryopt = JSON.parse(sessionStorage.getItem("plansummaryopt") ?? "[]");

        let healthplan = []
        let healthplanvol = []
        this.studentplanssummarymain =
          JSON.parse(sessionStorage.getItem("plansummarymain") ?? "[]").sort((a: { id: any; }, b: { id: any; }) => a.id - b.id) || "";

        const combinedArray = [];
        const groupedByParent: any = {};

        for (const obj of this.studentplanssummarymain) {

          const name = obj.name;

          const products = obj.products;
          if (!groupedByParent[name]) {
            groupedByParent[name] = [];
          }
          groupedByParent[name] = groupedByParent[name].concat(products);
        }

        for (const name in groupedByParent) {
          combinedArray.push({ name, products: groupedByParent[name] });
        }

        this.studentplanssummarymain1 = combinedArray;
        setTimeout(() => {
          this.allproducts = JSON.parse(sessionStorage.getItem("allproducts") ?? "[]");
          var total = 0;
          for (let i = 0; i < this.allproducts.length; i++) {
            total += this.allproducts[i].calculatedTax.total;
          }
          this.logger.log(total);
          this.planAmount = this._decimalPipe?.transform(total, "1.2-2")?.replace(/,/g, "");
          sessionStorage.setItem("totalAmount", this.planAmount);
          this.cartcheckvalue = this.planAmount > 0 ? true : false;
          // alert(this.planAmount)
        }, 1000);


        setTimeout(() => {
          this.signaturePadCC = new SignaturePad(this.signaturePadCanvasEl?.nativeElement);
          this.padAggsignaturePadCC = new SignaturePad(this.padAgreementSignaturePadCanvasEl?.nativeElement);
        }, 1000);

        this.savedGs = false;
        this.savedEq = false;
        this.savedCw = false;
        this.savedKIX = false;
        this.savedWADDELL = false;
        this.gsPlans = Response.data.gsPlans;
        this.eqPlans = Response.data.eqPlans;
        this.cwPlans = Response.data?.phrPlan;
        this.kixPlans = Response.data?.kixcarePlan;
        this.flexPlans = Response.data?.flexgsPlan;
        // this.flexPlans = true
        this.waddellPlans = Response.data?.waddellPlan;
        //iS replated to greenShield plans


        // if (this.gsPlans) {
        //   this.showGreenShiled = false;
        //   this.greenShiledForm.reset();
        //   $('#gsPlans').show();


        // }
        // else if (this.eqPlans) {
        //   this.showEquitable = false;
        //   this.EquitableForm.reset();
        //   $('#eqPlans').show();

        // }
        // else if (this.kixPlans) {
        //   this.showKixcarePlans = false;
        //   this.KixCareForm.reset();
        //   $('#kixPlans').show();

        // }
        // if (this.waddellPlans) {
        //   this.showWaddellPlans = false;
        //   this.waddellPlanForm.reset();

        //   $('#waddellPlans').show();

        // }
        // else {
        //   this.waddellRegistration = false;
        //   this.waddellPlans = false
        //   // this.kixCertificateId = '';
        // }

        // else {
        //   this.gsRegistration = false;
        //   this.gsPlans = false;
        //   this.gsMembershipId = '';
        //   this.eqRegistration = false;
        //   this.eqPlans = false
        //   this.eqCertificateId = '';
        // //   this.kixRegistration =false
        // //  this.kixPlans=false
        // //    this.kixCertificateId =''


        // }

        // if (this.cwPlans) {
        //   this.showCowan = false;
        //   this.cowanForm.reset();
        //   $('#cwPlans').show();
        // }
        // else {
        //   this.cwRegistraion = false;
        //   this.cwPlans = false
        //   this.cwCertificateId = '';
        // }

        //  if (this.kixPlans) {
        //   this.showKixcarePlans = false;
        //   this.KixCareForm.reset();

        //   $('#kixPlans').show();

        // }
        // else {
        //   this.kixRegistration = false;
        //   this.kixPlans = false
        //   // this.kixCertificateId = '';
        // }
        if (this.gsPlans) {
          this.showGreenShiled = false;
          this.greenShiledForm.reset();
          $('#gsPlans').show();

        } else if (this.eqPlans) {
          this.showEquitable = false;
          this.EquitableForm.reset();
          $('#eqPlans').show();
        }
        else {
          this.gsRegistration = false;
          this.gsPlans = false;
          this.gsMembershipId = '';
          this.eqRegistration = false;
          this.eqPlans = false
          this.eqCertificateId = '';
        }

        if (this.cwPlans) {
          this.showCowan = false;
          this.cowanForm.reset();
          $('#cwPlans').show();
        }
        else {
          this.cwRegistraion = false;
          this.cwPlans = false
          this.cwCertificateId = '';

        }

        if (this.kixPlans) {
          this.showKixcarePlans = false;
          this.KixCareForm.reset();

          $('#kixPlans').show();

        }
        else {
          this.kixRegistration = false;
          this.kixPlans = false
          // this.kixCertificateId = '';
        }

        if (this.flexPlans) {
          this.showFlexPlans = false;
          this.FlexForm.reset();

          $('#flexPlans').show();

        }
        else {
          this.flexRegistration = false;
          this.flexPlans = false
          // this.kixCertificateId = '';
        }
        if (this.waddellPlans) {
          this.showWaddellPlans = false;
          this.waddellPlanForm.reset();

          $('#waddellPlans').show();

        }
        else {
          this.waddellRegistration = false;
          this.waddellPlans = false
          // this.kixCertificateId = '';
        }
        if (!this.gsPlans && !this.eqPlans && !this.cwPlans && !this.kixPlans && !this.waddellPlans && !this.flexPlans) {
          this.selectedTab = "tab3"
        }
        console.log(this.selectedTab)
        this.enrollmentForm.reset();
        // this.creditCardForm.reset();
        this.enrollmentForm.get('enrollmentSummaryExpirymonth')?.setValue('');
        this.enrollmentForm.get('enrollmentSummaryExpiryyear')?.setValue('');
        this.bankPayForm.reset();
        this.paymentMethodSelectCC = true;
        this.enrollmentBankDetailedVerify = false;
        this.bankDetailsNames = "";
        const elements = this.elementRef.nativeElement.getElementsByClassName('imgdisplay2');
        for (let i = 0; i < elements.length; i++) {
          elements[i].style.display = 'block';
          elements[i].style.display = 'inline';
        }
        sessionStorage.setItem("paymentMethod", "CC");
        this.logger.log("***********tab3: " + this.studentplanssummarymain1);

        // this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {})
        // this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {})
        // this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {})
        this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
          "message": "Corporates information has been updated. Please refresh screen."
        }, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          }
        }).subscribe((res) => {
          console.log({ res })
        })

        // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {
        //   this.http.post(environment.reportApiUrl+'/websocket/corporate/notification-to-others',{
        //     "message": "Corporates information has been updated. Please refresh screen."
        //   }, { headers: {
        //     Authorization: 'Bearer ' + accessToken,
        //     'Content-Type': 'application/json',
        //   } }).subscribe((res)=>{
        //     console.log({res})
        //   })
        // })
      }
      else {
        Swal.fire({ title: this.lang.Info, text: Response.data.message })
      }
      // else {
      //   Swal.fire({ title: this.lang?.Error, text: Response.error || Response.data.error })
      // }

    }, (error) => {
      if (error.value) {
        Swal.fire({ title: this.lang?.Error, text: error.error })
        // this.router.navigate([this.lang?.Error]);
      } else {
        Swal.fire({ title: this.lang?.Error, text: error.error });
      }
    })


    //  $("#planSelectionInfo").css("display", "block");
    // $('#personalinfocheck').css("dispaly","none");

  }
  closeAddMemberPopup() {
    this.bankPayForm.reset();
    this.enrollmentForm.reset();
    this.userForm.reset();
    this.displayStudentId = false;
    this.displatGig = false;
    this.showBrokersList = false;
    this.forms = [];
    this.showForm = false;
  }

  public noofchildrenchanged(event: any) {
    let count = event.target.value;
    if (count < this.oldvaluenumber) {
      this.childrenDetailsArray.removeAt(count);
      this.oldvaluenumber--;
    } else {
      this.childrenDetailsArray.push(this.initChildDetails());
      this.oldvaluenumber++;
    }
  }
  closeAddChildrenPopup() {
    $('#childInfoModal').hide();
    this.graducationdaycheck = false;

    this.childFormGroup.reset();
    this.childFormGroup.get('childInfoGender')?.setValue('Select');

    this.childFormGroup.clearValidators();
    this.childFormGroup.updateValueAndValidity();

  }
  childInfoAddData() {
    this.logger.log(this.childFormGroup.controls)
    if (this.childFormGroup.invalid) {
      this.childFormGroup.markAllAsTouched()
      return
    }
    this.logger.log("Button name: " + this.childInfoModalAddAndUpdateButton)
    if (this.childInfoModalAddAndUpdateButton == 'Add') {
      //  this.childInfoAddDataArray=this.childFormGroup.value;
      let childObj = this.childFormGroup.value;
      this.logger.log(">><<", childObj)
      childObj['childInfoDOB'] = moment(childObj.childInfoDOB).format("MM-DD-YYYY");
      childObj['childInfoGraduationday'] = childObj.childPostGraduate ? moment(childObj['childInfoGraduationday']).format("MM-DD-YYYY") : childObj.childPostGraduate;
      // this.childInfoAddDataArray.push(this.childFormGroup.value);
      this.logger.log("?>>?", childObj);
      this.childInfoAddDataArray.push(childObj);
      this.noOfChildrenChangedValue = this.childInfoAddDataArray.length;
      this.userForm.get('noofchildren').setValue(this.noOfChildrenChangedValue);
      this.childTableRowsLength = this.childInfoAddDataArray.length;
      this.logger.log("childInfo123: " + JSON.stringify(this.childInfoAddDataArray))
      this.graducationdaycheck = false;

    }
    else if (this.childInfoModalAddAndUpdateButton == 'Update') {


      let childObj = this.childFormGroup.value;
      childObj['childInfoDOB'] = moment(childObj.childInfoDOB).format("MM-DD-YYYY");
      childObj['childInfoGraduationday'] = childObj.childPostGraduate ? moment(childObj['childInfoGraduationday']).format("MM-DD-YYYY") : childObj.childPostGraduate;


      this.childInfoAddDataArray[this.childTableEditRowIndex] = childObj; //this.childFormGroup.value;

      this.childInfoModalAddAndUpdateButton = 'Add';
      this.logger.log("this.childInfoAddDataArray: " + JSON.stringify(this.childInfoAddDataArray));
      this.childInfoAddDataArray['']
      this.dependentchildInsurenceval = false;
      this.graducationdaycheck = false;

      this.childFormGroup.clearValidators();
      this.closeAddChildrenPopup();

    }
    this.childFormGroup.reset();
    this.closeAddChildrenPopup();
    this.clearChildFormValidations();

  }
  clearChildFormValidations() {
    // childdisablility: [''],
    // childInfoCarrierName: [''],
    // childPostGraduate: [''],
    // childInfoGraduationday: [''],
    let controls = ['childdisablility', 'childInfoCarrierName', 'childPostGraduate', 'childInfoGraduationday'];
    for (let control of controls) {
      this.childFormGroup.get(control)?.clearValidators();
      this.childFormGroup.updateValueAndValidity();
      this.childFormGroup.get(control)?.reset();
    }
  }
  setVlidationsForChild() {

    let controls = ['childInfoFirstName', 'childInfoLastName', 'childInfoGender', 'childInfoDOB',
      'DependentchildInsurence'];
    this.childFormGroup.get('childInfoFirstName').setValidators([Validators.required]);
    this.childFormGroup.get('childInfoLastName').setValidators([Validators.required]);
    this.childFormGroup.get('childInfoGender').setValidators([Validators.required]);
    this.childFormGroup.get('childInfoDOB').setValidators([Validators.required]);
    this.childFormGroup.get('DependentchildInsurence').setValidators([Validators.required]);

    for (const name of Object.keys(this.childFormGroup.controls)) {
      this.childFormGroup.get(name).updateValueAndValidity();
    }
    this.childFormGroup = this.childInfoFormBuilder.group({
      childInfoFirstName: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      childInfoLastName: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      childInfoGender: ["", [Validators.required]],
      childInfoDOB: ['', [Validators.required]],
      childdisablility: [''],
      childInfoCarrierName: [''],
      childPostGraduate: [''],
      childInfoGraduationday: [''],
      DependentchildInsurence: ['', Validators.required]
    })
  }

  childInforTableEdit(index: any) {

    this.setVlidationsForChild();

    this.childInfoModalAddAndUpdateButton = "Update";
    this.childTableEditRowIndex = index;
    let dataObject = this.childInfoAddDataArray[index];
    if (dataObject.childInfoGraduationday != '' && dataObject.childPostGraduate) {
      this.graducationdaycheck = true;
      this.childFormGroup.get('childInfoGraduationday')?.setValidators(Validators.compose([Validators.required, this.validateDateforGraduation]));

    } else {
      this.graducationdaycheck = false;
      this.childFormGroup.get('childInfoGraduationday')?.reset();
      this.childFormGroup.get('childInfoGraduationday')?.clearValidators();
      this.childFormGroup.get('childInfoGraduationday')?.updateValueAndValidity();

    }
    if (dataObject.childInfoCarrierName != '' && dataObject.DependentchildInsurence == 'true') {
      this.dependentchildInsurenceval = true;

    } else {
      this.dependentchildInsurenceval = false;;
    }

    this.logger.log("Child data: " + dataObject + " index: " + index)
    this.logger.log("Child data123: " + JSON.stringify(dataObject))
    // this.childInfoControl['childInfoFirstName.=dataObject.childInfoFirstName;
    // const model=new Modal(this.childInfoModal.nativeElement);
    // model.show();

    $('#childInfoModal').show();
    this.childFormGroup.patchValue(dataObject);
  }

  deleteChildrenSwal(index: any) {
    Swal.fire({
      title: this.lang?.Info,
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#10104d",
      cancelButtonColor: "#10104d",
      confirmButtonText: "Yes"
    }).then((result) => {
      if (result.isConfirmed) {
        this.childInforTableDelete(index);
        // Swal.fire({
        //   title: "Deleted!",
        //   text: "Your file has been deleted.",

        // });
      }
    });

  }

  childInforTableDelete(index: any) {

    if (this.childInfoAddDataArray.length == 1)
      document.getElementById('Dependentchildrenno')?.click();

    this.childInfoAddDataArray.splice(index, 1);
    this.noOfChildrenChangedValue = this.childInfoAddDataArray.length;
    this.userForm.get('noofchildren').setValue(this.noOfChildrenChangedValue);
    this.childTableRowsLength = this.childInfoAddDataArray.length;
    // if(this.childTableRowsLength==0){
    //   this.childTableRowsLength=1;
    // }


    this.logger.log("table length: " + this.childTableRowsLength)
  }
  public provinceEnrollmentlist(event: any) {
    // if (event.target.value == "QC") {
    //   $('#QCproviance').show();
    // }

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(",");
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });

    // //this.logger.log(this.userForm.get('postalcode').value)
    if (this.enrollmentForm.get("enrollmentSummaryPostalCode")?.value) {
      if (
        this.provincialZipcodes.indexOf(
          this.enrollmentForm.get("enrollmentSummaryPostalCode")?.value[0]
        ) == -1
      ) {
        this.invalidenrollmentpostalcodeprovince = true;
        this.enrollmentForm.get("enrollmentSummaryPostalCode")?.markAsTouched();
      } else {
        this.invalidenrollmentpostalcodeprovince = false;
      }

      if (this.enrollmentForm.get("enrollmentSummaryPostalCode")?.value.length == 0) {
        this.invalidenrollmentpostalcodeprovince = false;
      }
    }
    // alert(this.postalvalue)
  }



  //enrolment

  // this.paymentMethodSelectCC = true;
  // homeaddressEnrollmentVal: boolean = false;
  paymentMethodSelect(event: any) {
    if (event == 'Credit_Card') {
      this.fusebill_paymentMethod = 'CC';
      sessionStorage.setItem("paymentMethod", "CC");
      this.paymentMethodSelectCC = true;
      this.enrollmentBankDetailedVerify = false;
      // this.voidCheckUploaded=false;

      this.bankPayForm.reset();
      this.enrollmentForm.get('enrollmentSummaryBankNumber')?.reset();
      this.enrollmentForm.get('enrollmentSummaryBankNumber')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryBankNumber')?.updateValueAndValidity();

      this.enrollmentForm.get('enrollmentSummaryTransitNumber')?.reset();
      this.enrollmentForm.get('enrollmentSummaryTransitNumber')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryTransitNumber')?.updateValueAndValidity();

      this.enrollmentForm.get('enrollmentSummaryAccontNumber')?.reset();
      this.enrollmentForm.get('enrollmentSummaryAccontNumber')?.clearValidators();
      this.enrollmentForm.get('enrollmentSummaryAccontNumber')?.updateValueAndValidity();

      this.enrollmentForm.get('enrollmentBankTextdescription')?.reset();
      this.enrollmentForm.get('enrollmentBankTextdescription')?.clearValidators();
      this.enrollmentForm.get('enrollmentBankTextdescription')?.updateValueAndValidity();

      // this.signaturePad= new SignaturePad(this.signaturePadCanvas?.nativeElement);
      // this.ngAfterViewInit();
      // this.creditCard();
      const elements = this.elementRef.nativeElement.getElementsByClassName('paymentMethodSelectCC');
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = 'block';
      }
    } else {
      // this.creditCardForm.reset();
      this.fusebill_paymentMethod = 'PAD';
      this.enrollmentForm.get('enrollmentSummaryCardHolderFirstName')?.reset();
      this.enrollmentForm.get('enrollmentSummaryCardHolderLastName')?.reset();
      this.enrollmentForm.get('enrollmentSummaryCardNumnber')?.reset();
      this.enrollmentForm.get('enrollmentSummaryCVV')?.reset();
      this.enrollmentForm.get('enrollmentSummaryExpiryyear')?.reset();
      this.enrollmentForm.get('enrollmentSummaryExpirymonth')?.reset();


      this.enrollmentForm.get('enrollmentSummaryExpirymonth')?.setValue('');
      this.enrollmentForm.get('enrollmentSummaryExpiryyear')?.setValue('');
      this.paymentMethodSelectCC = false;
      this.bankDetailsNames = "";
      sessionStorage.setItem("paymentMethod", "PAD");
      const elements = this.elementRef.nativeElement.getElementsByClassName('paymentMethodSelectCC');
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none';
      }
      this.clearSignature();
    }
    this.signaturemessagecc = false;
  }

  homeaddressEnrollment(event: any) {
    this.logger.log(" event.target.value: " + event.target.checked)
    this.homeaddressEnrollmentVal = event.target.checked;
    if (this.homeaddressEnrollmentVal) {
      this.logger.log('The homeaddressEnrollmentVal is checked.');

      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.reset();
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.reset();
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryProvince')?.reset();
      this.enrollmentForm.get('enrollmentSummaryProvince')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryCity')?.reset();
      this.enrollmentForm.get('enrollmentSummaryCity')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryStreetAddressLane2')?.reset();
      this.enrollmentForm.get('enrollmentSummaryStreetAddressLane2')?.clearValidators();

      this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.reset();
      this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.clearValidators();

      this.enrollmentForm.updateValueAndValidity();
    } else {
      this.logger.log('The homeaddressEnrollmentVal is not checked.');
      this.enrollmentForm.get('enrollmentSummaryApartSuite')?.setValidators(Validators.compose([apt_suitecheck, Validators.maxLength(50)]));
      this.enrollmentForm.get('enrollmentSummaryStreetAddress')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(50)]));
      this.enrollmentForm.get('enrollmentSummaryCity')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(50)]));
      this.enrollmentForm.get('enrollmentSummaryProvince')?.setValidators(Validators.compose([Validators.required,]));
      this.enrollmentForm.get('enrollmentSummaryPostalCode')?.setValidators(Validators.compose([Validators.required, Validators.maxLength(50)]));

      // this.enrollmentForm.get('recaptchaReactive')?.setValidators(Validators.compose([Validators.required]));
      this.enrollmentForm.updateValueAndValidity();
    }
    this.enrollmentForm.reset();
  }


  bankDetailsVerify() {
    return false
    this.logger.log('bankDetailsVerify')
    let inputData = {
      bankCode: this.bankPayForm.get('enrollmentSummaryBankNumber')?.value,
      branchCode: this.bankPayForm.get('enrollmentSummaryTransitNumber')?.value
    };
    // let getbanknamesvalues: string = `${environment.app.grp}api/students/bank/verify`;

    let getbanknamesvalues: string = "";
    // this.studentService.getbanknames(inputData)
    this.http.post(getbanknamesvalues, inputData, {})
      .subscribe(
        (result: any) => {
          this.logger.log("bank details verify: " + result);
          if (result.status == '200') {
            this.bankDetailsVerifyStatus = false;
            this.bankDetailsError = '';
            //data saved into this bankverifyDetails variable
            this.bankverifyDetails = result.data;
            this.bankDetailsNames = result.data.bank.name + "\n" + result.data.address.split(',').join("\n");
            this.logger.log("this.bankDetailsNames: " + this.bankDetailsNames)
            this.enrollmentBankDetailedVerify = true;
          } else {
            this.bankDetailsClear();
            this.bankDetailsVerifyStatus = true;
            this.bankDetailsError = result.message;


          }

        },
        (error) => {
          this.logger.log("bank details getting error: " + JSON.stringify(error))
        });

  }

  clearSignature() {

    // this.signaturePad.clear();
    if (this.signaturePadCC) {
      this.signaturePadCC.clear();
    }
    this.signaturePadClear = false;

    this.signaturemessagecc = true;
  }

  get enrollmentFormControl() {
    // this.logger.log("this.enrollmentForm.controls: "+JSON.stringify(this.enrollmentForm))
    return this.enrollmentForm.controls;
  }
  bankDetailsClear() {
    this.enrollmentBankDetailedVerify = false;
    this.bankDetailsNames = "";
    this.bankPayForm.get('enrollmentSummaryBankNumber')?.reset();
    this.bankPayForm.get('enrollmentSummaryTransitNumber')?.reset();
    this.bankPayForm.get('enrollmentSummaryAccontNumber')?.reset();
    this.bankPayForm.get('enrollmentBankTextarea')?.reset();
    this.bankPayForm.get('enrollmentSummaryvoidCheckUpload')?.reset();
    this.bankDetailsError = "";

  }

  memberTypeChange(event: any) {

    this.logger.log('enter to function');
    if (event.target.value.toLowerCase() == 'student') {
      this.showBrokersList = true;
      this.displayStudentId = true;
      this.displatGig = false;
      this.showForm = false;
      this.getBrokerDetails(event.target.value);
      this.userForm.get('provincialhealth')?.setValidators(Validators.required);
      this.userForm.get('uhipprovincialhealth').setValidators(Validators.required);
      this.userForm.get('provincialhealth').setValidators(Validators.required);
      this.userForm.get('parentalinsurance').setValidators(Validators.required);
      this.userForm.get('studentId').setValidators(Validators.required);
      this.userForm.get('workinghours').clearValidators();
      this.userForm.get('hoursperweek').clearValidators();

      this.userForm.get('workinghours').updateValueAndValidity();
      this.userForm.get('hoursperweek').updateValueAndValidity();
      this.userForm.updateValueAndValidity();
      this.studentPlaceHolder = this.lang.student_fn;
      this.studentPlaceHolderln = this.lang.student_ln;

    }
    else if (event.target.value == 'GIG') {
      this.studentPlaceHolder = this.lang.name_as_shown_on_provincial_health_card;
      this.studentPlaceHolderln = this.lang.name_as_shown_on_provincial_health_card;
      this.showBrokersList = true;
      this.displatGig = true;
      this.displayStudentId = false;
      this.showForm = false;
      this.getBrokerDetails(event.target.value);
      this.userForm.get('provincialhealth')?.clearValidators();
      this.userForm.get('uhipprovincialhealth').clearValidators();
      this.userForm.get('parentalinsurance').clearValidators();
      this.userForm.get('foreignStudent').clearValidators();
      this.userForm.get('studentId').clearValidators();

      this.userForm.get('foreignStudent')?.updateValueAndValidity();
      this.userForm.get('studentId')?.updateValueAndValidity();
      this.userForm.get('uhipprovincialhealth')?.updateValueAndValidity();
      this.userForm.get('parentalinsurance')?.updateValueAndValidity();

      this.userForm.get('workinghours').setValidators(Validators.required);
      this.userForm.get('hoursperweek').setValidators([Validators.required, validatehoursperweek]);
      this.userForm.get('hoursperweek').setValue('40');
      this.userForm.get('hoursperweek').updateValueAndValidity();
    }
    else {
      this.displayStudentId = false;
      this.displatGig = false;
      this.showBrokersList = false;
      this.forms = [];
      this.showForm = false;
      this.userForm.get('workinghours').clearValidators();
      this.userForm.get('hoursperweek').clearValidators();
    }
  }
  public isProvincialPlanInc: boolean = true
  public showExtrafeilds: boolean = false

  public landedimmigrantStatus(value) {
    if (value.target.value == "true") {
      this.showlandedimgratestatus = false;
      this.userForm.get('applylandedstaus').clearValidators();
      this.userForm.get('applylandedstaus').updateValueAndValidity();
    } else {
      this.showlandedimgratestatus = true;

      this.userForm.get('applylandedstaus').setValidators(Validators.required);
      this.userForm.get('applylandedstaus').updateValueAndValidity();
    }
    this.logger.log({ show: this.showlandedimgratestatus })
  }

  public spouseinfo(event: any) {
    // console.log(event.target.value)
    if (event.target.value == "true") {
      this.spouseinformation = true;
      if (this.showExtrafeilds) {
        this.showlandeddependentDetails = true
        this.userForm.get('coverageRequiredOfDependents').setValidators(Validators.required);

      }
      this.userForm.get('spousefirstname')?.reset();
      this.userForm.get('spousefirstname')?.clearValidators();
      this.userForm.get('spousefirstname')?.setValidators(Validators.compose([Validators.required, Validators.minLength(1),
        // Validators.pattern("^(?!\\s)[A-Za-z\\s]+$")
      ]));
      this.userForm.get('spouselastname')?.reset();
      this.userForm.get('spouselastname')?.clearValidators();
      this.userForm.get('spouselastname')?.setValidators(Validators.compose([Validators.required, Validators.minLength(1),
        // Validators.pattern("^(?!\\s)[A-Za-z\\s]+$")
      ]))
      this.userForm.get('spousegender')?.reset();
      this.userForm.get('spousegender')?.clearValidators();
      this.userForm.get('spousegender')?.setValidators([Validators.required]);

      // this.userForm.get('spousedateofbirth')?.reset();
      this.userForm.get('spousedateofbirth')?.clearValidators();
      this.userForm.get('spousedateofbirth')?.setValidators(Validators.compose([Validators.required, dateofbirthvalidation]));

      this.userForm.get('spousehealthcard')?.reset();
      this.userForm.get('spousehealthcard')?.clearValidators();
      this.userForm.get('spousehealthcard')?.setValidators([Validators.required]);

      // console.log(this.userForm.value.provincialhealth)
      // if (this.userForm.value.provincialhealth == 'false') {

      //   this.userForm
      //     .get('coverageRequiredOfDependents')
      //     ?.setValidators([Validators.required]);
      // }
      // else{
      //   this.userForm.get('coverageRequiredOfDependents')?.reset();
      //   this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
      //   this.userForm
      //     .get('coverageRequiredOfDependents')
      //     ?.updateValueAndValidity();
      // }

    } else {
      if (!this.childrenhealthinformation) {
        this.showlandeddependentDetails = false
        $("#coverageRequiredOfDependentsno").click();

        // if (this.userForm.value.having_dependent_children == 'true') {
        //   if (this.userForm.value.provincialhealth == 'false') {
        //     this.userForm
        //       .get('coverageRequiredOfDependents')
        //       ?.setValidators([Validators.required]);
        //   }
        //   else{
        //     this.userForm.get('coverageRequiredOfDependents')?.reset();
        //     this.userForm.get('coverageRequiredOfDependents')?.clearValidators();
        //     this.userForm
        //       .get('coverageRequiredOfDependents')
        //       ?.updateValueAndValidity();
        //   }
        // }
        // else{
        this.userForm.get('coverageRequiredOfDependents').reset();
        this.userForm.get('dependentdateOfArrival').reset();
        this.userForm.get('dependentcountryOrigin').reset();
        this.userForm.get('dependentLandedImigrant').reset();
        this.userForm.get('dependentapplylandedstaus').reset();
        this.userForm.get('dependentMorethan3years').reset();
        this.userForm.get('coverageRequiredOfDependents').clearValidators();
        this.userForm.get('coverageRequiredOfDependents').updateValueAndValidity();
        // }
      }
      this.logger.log(this.childrenhealthinformation)

      this.spouseinformation = false;
      this.spousehealthcardinfo = false;
      this.userForm.get('spousefirstname')?.reset();
      this.userForm.get('spousefirstname')?.clearValidators();
      this.userForm.get('spousefirstname')?.updateValueAndValidity();

      this.userForm.get('spouselastname')?.reset();
      this.userForm.get('spouselastname')?.clearValidators();
      this.userForm.get('spouselastname')?.updateValueAndValidity();

      this.userForm.get('spousegender')?.reset();
      this.userForm.get('spousegender')?.clearValidators();
      this.userForm.get('spousegender')?.updateValueAndValidity();

      // this.userForm.get('spousedateofbirth')?.reset();
      this.userForm.get('spousedateofbirth')?.clearValidators();
      this.userForm.get('spousedateofbirth')?.updateValueAndValidity();

      this.userForm.get('spousehealthcard')?.reset();
      this.userForm.get('spousehealthcard')?.clearValidators();
      this.userForm.get('spousehealthcard')?.updateValueAndValidity();

    }
  }

  public havingchildren(event: any) {
    this.logger.log("havingchildren: ");
    if (event.target.value == "true") {
      this.childrenhealthinformation = true;
      this.logger.log(this.noOfChildrenChangedValue);
      this.userForm.get('noofchildren').setValue(this.noOfChildrenChangedValue);
      if (this.showExtrafeilds == true) {
        this.showlandeddependentDetails = true;
        this.userForm.get('coverageRequiredOfDependents').setValidators(Validators.required);

      }
    } else {
      this.childrenhealthinformation = false;
      this.logger.log(!this.userForm.value.havingspouse || this.userForm.value.havingspouse == null)
      this.logger.log("dependentstatus", this.showlandeddependentDetails)
      if (!this.userForm.value.havingspouse || this.userForm.value.havingspouse == null) {

        this.showlandeddependentDetails = false;
      }
      this.childInfoAddDataArray.shift();
      this.childTableRowsLength = this.childInfoAddDataArray.length;
      this.userForm.get('childrenDetails')?.reset();
      this.userForm.get('childrenDetails')?.clearValidators();
      this.userForm.get('noofchildren')?.clearValidators();
      this.userForm.get('noofchildren')?.updateValueAndValidity();
      $("#coverageRequiredOfDependentsno").click();
      this.userForm.get('coverageRequiredOfDependents').reset();
      this.userForm.get('dependentdateOfArrival').reset();
      this.userForm.get('dependentcountryOrigin').reset();
      this.userForm.get('dependentLandedImigrant').reset();
      this.userForm.get('dependentapplylandedstaus').reset();
      this.userForm.get('dependentMorethan3years').reset();
      this.userForm.get('coverageRequiredOfDependents').clearValidators();
      this.userForm.get('coverageRequiredOfDependents').updateValueAndValidity();

    }
  }

  public dependentCoverage(value) {
    if (value.target.value == "true") {
      this.showdependentdetails = true;
      this.userForm.get('dependentdateOfArrival').setValidators(Validators.required);
      this.userForm.get('dependentLandedImigrant').setValidators(Validators.required);
      this.userForm.get('dependentMorethan3years').setValidators(Validators.required);
      this.userForm.get('dependentcountryOrigin').setValidators(Validators.required);

    } else {
      this.showdependentdetails = false;
      this.userForm.get('dependentdateOfArrival').clearValidators();
      this.userForm.get('dependentdateOfArrival').updateValueAndValidity();


      this.userForm.get('dependentLandedImigrant').clearValidators();
      this.userForm.get('dependentLandedImigrant').updateValueAndValidity();

      this.userForm.get('dependentapplylandedstaus').clearValidators();
      this.userForm.get('dependentapplylandedstaus').updateValueAndValidity();


      this.userForm.get('dependentMorethan3years').clearValidators();
      this.userForm.get('dependentMorethan3years').updateValueAndValidity();

      this.userForm.get('dependentcountryOrigin').clearValidators();
      this.userForm.get('dependentcountryOrigin').updateValueAndValidity();
      // this.checkhealthcardstatus = true;
    }
  }

  public dependentLandedImigrant(value) {
    if (value.target.value == "true") {
      this.showdependentlandedstatus = false;
      this.userForm.get('dependentapplylandedstaus').clearValidators();
      this.userForm.get('dependentapplylandedstaus').updateValueAndValidity();

    } else {
      this.showdependentlandedstatus = true;

      this.userForm.get('dependentapplylandedstaus').setValidators(Validators.required);
    }
  }
  clearPHRValidators() {
    this.userForm.get('dateOfArrival').clearValidators();
    this.userForm.get('dateOfArrival').updateValueAndValidity();
    this.userForm.get('isEmployeeImigrant').clearValidators();
    this.userForm.get('isEmployeeImigrant').updateValueAndValidity();
    this.userForm.get('applylandedstaus').clearValidators();
    this.userForm.get('applylandedstaus').updateValueAndValidity();
    this.userForm.get('countryOrigin').clearValidators();
    this.userForm.get('countryOrigin').updateValueAndValidity();
    this.userForm.get('coverageRequiredOfEmployee').clearValidators();
    this.userForm.get('coverageRequiredOfEmployee').updateValueAndValidity();
  }



  provincialhealth(e: any) {
    if (e.target.value == "false") {
      if (!this.isProvincialPlanInc) {
        this.checkhealthcardstatus = true;
        $('#checkuhipstatusModal').modal('show');
        this.clearPHRValidators()
      }
      else {
        this.showExtrafeilds = true
        this.checkhealthcardstatus = false
        if (this.childrenhealthinformation) {
          this.showlandeddependentDetails = true //dependent covergae
        }
        this.userForm.get('dateOfArrival').setValidators(Validators.required);
        this.userForm.get('isEmployeeImigrant').setValidators(Validators.required);
        this.userForm.get('countryOrigin').setValidators(Validators.required);
        this.userForm.get('coverageRequiredOfEmployee').setValidators(Validators.required);
      }
    } else {
      this.checkhealthcardstatus = false
      this.showExtrafeilds = false
      this.showlandeddependentDetails = false

      this.clearPHRValidators()

    }
  }

  getBrokerDetails(memnerType: any) {
    //'
    //http://localhost:3002/api/ap/customers/broker/list?type=GIG'
    let endPoint = `/api/ap/customers/broker/list?type=${memnerType.toUpperCase()}`;
    let url = `${environment.apiUrl}${endPoint}`;
    var accessToken = sessionStorage.getItem('accessToken');
    this.http.get(url, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe((Response: any) => {
      if (Response.status == '200') {
        this.logger.log(JSON.stringify(Response));
        this.brokers = Response.data.allBrokers;
        this.logger.log('broker details', JSON.stringify(this.brokers));
      }
      else {
        //  Swal.fire({title:this.lang?.Info,Text:Response.message})
        Swal.fire({
          title: this.lang?.Info,
          text: Response.message ? Response.message : Response.error,
        })
      }

    }, (error) => {
      if (error.value) {
        Swal.fire({ title: this.lang?.Error, text: error.error })
        // this.router.navigate([this.lang?.Error]);
      } else {
        Swal.fire({ title: this.lang?.Error, text: error.error });
      }
    })
  }
  public hoursperweekvalue(event) {
    let value = event.target.value;

    // hoursperweekfun1(value)
  }

  public workinghours(value) {
    if (value == "true") {
      this.hoursperweek = false;
      this.hourperweekvalue = true;
      this.userForm.get('hoursperweek').setValue('40');
    } else {
      this.hoursperweek = true;
      this.hourperweekvalue = false;
    }
  }





  //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/11111111111/details
  // https://testapi.groupbenefitz.aitestpro.com/api/ap/12531466/details
  checkFusBillId() {
    this.logger.log('enter to checkFusBillId');
    let fusbillId = this.userForm.get('fusbillId').value;
    if (fusbillId) {
      let formLink = environment.apiUrl;
      var accessToken = sessionStorage.getItem('accessToken');
      let Url: string = `${environment.apiUrl}/api/ap/${fusbillId}/details`;
      let lang = 'en';
      this.http
        .get(Url, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (responce: any) => {
            // this.isLoaded =true
            //             hideOnOverlayClick: false,
            // hideOnContentClick: false,
            // closeClick: false,
            if (responce.status == '200') {
              this.logger.log(JSON.stringify(responce));
              Swal.fire({
                title: this.lang?.Info,
                html: 'User Exists in Stax and Not in BMS <br> Are you sure you want to import the data?',
                showCancelButton: true,
                cancelButtonText: this.lang?.No,
                confirmButtonText: this.lang?.Yes,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.patchUserDetails(responce.data);
                } else {
                  this.userForm.reset()
                  this.customerPlansInActive = false;
                  this.customerPlansActiveData = null
                }
              });
            } else {
              // if(responce.status!='201'){
              Swal.fire({
                title: this.lang?.User_Not_Exists_in_Stax_and_Not_in_BMS,
                // icon: 'warning',
                html: `<div class="custom-content">${responce.message ? responce.message : responce.error
                  }</div>`,
                confirmButtonText: 'OK',
              });
              // }
            }
          },
          (error) => {
            if (error.value) {
              this.router.navigate([this.lang?.Error]);
            } else {
            }
          }
        );
    }
    else {
      this.customerPlansInActive = false;
      this.customerPlansActiveData = null
    }


  }
  public customerPlansInActive: boolean = false;
  public customerPlansActiveData: any;

  patchUserDetails(data: any) {
    this.firstName = data.customerData.firstName;
    this.lastName = data.customerData.lastName;
    this.primaryEmail = data.customerData.primaryEmail;

    this.primaryPhone = data.customerData?.primaryPhone;
    this.country = data.customerAddress?.billingAddress?.country;
    this.line1 = data.customerAddress?.billingAddress?.line1;
    this.line2 = data.customerAddress?.billingAddress?.line2;
    this.city = data.customerAddress?.billingAddress?.city;
    //  this.state=data.customerAddress.billingAddress.state;
    this.postalZip = data.customerAddress?.billingAddress?.postalZip;
    this.postalZip = data.customerAddress?.billingAddress?.postalZip;
    this.configprovinceres.filter((proviance) => {
      if (proviance.name.toLowerCase() == data.customerAddress?.billingAddress?.state.toLowerCase()) {
        this.state = proviance.shortName;
      }
    });
    this.logger.log(this.state);
    if (data.customerPlansInActiveAndProvison && this.userForm.get('fusbillId').value) {
      this.logger.log("entered")
      this.customerPlansInActive = true;
      this.customerPlansActiveData = data.customerSubscrptions
    }
    else {
      this.customerPlansInActive = false;
      this.customerPlansActiveData = null
    }
    this.userForm.markAsTouched();

  }

  getForms(id: any) {
    this.showForm = true;
    this.forms = this.brokers.filter((broker) => {
      if (broker.id == id) {
        return broker;
      }
    });
    this.logger.log('forms', this.forms)
  }


  public getSliderBackground(
    rangeValue: any,
    maxRange: any,
    stepCount: any,
    defaultRange: any
  ): any {
    const percentage = (rangeValue / maxRange) * 100;
    let gradientColor = "white";


    // if (percentage >= 8 && stepCount === 25000) {
    //   gradientColor = "green";
    // }
    // return `linear-gradient(to right, ${gradientColor} ${percentage}%, white ${percentage}%)`;



    if (rangeValue <= defaultRange) {
      this.greenValue = (defaultRange / maxRange) * 100;
      this.names = [
        { label: 'Guaranteed', position: this.greenValue },    // Display "Start" at 0%
        { label: 'Pending', position: 100 - this.greenValue }, // Display "Quarter" at 25%

      ];
      this.showyellowbar = false
      return `linear-gradient(to right, green ${(defaultRange / maxRange) * 100}%, lightgray 0%)`;
    } else if (rangeValue > defaultRange) {
      const greenPart = adjustWith2DecimalsForUI((defaultRange / maxRange) * 100);
      console.log(greenPart)
      this.yellowValue = adjustWith2DecimalsForUI((100 - greenPart) * 100);
      // const yellowPart = ((rangeValue - defaultRange) / 4.5) + greenPart;
      const yellowPart = adjustWith2DecimalsForUI((rangeValue / maxRange) * 100)

      console.log(yellowPart)
      this.names = [
        { label: 'Guaranteed', position: greenPart },    // Display "Start" at 0%
        { label: 'Pending', position: yellowPart }, // Display "Quarter" at 25%

      ];
      this.showyellowbar = true
      return `linear-gradient(to right,  green 0%,
      green ${greenPart}%,
      yellow ${greenPart}%,
      yellow ${yellowPart}%,
      lightgray  ${yellowPart}%,
      lightgray  100%) `;

    }
  }

  public isDataAvailable(type: string, category: string, feild?: string): boolean {
    // console.log(this.allFormData)
    // console.log(type)
    // console.log(category)
    // console.log(feild)
    const bool = feild ? !(this.allFormData[type] && this.allFormData[type][category] && this.allFormData[type][category][feild]) : !(this.allFormData[type] && this.allFormData[type][category]);
    return bool
  }
  public isDataAvailableSpouseDataa(type: string, category: string, feild?: string): boolean {


    // const bool = feild?this.allFormData[type] && this.allFormData[type][category]:false;
    // return bool

    const bool = feild ? !(this.allFormData[type] && this.allFormData[type][category] && this.allFormData[type][category][feild]) : !(this.allFormData[type] && this.allFormData[type][category]);
    return bool
  }
  public isDataAvailableSpouse(type: string, category: string, feild?: string): boolean {

    if (this.allFormData[type]) {
      console.log(this.allFormData[type]['member'])
    }

    if (this.allFormData[type] && this.allFormData[type]['member']) {
      return false
    }
    else {
      return true
    }


  }
  public generateTicks(maxRange: any, stepCount: any): any[] {
    const ticks = [];
    const totalTicks = maxRange / stepCount;

    for (let i = 0; i <= totalTicks; i++) {
      ticks.push(i * stepCount);
    }

    return ticks;
  }

  public updateTotal(data: any) {
    const memberPremium =
      data.member && data.member.premium > 0 ? data.member.premium : 0;
    const spousePremium =
      data.spouse && data.spouse.premium > 0 ? data.spouse.premium : 0;
    const dependentPremium =
      data.dependent && data.dependent.premium > 0 ? data.dependent.premium : 0;
    const total = memberPremium + spousePremium + dependentPremium;

    return total;
  }
  public updateFormData(
    type: string,
    category: string,
    newData: any,
    remove: boolean = false
  ): void {


    if (this.lastUpdatedType !== type) {
      this.formData = this.allFormData[type]
        ? { ...this.allFormData[type] }
        : {};
    }

    let updatedFormData = { ...this.formData };
    let shouldUpdateTotal = false;
    console.log(updatedFormData)
    if (remove) {
      delete updatedFormData[category];
      delete updatedFormData.total;
    } else if (typeof newData === "object" && newData !== null) {
      updatedFormData[category] = { ...updatedFormData[category], ...newData };
      shouldUpdateTotal = "coverage" in newData || category === "dependent" || "isSmoker" in newData;
    } else {
      updatedFormData[category] = newData;
    }

    if (
      shouldUpdateTotal &&
      ["member", "spouse", "dependent"].includes(category)
    ) {
      updatedFormData.total = this.updateTotal(updatedFormData);
    }

    this.formData = updatedFormData;
    this.allFormData[type] = { ...this.formData };
    // this.allFormData = { ...this.allFormData, [type]: this.formData };
    this.lastUpdatedType = type;
    console.log("formData:", this.allFormData);


  }

  public calculateAge(dob: string) {
    const today = new Date();
    const birthDate = new Date(dob);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  public updatePremium(
    type: string,
    category: string,
    newIsSmokerValue: string
  ) {

    //  if (this.allFormData[type][category]) {
    //   const isSmokerValue = event.target.value=== "yes" ? "smoker" : "nonSmoker";

    //   console.log(isSmokerValue)
    //   let gender:any = this.userForm.value.gender?.toLowerCase()
    //   let value: any = 0;
    //   console.log(this.allFormData[type][category]["coverage"])
    //   value=this.allFormData[type][category]["coverage"][gender][isSmokerValue]
    //   console.log(value)
    //   const premium = (this.allFormData[type][category]["coverage"].maximumCoverageWithoutEvidence * value) / 1000;
    //   console.log(parseFloat(premium.toFixed(2)))
    //   this.updateFormData(type, category, {
    //     isSmoker: isSmokerValue,
    //     premium: parseFloat(premium.toFixed(2))
    //   });
    // }

    console.log(this.allFormData)
    // const coverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence;

    const coverage = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence / 25000;
    const isSmoker = newIsSmokerValue === "yes" ? "smoker" : "nonSmoker";
    let value: any = 0;
    let gender: any = this.userForm.value.gender?.toLowerCase()
    let spouseGender: any = this.userForm.value.spousegender?.toLowerCase()

    console.log(spouseGender)

    if (category === "member") {
      value = this.allFormData[type][category]["coverage"]["price"][gender][isSmoker]
    }

    if (category === "spouse") {
      value = this.allFormData[type][category]["coverage"]["price"][spouseGender][isSmoker]
    }
    console.log({ value })

    this.updateFormData(type, category, { constant: value });

    if (coverage > 0) {
      // const premium = (coverage * value) / 1000;

      const premium = (coverage * value);
      return parseFloat(premium.toFixed(2));
    }
    console.log("formData:", this.allFormData);
    return 0;

  }

  public updateDependentPremium(type: string, category: string, coverage: number) {
    // const constant = coverage > 5000 ? 2.56 : 1.28;
    // this.updateFormData(type, category, { constant: constant });

    // const p =
    //   (constant * coverage) / 1000;
    // return parseFloat(p.toFixed(2));
  }
  public handleRadioChange(event: any, type: string, category: string, options: any, plan: any, product: any, pckage: any, group: any, value: any): void {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    let isSmokerValue = event.target.value;
    let plandetails = event.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let smokerCheck: any = ''

    if (isSmokerValue == "no") {
      smokerCheck = false
    }
    else {
      smokerCheck = true
    }

    this.rangeValues = []


    this.allFormData[type][category].coverage = value

    if (this.allFormData[type][category]) {

      this.updateFormData(type, category, {
        isSmoker: isSmokerValue,
        premium: this.updatePremium(type, category, isSmokerValue),
      });
    }

    console.log(this.allFormData)
    let lifeCoverage = ''
    let memberObj: any = {}
    let spouseObj: any = {}

    if (category == "member") {
      lifeCoverage = "MEMBER"
    }
    else {
      lifeCoverage = "MEMBER & SPOUSE"
    }

    if (this.allFormData[type]['spouse']) {
      lifeCoverage = "MEMBER & SPOUSE"

    }







    plansummaryLife.forEach((element: any, index: any) => {

      if (element.planname == plandetailsobj[14]) {
        plansummaryLife.splice(index, 1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

    })
    let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["member"].coverage.defaultRange) / 25000) : 0
    let spousePrice: any;
    if (this.allFormData[type]['spouse']) {
      spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["spouse"].coverage.defaultRange) / 25000) : 0
    }


    setTimeout(() => {
      // console.log(this.allFormData[type][category].premium)

      let obj: any = {
        isBundle: plan.isBundle,
        // enrollmentDate: moment(
        //   this.userForm.get("planenrollmentdate").value,
        //   "MM-DD-YYYY"
        // ).format("YYYY-MM-DD"),
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? this._CustomDatePipe.transform(
            this.userForm.value.planEnrollmentDate
          )
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        // amount: this.allFormData[type][category].premium,
        planCoverage: plandetailsobj[2],
        planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == '' ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == '' ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType

        //  "disallowedPlanLevels":plandetailsobj[11]
      };


      obj["categorization"] = {
        paidByCompany: 0,
        coveredByCompany: 0,
        paidByEmployee: 1,
      }


      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
      ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version: product.version
      };

      this.productobj.total = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')


      if (category == "member") {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          // "guaranteedAcceptanceAmount":this.allFormData[type]["member"].coverageValue <=this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverageValue/25000)*this.allFormData[type][category].constant):this.allFormData[type]["member"].coverage.defaultRange,

          "guaranteedAcceptanceAmount": adjustWith2DecimalsForUI(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant)),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }

        memberObj["guaranteedAcceptanceTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax)
        memberObj["guaranteedAcceptanceTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverageValue <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverageValue / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total)

        memberObj["pendingApprovalTax"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax)
        memberObj["pendingApprovalTotal"] = adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total)

        obj["member"] = memberObj
        obj["spouse"] = {}
        if (this.allFormData[type]['spouse']) {
          spouseObj = {
            "planStartDate": this.userForm.value.planEnrollmentDate
              ? this._CustomDatePipe.transform(
                this.userForm.value.planEnrollmentDate
              )
              : undefined,
            "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage": "MEMBER & SPOUSE",
            "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
            "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
            "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
            "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
            "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
            "age": this.allFormData[type]["spouse"].coverage.age,
            "gender": this.userForm.value.spousegender?.toLowerCase(),
            "province": "ON",
            "provinceId": 12,
            "amount": this.allFormData[type]["spouse"].premium,
            "tax": adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate": "", //not mandatory,
            "taxName": "",
            "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium": this.allFormData[type]["spouse"].constant,
            "total": adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          }






          obj["member"] = memberObj
          obj["spouse"] = spouseObj

          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant), product.taxesDataJSON ?? []).tax
          spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant), product.taxesDataJSON ?? []).total

          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type][category].constant, product.taxesDataJSON ?? []).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type][category].constant, product.taxesDataJSON ?? []).total
        }
      }
      else {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),

          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        spouseObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage": "MEMBER & SPOUSE",
          "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type][category].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["spouse"].coverage.age,
          "gender": this.userForm.value.spousegender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["spouse"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["spouse"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
        }

        obj["member"] = memberObj
        obj["spouse"] = spouseObj


        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total

        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
        spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).total

      }

      let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0))
      let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"] + (spouseObj["guaranteedAcceptanceTax"] ?? 0))
      let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"] + (spouseObj["guaranteedAcceptanceTotal"] ?? 0))

      let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0))
      let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"] + (spouseObj["pendingApprovalTax"] ?? 0))
      let MSpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"] + (spouseObj["pendingApprovalTotal"] ?? 0))

      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version: plan.version,
        guaranteedAcceptanceDetails: {
          "amount": MSguranteeAcceptanceAmount,
          "tax": MSguranteeAcceptancetTAX,
          "total": MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]


        },
        pendingApprovalDetails: {
          "amount": MSpendingApprovalAmount,
          "tax": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "total": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(this.allFormData[type].total),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]
        },
        selectedDetails: {
          "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).total : 0),

          "tax": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).tax : 0),
          "products": [this.productobj]
        }


      };

      obj["guaranteedAcceptanceDetails"] = obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"] = obj1.pendingApprovalDetails
      obj["selectedDetails"] = obj1.selectedDetails
      obj1.products.push(this.productobj);

      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }


    /*
    Form Here the code works for auto slection of Smoker in Life and critical vice versa
     */

    plansummaryLife.forEach((element: any, index: any) => {


      if (category == "member") {

        if (element.member.smoker == isSmokerValue) {
        }
        else {


          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("." + "member" + "-" + element.planCoverage + "-" + isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan.click()
          }, 1000);

        }
      }
      if (category == "spouse") {


        if (element.spouse.smoker == isSmokerValue) {
        }
        else {


          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("." + "spouse" + "-" + element.planCoverage + "-" + isSmokerValue);
          console.log(plan)
          setTimeout(() => {
            plan.click()
          }, 1000);

        }
      }




    })
  }

  public handleRangeChange(value: any, type: string, category: string, options: any, plan: any, product: any, pckage: any, group: any, event: any, data: any): void {
    // console.log(value)
    // console.log(type)
    // console.log(event)
    // console.log(data)


    if (data.maximumCoverageWithoutEvidence == 0) {
      data.maximumCoverageWithoutEvidence = 25000
    }
    this.allFormData[type][category].coverage = data

    // this.sliderValue = this.allFormData[type][category].coverage.maximumCoverageWithoutEvidence


    this.rangeValues = [];




    if (this.allFormData[type][category]) {
      this.updateFormData(type, category, {
        // coverage: value,
        isSmoker: this.allFormData[type][category].isSmoker,
        premium: this.updatePremium(type, category, this.allFormData[type][category].isSmoker),
      });
    }
    let lifeCoverage = ''
    let memberObj: any = {}
    let spouseObj: any = {}
    if (category == "member") {
      lifeCoverage = "MEMBER"
    } else {
      lifeCoverage = "MEMBER & SPOUSE"
    }

    if (this.allFormData[type]['spouse']) {
      lifeCoverage = "MEMBER & SPOUSE"

    }

    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');


    let plandetails = event.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');


    plansummaryLife.forEach((element: any, index: any) => {

      if (element.planname == plandetailsobj[14]) {
        plansummaryLife.splice(index, 1)
      }
      sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));

    })
    setTimeout(() => {
      // console.log(this.allFormData[type][category].premium)

      let obj: any = {
        isBundle: plan.isBundle,
        // enrollmentDate: moment(
        //   this.userForm.get("planenrollmentdate").value,
        //   "MM-DD-YYYY"
        // ).format("YYYY-MM-DD"),
        enrollmentDate: this.userForm.value.planEnrollmentDate
          ? this._CustomDatePipe.transform(
            this.userForm.value.planEnrollmentDate
          )
          : undefined,
        // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
        name: plandetailsobj[14],
        details: plandetailsobj[0],
        packagename: plandetailsobj[0],
        groupName: plandetailsobj[1],
        amount: this.allFormData[type].total,
        // amount: this.allFormData[type][category].premium,
        planCoverage: plandetailsobj[2],
        planPrice: adjustWith2DecimalsForUI(this.allFormData[type].total),
        amountUI:
          '$' +
          adjustWith2DecimalsForUI(this.allFormData[type].total),
        gst:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? 0
            : parseFloat(plandetailsobj[4]),
        hst:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? 0
            : parseFloat(plandetailsobj[5]),
        pst:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? 0
            : parseFloat(plandetailsobj[6]),
        qst:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? 0
            : parseFloat(plandetailsobj[17]),
        gstCheck:
          plandetailsobj[4] == null ||
            plandetailsobj[4] == '' ||
            plandetailsobj[4] == undefined ||
            plandetailsobj[4] == 'null'
            ? false
            : true,
        hstCheck:
          plandetailsobj[5] == null ||
            plandetailsobj[5] == '' ||
            plandetailsobj[5] == undefined ||
            plandetailsobj[5] == 'null'
            ? false
            : true,
        pstCheck:
          plandetailsobj[6] == null ||
            plandetailsobj[6] == '' ||
            plandetailsobj[6] == undefined ||
            plandetailsobj[6] == 'null'
            ? false
            : true,
        qstCheck:
          plandetailsobj[17] == null ||
            plandetailsobj[17] == '' ||
            plandetailsobj[17] == undefined ||
            plandetailsobj[17] == 'null'
            ? false
            : true,
        id: parseFloat(plandetailsobj[7]),
        fusebillPlanID:
          plandetailsobj[8] == null ||
            plandetailsobj[8] == '' ||
            plandetailsobj[8] == undefined ||
            plandetailsobj[8] == 'null'
            ? 0
            : parseFloat(plandetailsobj[8]),
        planFrequencyID:
          plandetailsobj[9] == null ||
            plandetailsobj[9] == '' ||
            plandetailsobj[9] == undefined ||
            plandetailsobj[9] == 'null'
            ? 0
            : parseFloat(plandetailsobj[9]),
        optIn: plandetailsobj[10] == 'true' ? true : false,
        planname: plandetailsobj[14],
        planLevel: parseInt(plandetailsobj[15]),
        packageId: parseInt(plandetailsobj[16]),
        options: [],
        version: plan.version,
        description: plan.description,
        insuranceType: plan.insuranceType

        //  "disallowedPlanLevels":plandetailsobj[11]
      };

      obj["categorization"] = {
        paidByCompany: 0,
        coveredByCompany: 0,
        paidByEmployee: 1,
      }

      if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
        if (plandetailsobj[11].includes(plandetailsobj[12])) {
        }
      }
      ///this.consoleMessage(obj)
      this.productobj = {
        id: product.id,
        productId: product.productId,
        name: product.name,
        planProductId: product.planProductId,
        price: adjustWith2DecimalsForUI(this.allFormData[type].total),
        tax: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.tax : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        total: this._decimalPipe
          .transform(
            product.calculatedTax ? product.calculatedTax.total : 0,
            '1.2-2'
          )
          ?.replace(/,/g, ''),
        tax_details:
          product.bundledTaxes && product.bundledTaxes.length > 0
            ? product.bundledTaxes
            : product.taxesDataJSON,
        calculatedTax: this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []),
        bundledProducts: product.bundledProducts,
        planCoverage: lifeCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : '',
        description: product.description,
        coverage: lifeCoverage,
        version: product.version
      };

      this.productobj.total = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      this.productobj.tax = this._decimalPipe
        .transform(
          this.productobj.calculatedTax ? this.productobj.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, '')
      // console.log(this.allFormData)
      // console.log(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence )
      // console.log(this.allFormData[type]["member"].coverage.defaultRange)
      // console.log((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)

      // console.log(((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000)*this.allFormData[type][category].constant)

      let memberPrice = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["member"].coverage.defaultRange) / 25000) : 0
      let spousePrice: any;
      if (this.allFormData[type]['spouse']) {
        spousePrice = this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence - this.allFormData[type]["spouse"].coverage.defaultRange) / 25000) : 0
      }
      // console.log(price)
      // console.log(price*this.allFormData[type]["member"].constant)
      // console.log(product.taxesDataJSON)
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]))
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).tax)
      // console.log(this.calculateTaxForProductTaxesData(price*this.allFormData[type]["member"].constant,product.taxesDataJSON??[]).total)
      if (category == "member") {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,


          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        obj["member"] = memberObj
        obj["spouse"] = {}

        if (this.allFormData[type]['spouse']) {
          spouseObj = {
            "planStartDate": this.userForm.value.planEnrollmentDate
              ? this._CustomDatePipe.transform(
                this.userForm.value.planEnrollmentDate
              )
              : undefined,
            "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
            "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
            "coverage": "MEMBER & SPOUSE",
            "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
            "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
              this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
            "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant),
            "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
            "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
            "age": this.allFormData[type]["spouse"].coverage.age,
            "gender": this.userForm.value.spousegender?.toLowerCase(),
            "province": "ON",
            "provinceId": 12,
            "amount": this.allFormData[type]["spouse"].premium,
            "tax": adjustWith2DecimalsForUI(this.productobj.tax),
            "taxRate": "", //not mandatory,
            "taxName": "",
            "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "premium": this.allFormData[type]["spouse"].constant,
            "total": adjustWith2DecimalsForUI(this.productobj.total),
            "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
            "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
            "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
            "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
            "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          }






          obj["member"] = memberObj
          obj["spouse"] = spouseObj

          spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
          spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

          spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).tax
          spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["spouse"].constant, product.taxesDataJSON ?? []).total
        }




      }
      else {

        memberObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["member"].coverage.minimumCoverage,
          "coverage": "MEMBER",
          "guaranteedAcceptance": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["member"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["member"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(memberPrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["member"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["member"].coverage.age,
          "gender": this.userForm.value.gender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["member"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["member"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["member"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["member"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["member"].coverage.minimumCoverage,
        }
        spouseObj = {
          "planStartDate": this.userForm.value.planEnrollmentDate
            ? this._CustomDatePipe.transform(
              this.userForm.value.planEnrollmentDate
            )
            : undefined,
          "units": (this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / this.allFormData[type][category].coverage.minimumCoverage),
          "standardUnits": this.allFormData[type]["spouse"].coverage.minimumCoverage,
          "coverage": "MEMBER & SPOUSE",
          "guaranteedAcceptance": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <=
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false, //defalutRange
          "pendingMedicalQuestionaire": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence >
            this.allFormData[type]["spouse"].coverage.defaultRange ? true : false,
          "guaranteedAcceptanceAmount": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type][category].constant),
          "pendingApprovalAmount": adjustWith2DecimalsForUI(spousePrice * this.allFormData[type][category].constant) || 0,
          "smoker": this.allFormData[type]["spouse"].isSmoker == "yes" ? true : false,
          "age": this.allFormData[type]["spouse"].coverage.age,
          "gender": this.userForm.value.spousegender?.toLowerCase(),
          "province": "ON",
          "provinceId": 12,
          "amount": this.allFormData[type]["spouse"].premium,
          "tax": adjustWith2DecimalsForUI(this.productobj.tax),
          "taxRate": "", //not mandatory,
          "taxName": "",
          "coverageValue": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "premium": this.allFormData[type]["spouse"].constant,
          "total": adjustWith2DecimalsForUI(this.productobj.total),
          "coverageUnitPrice": this.allFormData[type]["spouse"].coverage.coverageUnitPrice,
          "defaultRange": this.allFormData[type]["spouse"].coverage.defaultRange,
          "maximumCoverageWithEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithEvidence,
          "maximumCoverageWithoutEvidence": this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence,
          "minimumCoverage": this.allFormData[type]["spouse"].coverage.minimumCoverage,
        }

        obj["member"] = memberObj
        obj["spouse"] = spouseObj

        // let price = this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence > this.allFormData[type]["member"].coverage.defaultRange?((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence-this.allFormData[type]["member"].coverage.defaultRange)/25000):0*this.allFormData[type]["member"].constant

        //   console.log(price)
        //   console.log(this.calculateTaxForProductTaxesData(price,product.taxesDataJSON??[]))
        memberObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).tax
        memberObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["member"].coverage.defaultRange ? ((this.allFormData[type]["member"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["member"].constant) : ((this.allFormData[type]["member"].coverage.defaultRange / 25000) * this.allFormData[type]["member"].constant), product.taxesDataJSON ?? []).total
        spouseObj["guaranteedAcceptanceTax"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).tax
        spouseObj["guaranteedAcceptanceTotal"] = this.calculateTaxForProductTaxesData(this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence <= this.allFormData[type]["spouse"].coverage.defaultRange ? ((this.allFormData[type]["spouse"].coverage.maximumCoverageWithoutEvidence / 25000) * this.allFormData[type]["spouse"].constant) : ((this.allFormData[type]["spouse"].coverage.defaultRange / 25000) * this.allFormData[type]["spouse"].constant), product.taxesDataJSON ?? []).total

        memberObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        memberObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(memberPrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

        spouseObj["pendingApprovalTax"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).tax
        spouseObj["pendingApprovalTotal"] = this.calculateTaxForProductTaxesData(spousePrice * this.allFormData[type]["member"].constant, product.taxesDataJSON ?? []).total

      }


      console.log(memberObj["pendingApprovalTax"])
      let MSguranteeAcceptanceAmount = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceAmount"] + (spouseObj["guaranteedAcceptanceAmount"] ?? 0))
      let MSguranteeAcceptancetTAX = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTax"] + (spouseObj["guaranteedAcceptanceTax"] ?? 0))
      let MSguranteeAcceptancetTotal = adjustWith2DecimalsForUI(memberObj["guaranteedAcceptanceTotal"] + (spouseObj["guaranteedAcceptanceTotal"] ?? 0))

      let MSpendingApprovalAmount = adjustWith2DecimalsForUI(memberObj["pendingApprovalAmount"] + (spouseObj["pendingApprovalAmount"] ?? 0))
      let MSpendingApprovalTAX = adjustWith2DecimalsForUI(memberObj["pendingApprovalTax"] + (spouseObj["pendingApprovalTax"] ?? 0))
      let MSpendingApprovalTotal = adjustWith2DecimalsForUI(memberObj["pendingApprovalTotal"] + (spouseObj["pendingApprovalTotal"] ?? 0))

      let obj1: any = {
        packageId: plan.packageId,
        packageName: pckage.name,

        planproductname: this.productobj.name,

        groupid: plan.planLevel,
        groupName: group.name,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : group.id,
        planLevelParent: group.parentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: lifeCoverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        version: plan.version,
        guaranteedAcceptanceDetails: {
          "amount": MSguranteeAcceptanceAmount,
          "tax": MSguranteeAcceptancetTAX,
          "total": MSguranteeAcceptancetTotal,
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(MSguranteeAcceptanceAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSguranteeAcceptanceAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]


        },
        pendingApprovalDetails: {
          "amount": MSpendingApprovalAmount,
          "tax": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "total": this._decimalPipe
            .transform(
              this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
              '1.2-2'
            )
            ?.replace(/,/g, ''),
          "products": [{
            id: product.id,
            productId: product.productId,
            name: product.name,
            planProductId: product.planProductId,
            price: adjustWith2DecimalsForUI(MSpendingApprovalAmount),
            tax_details:
              product.bundledTaxes && product.bundledTaxes.length > 0
                ? product.bundledTaxes
                : product.taxesDataJSON,
            calculatedTax: this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []),
            bundledProducts: product.bundledProducts,
            planCoverage: lifeCoverage,
            planLevel: product.planlevel ? product.planlevel.id : '',
            planLevelParent: product.planlevel ? product.planlevel.parentId : '',
            description: product.description,
            coverage: lifeCoverage,
            version: product.version,
            total: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).total : 0,
                '1.2-2'
              )
              ?.replace(/,/g, ''),
            tax: this._decimalPipe
              .transform(
                this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(MSpendingApprovalAmount, product.taxesDataJSON ?? []).tax : 0,
                '1.2-2'
              )
              ?.replace(/,/g, '')
          }]
        },
        selectedDetails: {
          "amount": adjustWith2DecimalsForUI(this.allFormData[type].total),
          "total": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).total : 0),

          "tax": adjustWith2DecimalsForUI(this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []) ? this.calculateTaxForProductTaxesData(this.allFormData[type].total, product.taxesDataJSON ?? []).tax : 0),
          "products": [this.productobj]
        }


      };

      obj["guaranteedAcceptanceDetails"] = obj1.guaranteedAcceptanceDetails
      obj["pendingApprovalDetails"] = obj1.pendingApprovalDetails
      obj["selectedDetails"] = obj1.selectedDetails


      obj1.products.push(this.productobj);
      this.addtoplansummaryLife(obj, obj1);
    }, 100);
    for (let i = this.minValue; i <= this.allFormData[type][category]?.coverage?.maximumCoverageWithEvidence; i += 100000) {
      this.rangeValues.push(i);
    }
  }
  public calculateTaxForProductTaxesData(price: number, taxesData: any) {
    // this.console.log(taxesData)
    // [{"tax_name":"PST","tax_code":"0002","plan_product_id":177927,"tax_description":"PST on Health Insurance","business_tax_number":"709505879TR0001","tax_rate":0.09,"tax_sku":"pstonhealthinsurance"}]
    let calculatedTax: any = {}
    let tax: any = 0;
    let planProductIds: any = []
    let planProductInfos: any = []
    if (taxesData && taxesData != undefined && taxesData != null && taxesData != "null") {
      for (const taxData of taxesData) {
        tax += adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductIds.push(taxData.plan_product_id);
        let planProductInfo: any = {};
        // planProductInfo.name = taxData.tax_description + " " + (taxData.business_tax_number ?? "");
        planProductInfo.name = taxData.tax_name;
        planProductInfo.description = taxData.tax_description;
        planProductInfo.price = adjustWith2DecimalsForUI(price * taxData.tax_rate);
        planProductInfo.planProductUniqueId = taxData.plan_product_id;
        planProductInfo.isIncluded = true;
        planProductInfo.taxRate = taxData.tax_rate;
        planProductInfo.taxRatePercentage = adjustWith2DecimalsForUI((taxData.tax_rate) * 100) + "%";
        planProductInfos.push(planProductInfo);
      }
    }

    let total = adjustWith2DecimalsForUI(price + tax)
    calculatedTax.price = adjustWith2DecimalsForUI(price);
    calculatedTax.tax = adjustWith2DecimalsForUI(tax);
    calculatedTax.total = adjustWith2DecimalsForUI(total);

    calculatedTax.planProductIds = planProductIds;
    calculatedTax.planProductInfos = planProductInfos;

    return calculatedTax;

  }

  public transformData() {
    let transformedData: any = [];
    let id = 12;

    Object.keys(this.allFormData).forEach(key => {
      const plan = this.allFormData[key];
      if (plan.total > 0) {
        const hasMember: boolean = plan.hasOwnProperty('member');

        const hasSpouse = plan.hasOwnProperty('spouse');
        const hasChildren = plan.hasOwnProperty('dependent');

        const transformedObject: any = {
          name: key.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
          id: id++,
          havingSpouse: hasSpouse,
          havingChildren: hasChildren,
          total: plan.total,
        }

        transformedObject.member = {}

        if (hasMember && plan.member.premium > 0) {
          transformedObject.member = {
            isSmoker: plan.member.isSmoker,
            total: plan.member.premium,
            units: plan.member.coverage,
            // placeOfBirth: plan.member.PlaceOfBirth,
            premium: plan.member.constant
          }
        }

        transformedObject.spouse = {}

        if (hasSpouse && plan.spouse.premium > 0) {
          transformedObject.spouse = {
            isSmoker: plan.spouse.isSmoker,
            total: plan.spouse.premium,
            units: plan.spouse.coverage,
            // placeOfBirth: plan.spouse.PlaceOfBirth,
            premium: plan.spouse.constant

          };
        }

        transformedObject.dependent = []

        if (hasChildren && plan.dependent.premium > 0) {
          const dep = this.signUpData.childrenDetails.map((d: any) => {
            return {
              childFirstName: d.childFirstName,
              childLastName: d.childLastName,
              //  total: plan.dependent.premium/this.signUpData.childrenDetails.length,
              total: plan.dependent.premium,
              units: plan.dependent.coverage,
              premium: plan.dependent.constant,
              // placeOfBirth:
              //   plan.dependent[`${d.childFirstName}-${d.childLastName}`],
            };
          });

          transformedObject.dependent = dep;
          transformedObject.dependent.allDependentPremium = {
            total: plan.dependent.premium,
            units: plan.dependent.coverage,
            premium: plan.dependent.constant
          }

        }

        transformedData.push(transformedObject);
      }
    });

    return transformedData;
  }
  public onCheckboxChangeP(
    event: any,
    type: string,
    category: string,
    key1: string,
    value1: any,
    key2?: string,
    value2?: any
  ): void {

    console.log(this.allFormData)


    console.log(value1)
    console.log(value1?.member)
    // console.log(value1?.spouse)
    if (category == 'member') {
      this.updateFormData(type, 'member', { coverage: value1.member })
    }
    if (category == 'spouse') {
      if (this.userForm.value.having_spouse === 'true') {
        this.updateFormData(type, 'spouse', { coverage: value1.spouse });
      }
    }



    let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');
    if (event.target.checked) {
      this.updateFormData(type, category, { [key1]: value1 });
      const dom: HTMLElement = this.elementRef.nativeElement;
      const plan: any = dom.querySelector("." + category + "-" + type + "-no");
      console.log(plan)
      setTimeout(() => {
        // plan.click()
      }, 100);


    } else {

      console.log(type)
      console.log(category)
      this.updateFormData(type, category, {}, true);

      if (category == 'spouse') {
        this.updateFormData(type, 'member', {}, true);


        const planCheck = this.renderer.selectRootElement("#planCheckLife" + type + "-" + 'MEMBER', true);
        this.renderer.setProperty(planCheck, 'checked', false);
      }
      if (category == 'member') {
        this.updateFormData(type, 'spouse', {}, true);

        planSummaryLife.forEach((element: any, index: any) => {

          if (element.coverage == 'MEMBER & SPOUSE') {
            const planCheck = this.renderer.selectRootElement("#planCheckLife" + type + "-" + 'SPOUSE', true);
            this.renderer.setProperty(planCheck, 'checked', false);
          }

        })

      }
      this.unselectplanLife(event)
    }


  }

  public onInputChangeP(e: Event, type: string, category: string): void {
    const inputElement = e.target as HTMLInputElement;
    if (inputElement && this.allFormData[type][category]) {
      const obj = { [inputElement.name]: inputElement.value };
      this.updateFormData(type, category, obj);
    }
  }

  public handleRangeChangeForDependent(
    value: any,
    type: string,
    category: string
  ): void {
    // if (this.allFormData[type][category]) {
    //   this.updateFormData(type, category, {
    //     // coverage: value,
    //     premium: this.updateDependentPremium(type, category, value),
    //   });
    // }
  }
  public unselectplanLife(elementcv: any) {

    // this.planCoverageName = ''
    // this.insuranceplanid =''
    console.log(elementcv)

    let plandetails = elementcv.target.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummaryLife(obj);
  }
  public addtoplansummaryLife(obj: any, obj1: any) {
    let plansummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplansLife(obj.id, plansummaryLife.length);
    plansummaryLife.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymainLife = [];
    this.planssummaryopt = [];

    plansummaryLife.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymainLife.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    sessionStorage.setItem(
      'planssummarymainLife',
      JSON.stringify(this.planssummarymainLife)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummaryLife', JSON.stringify(plansummaryLife));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
    this.planCoverafeFunction();
    if (plansummaryLife.length > 0 || planSummaryData.length > 0) {
      this.plansnexttab = false;
    } else {
      this.plansnexttab = true;
    }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }, 100);
  }
  public removeplansummaryLife(obj: any) {

    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // console.log(planSummary);

    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplansLife(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {

        planSummary.splice(index, 1);
        ////this.consoleMessage("afterremove")
        ////this.consoleMessage(planSummary)
      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)

      sessionStorage.setItem('selectedPlansLife', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymainLife = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymainLife.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        'planssummarymainLife',
        JSON.stringify(this.planssummarymainLife)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummaryLife', JSON.stringify(planSummary));
      let planSummaryData = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

      if (planSummary.length > 0 || planSummaryData.length > 0) {
        this.plansnexttab = false;
      } else {
        this.plansnexttab = true;
      }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      this.planCoverafeFunction();
      // this.planssummarymain = JSON.parse(
      //   sessionStorage.getItem('plansummarymain') || '[]'
      // );

      // var total = 0;
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);
  }
  public addtoslectplansLife(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlansLife') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlansLife', JSON.stringify(selectedPlans));
  }
  public getslectedplansLife(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlansLife') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }


  public onCheckboxChange(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any
  ) {
    // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;
    let multiple = allow_multiple == true ? true : false;


    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)



      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      //console.log(samePlanIdElements)
      let targetClassName = 'cp_plan'
      if (e.target.className.includes('cp_plan')) {
        targetClassName = 'cp_plan'
      }
      else if (e.target.className.includes('cc_plan')) {
        targetClassName = 'cc_plan'
      }
      else if (e.target.className.includes('ep_plan')) {
        targetClassName = 'ep_plan'
      }

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //console.log(elem)


        if (element.checked && element.className.includes(targetClassName)) {
          element.checked = false;
          element.disabled = false;  //need to change here for flex bronze disabled
          this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);

        }
      }
      e.target.checked = true

    } else {

    }



    //console.log(disallowedPlanLevels)
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(",");
      //console.log(disallowed_plans)
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split("##");

        //this.consoleMessage("main", plandetailsobj);
        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {
          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }


          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }


      }
    }





    //////this.consoleMessage(e)
    // //console.log(`newPlan${plan.id}`)

    let sameplanclassname = `newPlan${plan.id}`
    // //console.log(e.target.className)/////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '');
    // //console.log(classname)
    classname = e.target.className.split(' ').join('.');
    // classname = classname.split(' ').join('.');

    // if (classname[0] != '.') {
    //   classname = `.${classname}`

    // }

    // if (classname[classname.length - 1] == '.') {
    //   classname = classname.substring(0, classname.length - 1);
    // }

    //console.log(classname)
    //console.log(sameplanclassname)
    // //////this.consoleMessage(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll('.' + classname);
    const elements = dom.querySelectorAll(classname);

    const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);
    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {
            this.unselectplan(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {

      }
    } else {

      //console.log("elesehere")
      if (e.target.checked) {


        // for (let i = 0; i < samePlanElements.length; i++) {
        //   let elem = samePlanElements[i];
        //   element = elem;

        //   if (element.checked) {

        //     this.unselectplan(elem, options, plan, product, pckage, group,planindex);
        //     element.checked = false;
        //   }
        // }

        // e.checked = true;
        // e.target.checked = true;
      } else {
      }
      // alert("!")
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {

        console.log(group)
        console.log(pckage)

        let removedisabledcompanypaidproductid: any = []
        let removedisabledcoveredpaidproductid: any = []
        let removedisabledemployedpaidproductid: any = []
        if (
          group.categorization.coveredByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcompanypaidproductid.push(
                          pl
                        );
                      }
                      else {
                        removedisabledcompanypaidproductid.push(
                          // id: product.id,

                          product.planLevel,

                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcompanypaidproductid.push(
                            pl
                          );
                        }
                        else {
                          removedisabledcompanypaidproductid.push(
                            // id: product.id,

                            product.planLevel,

                          );
                        }

                      });
                    });
                  });
                }
              }
            }

          });
        } else {
        }

        if (
          group.categorization.paidByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcoveredpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledcoveredpaidproductid.push(
                          // id: product.id,
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcoveredpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledcoveredpaidproductid.push(
                            // id: product.id,
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        if (
          group.categorization.paidByEmployee == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {



          pckage.groups.forEach((element: any) => {
            //console.log(element)
            if (pckage.id != 5) {

              if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledemployedpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledemployedpaidproductid.push(
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {


              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledemployedpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledemployedpaidproductid.push(
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        console.log(removedisabledcompanypaidproductid)
        console.log(removedisabledcoveredpaidproductid)
        console.log(removedisabledemployedpaidproductid)

        removedisabledcompanypaidproductid = removedisabledcompanypaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcoveredpaidproductid = removedisabledcoveredpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledemployedpaidproductid = removedisabledemployedpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcompanypaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;


            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)
                  //  plan.disabled = false;
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            }
            else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              plan.disabled = false;
              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }





            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {

              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    /* //console.log(plan) */

                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);


              if (elem.isBundle) {
                // if (elem.id == element.id) {
                //   selectplans.splice(index, 1)
                // }

                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {


                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
                // if(elem.id==elem.products[0].id){
                //   selectplans.splice(index,1)
                // }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();

          }, 1000);
        });
        removedisabledcoveredpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;



            let plan: any = ''


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)


                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);

              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });
        removedisabledemployedpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelectorAll("#plancheck" + element.id);
            // //console.log(plan)
            // //Rakesh changes here company to upgrade
            // plan.disabled = false;
            // plan.forEach((element: any) => {
            //   //console.log(element)
            //   element.checked = false
            // });


            let plan: any = ''


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)


                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);

              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)

                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)

                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });


        this.selectplan(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      } else {


        this.unselectplan(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      }
    }, 10);
  }


  public allowmultipleplans() { }

  public disallowedPlans() { }
  public selectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {
    // ////this.consoleMessage(elementcv)
    //this.consoleMessage(plan);
    //this.consoleMessage(product)
    //this.consoleMessage(pckage)
    //this.consoleMessage(group)

    // alert("1")
    this.planobjdata = {};
    this.planobjdataobj = {}

    console.log(disallowedPlanLevels)

    let details: any = elementcv.attributes.data.value;

    let detailsObj: any = details.split("##");


    let categorization = {}

    if (group.categorization.paidByCompany == 1) {

      categorization = {
        paidByCompany: detailsObj[22] == "true" ? 0 : 1,
        coveredByCompany: detailsObj[22] == "true" ? 1 : 0,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    } else {
      categorization = {
        paidByCompany: group.categorization.paidByCompany,
        coveredByCompany: group.categorization.coveredByCompany,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    }

    //console.log(categorization)

    // paidByCompany: group.categorization.paidByCompany,
    // coveredByCompany: group.categorization.coveredByCompany,
    // paidByEmployee: group.categorization.paidByEmployee,

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }
    // if (options && options.length > 0) {
    //   let obj = {
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     enrollmentDate: this.userForm.value.planEnrollmentDate
    //       ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
    //       : undefined,
    //     // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
    //     name: plandetailsobj[14],
    //     details: plandetailsobj[0],
    //     packagename: plandetailsobj[0],
    //     groupName: plandetailsobj[1],
    //     // amount: parseFloat(plandetailsobj[3]),
    //     amount: parseFloat(product.calculatedTax.price),
    //     planCoverage: plandetailsobj[2],
    //     // planPrice: parseFloat(plandetailsobj[3]),
    //     planPrice: parseFloat(product.calculatedTax.price),
    //     // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
    //     amountUI: "$" + parseFloat(product.calculatedTax.price),
    //     gst:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[4]),
    //     hst:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[5]),
    //     pst:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[6]),
    //     qst:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[17]),
    //     gstCheck:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? false
    //         : true,
    //     hstCheck:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? false
    //         : true,
    //     pstCheck:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? false
    //         : true,
    //     qstCheck:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? false
    //         : true,
    //     id: parseFloat(plandetailsobj[7]),
    //     fusebillPlanID:
    //       plandetailsobj[8] == null ||
    //         plandetailsobj[8] == "" ||
    //         plandetailsobj[8] == undefined ||
    //         plandetailsobj[8] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[8]),
    //     planFrequencyID:
    //       plandetailsobj[9] == null ||
    //         plandetailsobj[9] == "" ||
    //         plandetailsobj[9] == undefined ||
    //         plandetailsobj[9] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[9]),
    //     optIn: plandetailsobj[10] == "true" ? true : false,
    //     planname: plandetailsobj[14],
    //     planLevel: parseInt(plandetailsobj[15]),
    //     packageId: parseInt(plandetailsobj[16]),
    //     options: [],
    //     paidByCompany1: plandetailsobj[19],
    //     coveredByCompany1: plandetailsobj[20],
    //     paidByEmployee1: plandetailsobj[21],
    //     planLevel_parentId: plandetailsobj[12],
    //     // disallowedPlanLevels: plandetailsobj[11],
    //     version: plan.version,
    //     description: plan.description,
    //     insuranceType: plan.insuranceType,
    //   };
    //   if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
    //     if (plandetailsobj[11].includes(plandetailsobj[12])) {
    //     }
    //   }
    //   let coverage = product.planCoverage;

    //   coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,

    //     planProductId: product.planProductId,
    //     price: adjustWith2DecimalsForUI(product.price1 || product.price),
    //     tax: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.tax : 0
    //     ),
    //     total: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.total : 0
    //     ),
    //     //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
    //     //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
    //     //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel
    //       ? product.planlevel.id
    //       : plan.planLevel
    //         ? plan.planLevel
    //         : group.id,
    //     planLevelParent: product.planlevel
    //       ? product.planlevel.parentId
    //       : group.parentId,
    //     description: product.description,
    //     coverage: coverage,
    //     version: product.version
    //   };
    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //     upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    //   };
    //   obj1.products.push(this.productobj);
    //   let finalobj1: any = { ...obj1, ...categorization };



    //   //this.consoleMessage(obj1);


    //   this.planobjdata = finalobj1;
    //   this.planobjdataobj = obj
    //   this.elementcvValues = elementcv

    //   console.log(this.planobjdata)

    //   // this.addtoplansummary(obj, obj1, elementcv);
    //   this.addtoplansummary(obj, finalobj1, elementcv);
    //   setTimeout(() => {


    //     // this.openplanoptions(elementcv, options, plan, product)

    //     this.openplanoptions(elementcv)
    //   }, 1000);
    // }
    // else {
    let obj = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      // amount: parseFloat(plandetailsobj[3]),
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      // planPrice: parseFloat(plandetailsobj[3]),
      planPrice: parseFloat(product.calculatedTax.price),
      // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      amountUI: "$" + parseFloat(product.calculatedTax.price),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      // disallowedPlanLevels: plandetailsobj[11],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,

      planProductId: product.planProductId,
      //  price: product.price1 || product.price,
      //  tax: product.calculatedTax ? product.calculatedTax.tax : 0,
      //  total: product.calculatedTax ? product.calculatedTax.total : 0,

      price: adjustWith2DecimalsForUI(product.price1 || product.price),
      tax: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.tax : 0
      ),
      total: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.total : 0
      ),
      //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
      //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
      //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),

      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel
        ? product.planlevel.id
        : plan.planLevel
          ? plan.planLevel
          : group.id,
      planLevelParent: product.planlevel
        ? product.planlevel.parentId
        : group.parentId,
      description: product.description,
      coverage: coverage,
      version: product.version
    };
    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
      upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    };

    obj1.products.push(this.productobj);
    let finalobj1: any = { ...obj1, ...categorization };

    //console.log(finalobj1)


    this.addtoplansummary(obj, finalobj1, elementcv);
    setTimeout(() => {

      this.openplanoptions(elementcv)
    }, 1000);
    // }
  }

  public unselectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {

    //console.log(plan)

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    let obj = {
      isBundle: plan.isBundle,
      enrollmentDate: this.userForm.value.planEnrollmentDate
        ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
        : undefined,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      disallowedPlanLevels: plandetailsobj[11],
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummary(obj, group, pckage, elementcv);
    setTimeout(() => {


      this.openplanoptions(elementcv)


    }, 1000);
  }


  public addtoplansummary(obj: any, obj1: any, e: any) {
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || "[]");

    // console.log(obj)
    // console.log(obj1)

    /* This code mainly for flex plan silver and gold */


    for (let i = 0; i < planSummary.length; i++) {
      if (obj1.planLevelParent) {
        if (planSummary[i].planLevelParent == obj1.planLevelParent && planSummary[i].coveredByCompany == obj1.coveredByCompany) {

          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("#plancheck" + planSummary[i].id + ".coverage" + planSummary[i].coverage);
          //console.log(plan)
          if (plan.checked) {
            plan.checked = false
          }
          planSummary.splice(i, 1)
        }
      }
    }



    //this.consoleMessage("obj1", obj1);
    //console.log("obj", obj);
    setTimeout(() => {
      const dom: HTMLElement = this.elementRef.nativeElement;
      const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
      const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
      const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
      // //console.log(plan)

      if (obj.coverage === "SINGLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "COUPLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "FAMILY") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
      } else {
        // Default case - hide all plans if coverage doesn't match expected
      }



    }, 2000);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.options && obj.options.length > 0) {
      obj["disallowedPlanLevels"] = obj1.disallowedPlanLevels

    }

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;

      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj["gstPrice"] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(hstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj["hstPrice"] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;


      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj["pstPrice"] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj["qstPrice"] = 0;
    }

    obj["taxUI"] = "";
    if (obj["gstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["gstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
          "&nbsp;(GST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["pstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["pstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
          "&nbsp;(PST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["qstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["qstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
          "&nbsp;(QST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["hstCheck"]) {
      obj["taxUI"] += "<span> ";
      if (obj["hstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
          "&nbsp;(HST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (
      !obj["hstCheck"] &&
      !obj["gstCheck"] &&
      !obj["pstCheck"] &&
      !obj["qstCheck"]
    ) {
      obj["taxUI"] += "<span>-";

      obj["taxUI"] += "</span>";
    }

    // ////this.consoleMessage(object["taxUI"])

    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, "1.2-2")
    // );
    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2")
    // );
    obj['tax'] = obj1.products[0]
      ? this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2") : 0;
    obj['tax'] = parseFloat(obj['tax']);
    // obj["products"] =obj1

    obj["coverage"] = obj1.coverage;
    obj["planCoverage"] = obj1.planCoverage;
    obj["planLevelParent"] = obj1.planLevelParent;
    obj["planproductname"] = obj1.planproductname;

    obj["products"] = obj1.products;
    obj["upgradeCalculation"] = obj1.upgradeCalculation;
    obj["paidByCompany"] = obj1.paidByCompany;
    obj["coveredByCompany"] = obj1.coveredByCompany;
    obj["paidByEmployee"] = obj1.paidByEmployee;



    let pricecal = obj1.products[0].calculatedTax.total;
    obj["totalPrice"] = pricecal;

    obj["totalUI"] = "$" + pricecal;

    (obj["total"] = pricecal),
      (obj["skuTotalPrice"] = parseFloat(
        obj1.products.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.total;
        }, 0)
      ));

    let updatedSum = this.addtosum(obj.skuTotalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != "Opt-in") {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem("plansskumain", JSON.stringify(this.plansskumain));

    sessionStorage.setItem(
      "plansummarymain",
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      "plansummaryopt",
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem("plansummary", JSON.stringify(planSummary));

    // setTimeout(() => {
    this.planCoverafeFunction();

    // }, 3000);

    if (planSummary.length > 0) {
      this.plansnexttab = false;
    } else {
      this.plansnexttab = true;
    }

    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }
    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   if (obj.planproductname.includes("La Vie")) {

      //     if (this.planssummarymain[i].planLevel == 18) {

      //       if (this.planssummarymain[i].coverage == obj.coverage) {

      //       } else {
      //         const dom: HTMLElement = this.elementRef.nativeElement;
      //         // const plan: any = dom.querySelector(`#plancheck792`)
      //         const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
      //         setTimeout(() => {
      //           plan.click()
      //           this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
      //         }, 1000);
      //       }
      //       break;
      //     }
      //     else {

      //       const dom: HTMLElement = this.elementRef.nativeElement;
      //       // const plan: any = dom.querySelector(`#plancheck792`)
      //       const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

      //       console.log(plan)
      //       setTimeout(() => {
      //         plan.click()
      //         this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
      //       }, 1000);
      //     }
      //   }
      // }
      this.companypaidproductid = this.companypaidproductid.filter(
        (item: any) => item !== undefined && item !== null
      );

      var result = this.companypaidproductid.reduce((unique: any, o: any) => {
        if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log(result);
      const filteredPlans = result.filter((result: any) => result.planLevel === 18);

      console.log(filteredPlans);


      if (filteredPlans.length > 0) {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
            }



          }
        }
      } else {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].planLevel == 18) {

              if (this.planssummarymain[i].coverage == obj.coverage) {

              } else {
                const dom: HTMLElement = this.elementRef.nativeElement;
                // const plan: any = dom.querySelector(`#plancheck792`)
                const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
                setTimeout(() => {
                  plan.click()
                  this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
                }, 1000);
              }
              break;
            }
            else {

              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

              console.log(plan)
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
              break;
            }
          }
        }
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      //this.consoleMessage(total);

      this.planAmount = parseFloat(total.toString());
      sessionStorage.setItem("totalAmount", this.planAmount);
    }, 100);

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";



      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          const dom: HTMLElement = this.elementRef.nativeElement;
          const plan: any = dom.querySelector("#plancheck" + element.id);

          const samePlanIdElements = dom.querySelectorAll('#' + e.id);
          //console.log(samePlanIdElements)
          let targetClassName = 'cp_plan'
          if (e.className.includes('cp_plan')) {
            targetClassName = 'cp_plan'
          }
          else if (e.className.includes('cc_plan')) {
            targetClassName = 'cc_plan'
          }
          else if (e.className.includes('ep_plan')) {
            targetClassName = 'ep_plan'
          }

          for (let i = 0; i < samePlanIdElements.length; i++) {
            let elem = samePlanIdElements[i];
            let element: any = elem;
            // //console.log(elem)
            // //console.log(elem.className.includes('cp_plan'))
            if (elem.className.includes('cp_plan')) {
              element.disabled = false;
              if (element.checked) {
                element.disabled = true;

              }
            }
          }
          if (plan) {
            // plan.disabled = true;
            // if(plan.isBundle){
            //   plan.disabled = false;
            // }else{
            //   plan.disabled = false;
            // }

          }
        }
      });
    }, 1000);
  }

  public getindexofplan(obj: any) {

    //console.log(obj)
    let plansproductarray = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    for (let i = 0; i < plansproductarray.length; i++) {
      if (obj.isBundle == false) {
        if (plansproductarray[i].id == obj.id) {

          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                // plan.disabled = false;
              }
            })

          }
          return i;
        }
      } else {
        if (plansproductarray[i].id == obj.id) {
          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                plan.disabled = false;
              }
            })

          }
          return i;
        }
      }
    }
  }

  toggleItem1(item: any): void {
    item.expanded = !item.expanded;
  }
  toggleItem2(item: any): void {
    item.expanded = !item.expanded;
  }

  public removeplansummary(obj: any, group: any, pckage: any, e: any) {



    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    if (planSummary) {

      let index: any = this.getindexofplan(obj);
      if (index > -1) {
        planSummary.splice(index, 1);
      } else {

        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;


        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj["gstPrice"] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;




        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(hstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);

      } else {
        obj["hstPrice"] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;


        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);




      } else {
        obj["pstPrice"] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj["qstPrice"] = 0;
      }

      obj["taxUI"] = "";
      if (obj["gstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["gstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
            "&nbsp;(GST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["pstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["pstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
            "&nbsp;(PST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["qstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["qstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
            "&nbsp;(QST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["hstCheck"]) {
        obj["taxUI"] += "<span> ";
        if (obj["hstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
            "&nbsp;(HST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (
        !obj["hstCheck"] &&
        !obj["gstCheck"] &&
        !obj["pstCheck"] &&
        !obj["qstCheck"]
      ) {
        obj["taxUI"] += "<span>-";

        obj["taxUI"] += "</span>";
      }

      // ////this.consoleMessage(object["taxUI"])



      obj['tax'] = gstprice + hstprice + pstprice + qstprice
        ? this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, '1.2-2')
        : 0;
      obj['tax'] = parseFloat(obj['tax']);
      (obj["totalPrice"] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj["totalUI"] =
          "$" +
          parseFloat(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice
          ));

      obj["total"] = parseFloat(
        obj.planPrice + gstprice + hstprice + pstprice + qstprice
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];
      console.log(planSummary)

      planSummary.forEach((element: any) => {
        if (element.packagename != "Opt-in") {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        "plansummarymain",
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        "plansummaryopt",
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem("plansummary", JSON.stringify(planSummary));
      if (planSummary.length > 0) {
        this.plansnexttab = false;
      } else {
        this.plansnexttab = true;
      }


      this.planCoverafeFunction();


      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }





      setTimeout(() => {
        let selectplans =
          JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

        //console.log(pckage);
        //console.log(group);

        let adddisabledcompanypaidproductid: any = []

        if (
          group.categorization.coveredByCompany == 1
          ||
          group.categorization.paidByEmployee == 1
        ) {
          pckage.groups.forEach((element: any) => {
            if (element.categorization.paidByCompany == 1) {
              if (group?.parentId == element?.parentId) {
                element.plans.forEach((plan: any) => {

                  let pl = { ...plan, ...element.categorization }
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      //console.log(product)
                      //console.log(pl)
                      if (pl.isBundle) {
                        adddisabledcompanypaidproductid.push(
                          pl,
                        );
                      } else {
                        adddisabledcompanypaidproductid.push(product.planlevel);
                      }

                    });
                  });
                });
              }
            }
          });



          adddisabledcompanypaidproductid = adddisabledcompanypaidproductid.filter(
            (item: any) => item !== undefined && item !== null
          );
          console.log(adddisabledcompanypaidproductid);

          for (let i = 0; i < adddisabledcompanypaidproductid.length; i++) {
            // adddisabledcompanypaidproductid.forEach((element: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector("#plancheck" + adddisabledcompanypaidproductid[i].id);


            // const planCheck1 = this.renderer.selectRootElement("#plancheck" + element.id, true);

            let selectPlanCheck;
            if (obj?.isBundle == true) {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId && el.planLevelParent == adddisabledcompanypaidproductid[i].planLevel_parentId;
              })
            }
            else {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId;
              })



              let planData: any = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
              let targetClassName = 'cp_plan'
              if (e.className.includes('cp_plan')) {
                targetClassName = 'cp_plan'
              }
              else if (e.className.includes('cc_plan')) {
                targetClassName = 'cc_plan'
              }
              else if (e.className.includes('ep_plan')) {
                targetClassName = 'ep_plan'
              }

              for (let i = 0; i < planData.length; i++) {
                console.log(planData[i])
                if (planData[i].className.includes('cp_plan')) {
                  planData[i].click()
                  return false;

                }
              }


            }

            //console.log(selectPlanCheck)
            if (selectPlanCheck) {

              selectplans.forEach((products: any) => {

                if (products.packageId == adddisabledcompanypaidproductid[i].packageId) {

                  products.products.forEach((prod: any) => {
                    // if (prod.id == adddisabledcompanypaidproductid[i].id) {
                    if (prod.planLevel == adddisabledcompanypaidproductid[i].id) {
                    } else {
                      //console.log("checkHere")
                      // $("#plancheck" + element.id).click()
                    }
                  });
                } else {
                  // //this.consoleMessage("CheckHere1")

                }
              });
            } else {


              const dom: HTMLElement = this.elementRef.nativeElement;

              let coverage = adddisabledcompanypaidproductid[i].companyPaidCoverage?.replace("SELECTIVE_", "")
              //console.log(coverage)

              let planData;
              if (coverage && coverage != "DIRECT") {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id + ".coverage" + coverage)
                //console.log(planData)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
                break;
              }
              else {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
              }


            }
          }
        }




        setTimeout(() => {
          let selectplans =
            JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

          selectplans.forEach((products: any) => {
            if (products.paidByCompany == 1) {
              products.products.forEach((element: any) => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck" + element.id);

                //this.consoleMessage(plan);

                if (plan) {

                }


                const samePlanIdElements = dom.querySelectorAll('#' + e.id);
                //console.log(e)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                for (let i = 0; i < samePlanIdElements.length; i++) {
                  let elem = samePlanIdElements[i];
                  let element: any = elem;
                  if (elem.className.includes('cp_plan')) {
                    element.disabled = false;
                    if (element.checked) {
                      element.disabled = true;

                    }
                  }

                }
              });
            }
          });
        }, 1000);
      }, 100);



      setTimeout(() => {
        let selectplansInfo =
          JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";

        //console.log(selectplansInfo)

        if (selectplansInfo.length > 0) {
          for (let i = 0; i < selectplansInfo.length; i++) {
            if (selectplansInfo[i].id == obj.id) {

            }

            else {
              setTimeout(() => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
                const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
                const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
                /*  //console.log(plan) */


                plan.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });

                plan2.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });
                plan3.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });



              }, 1000);
            }
          }



        }
        else {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
            const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
            const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
            /*  //console.log(plan) */


            plan.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });

            plan2.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });
            plan3.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });



          }, 1000);
        }
      }, 1000);

      setTimeout(() => {
        let selectplansInfo = JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";
        if (selectplansInfo.length === 0) {
          if (obj.groupName != "Complete Executive Care") {
            this.autoSelectCompanyPaidPlans()
          }


        }
      }, 1000);
    }
  }
  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.logger.log("beforeaddtoplans")
    ////this.logger.log(planid)
    ////this.logger.log(plansumamryindex)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}");
    ////this.logger.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.logger.log("afteraddtoplans")
    ////this.logger.log(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans));
  }
  public removeslectplans(planid: number, plansumamryindex: number) {
    ////this.logger.log("beforeremoveplans")
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans"));

    ////this.logger.log(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      ////this.logger.log(planid)
      ////this.logger.log(selectedPlans[planid])

      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    ////this.logger.log("adjustedselectedPlans")
    ////this.logger.log(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans));
  }

  public getslectedplans(planid: number) {
    ////this.logger.log(planid)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}");
    ////this.logger.log(selectedPlans)
    return selectedPlans[planid];
  }
  public addtosum(amount: any) {
    //this.logger.log("addtosum" + amount);

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);
    // let selectedPlansAmount:any = parseFloat(sessionStorage.getItem("totalAmount") || "0.00");

    // // selectedPlansAmount = selectedPlansAmount + amount;
    // selectedPlansAmount = selectedPlansAmount+parseFloat(amount)
    //this.logger.log("selectedPlansAmount" + selectedPlansAmount);

    console.log(selectedPlansAmount)
    sessionStorage.setItem(
      "totalAmount",
      this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    // this.planAmount = selectedPlansAmount

    this.planAmount = this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "");

    //this.logger.log("palnamopunt" + this.planAmount);
    return selectedPlansAmount;
    // //////this.logger.log(this.planAmount )
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(sessionStorage.getItem("totalAmount").replace(/,/g, ""));

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      "totalAmount",
      this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );
    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    // this.planAmount = selectedPlansAmount
    this.planAmount = this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "");
    return selectedPlansAmount;
  }

  calculateBasePlanDeltasforCCplans1(ccplanspackages, baseplans, compnayplans) {


    let modifiedCCplanPackages = []
    for (let i = 0; i < ccplanspackages.length; i++) {
      let modifiedCCPackage = ccplanspackages[i]
      //this.logger.log(ccplanspackages[i].name)
      //this.logger.log(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC

      modifiedCCPackage.groupsCC = []
      for (let CCplangroup of CCplansgroups) {

        let modifiedCCgroup = CCplangroup
        //this.logger.log(CCplangroup.id)
        //this.logger.log(CCplangroup.parentId)
        //this.logger.log(CCplangroup.name)
        let CCplans = CCplangroup.plans
        modifiedCCgroup.plans = []
        for (let CCplan of CCplans) {

          let modifiedCCplan = CCplan
          //this.logger.log(CCplan.id)
          //this.logger.log(CCplan.isBundle)
          //this.logger.log(CCplan.name)

          CCplan.planLevel_parentId = CCplangroup.parentId

          let payroll = true;
          let EmployeeChoice = 0

          if (this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)) {

            if (EmployeeChoice == 2) {
              payroll = false;
            }

          }
          else {
            if (this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(CCplan.planLevel)) {

              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];

          if (CCplan.isBundle) {
            //this.logger.log("BundlePlan")

            //this.logger.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan) {
              //this.logger.log(plan)
              //cp_plans

              //this.logger.log(CCplan.packageId,plan.packageId)
              //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.logger.log(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan) {
              //this.logger.log(plan)
              //cp_plans

              //this.logger.log(CCplan.packageId,plan.packageId)
              //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.logger.log(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            console.log(filtered_base_plans);

            //this.logger.log(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct;
            let selectedBaseplanProductsArray = [];
            let selectedCompanyplanProduct;
            let selectedCompanyplanProductsArray = [];

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              this.logger.log(filtered_base_plans.length);
              var filtered_base_plans2 = filtered_base_plans.filter(function (plan) {


                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan) {
                ////this.logger.log(plan)
                //cp_plans

                // //this.logger.log(CCplan.packageId,plan.packageId)
                // //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
                // //this.logger.log(CCplan.planLevel,plan.planLevel)

                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
              // alert("morethan1")
            }
            console.log({ selectedBasePlan })

            if (selectedBasePlan) {
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }
                this.logger.log(selectedBaseplanProductsArray)
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                this.logger.log(selectedBaseplanProductsArray)
              }
              else {
                let productCoverageFound = false;
                for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                  for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                    if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                      productCoverageFound = true
                      selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                      break;
                    }


                  }
                  if (!productCoverageFound) {



                    selectedBasePlan = {};
                    selectedBaseplanProduct = {};
                    selectedBaseplanProduct.calculatedTax = {};
                    selectedBaseplanProduct.calculatedTax.price = 0;
                    selectedBaseplanProduct.calculatedTax.tax = 0;
                    selectedBaseplanProduct.calculatedTax.total = 0;
                    selectedBaseplanProduct.name = "NA";
                    selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                    selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                  }

                }
                this.logger.log(selectedBaseplanProductsArray)
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                this.logger.log(selectedBaseplanProductsArray)
              }




            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              this.logger.log(selectedCompanyplanProductsArray)
              this.logger.log(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                this.logger.log(selectedCompanyplanProductsArray)
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
                this.logger.log(selectedCompanyplanProductsArray)

              } else {
                let productCoverageFound = false;
                for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                  for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                    if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                      productCoverageFound = true
                      selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                      break;
                    }


                  }
                  if (!productCoverageFound) {


                    selectedCompanyplanProduct = {};
                    selectedCompanyplanProduct.calculatedTax = {};
                    selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                    selectedCompanyplanProduct.name = "NA";
                    selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                  }

                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
              this.logger.log(selectedCompanyplanProductsArray)
            }


            this.logger.log(selectedCompanyplanProductsArray)
            //this.logger.log(selectedBaseplanProduct.calculatedTax?.price)
            //this.logger.log(selectedBaseplanProduct.calculatedTax.tax)
            //this.logger.log(selectedBaseplanProduct.calculatedTax.total)
            // let selectedCCplanProduct = CCplan.productAddonss[CCplan.name][0]

            //this.logger.log(selectedCCplanProduct.calculatedTax?.price)
            //this.logger.log(selectedCCplanProduct.calculatedTax.tax)
            //this.logger.log(selectedCCplanProduct.calculatedTax.total)

            //this.logger.log("Delta")
            //this.logger.log(selectedCCplanProduct.calculatedTax?.price-selectedBaseplanProduct.calculatedTax?.price)
            //this.logger.log("EmployeeTax")
            //this.logger.log(selectedCCplanProduct.calculatedTax.planProductInfos.length>0?selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
            //this.logger.log(selectedCCplanProduct.calculatedTax.planProductInfos.length>0?selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)

            //this.logger.log("CompanyTax")
            //this.logger.log(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
            //this.logger.log(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.logger.log("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []

            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax?.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax?.price -
                selectedBaseplanProduct.calculatedTax?.price
              );

              if (selectedBaseplanProduct.name == 'NA') {
                //this.logger.log("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              let deltaplanTax = adjustWith2DecimalsForUI(
                deltaplanPrice *
                (this.deltaCompanyTax ? companyTax : employeeTax)
              );
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };

              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
              };

              this.logger.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;
            }

          }
          else {
            this.logger.log("Not a BundlePlan")

            this.logger.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan) {

              console.log(plan)
              //cp_plans

              console.log(CCplan.packageId, plan.packageId)
              console.log(CCplan.planLevel_parentId, plan.planLevel_parentId)
              console.log(CCplan.planLevel, plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan) {

              console.log(plan)
              //cp_plans

              console.log(CCplan.packageId, plan.packageId)
              console.log(CCplan.planLevel_parentId, plan.planLevel_parentId)
              console.log(CCplan.planLevel, plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            this.logger.log(filtered_base_plans)

            this.logger.log(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            if (filtered_base_plans.length == 0) {

            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0]
              selectedCompnayPlan = filtered_compnay_plans[0]

            } else {
              //this.logger.log(filtered_base_plans.length)
            }

            let selectedbaseplanproduct
            let selectedBaseplanProduct

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {

                this.logger.log(planname)
                this.logger.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname]

                if (products.length == 0) {

                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0]
                  // selectedCompnayPlan= filtered_compnay_plans[0]

                } else {
                  //this.logger.log(products.length)
                }
              }
              //this.logger.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct

              this.logger.log(selectedBaseplanProduct.calculatedTax?.price)
              this.logger.log(selectedBaseplanProduct.calculatedTax?.tax)
              this.logger.log(selectedBaseplanProduct.calculatedTax?.total)
            }
            else {
              selectedBasePlan = {}
              selectedBaseplanProduct = {}
              selectedBaseplanProduct.calculatedTax = {}
              selectedBaseplanProduct.calculatedTax.price = 0
              selectedBaseplanProduct.calculatedTax.tax = 0
              selectedBaseplanProduct.calculatedTax.total = 0
              selectedBaseplanProduct.name = "NA"
            }





            let CCplanProduct;

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname]
              if (products.length == 0) {

              } else if (products.length == 1) {
                CCplanProduct = products[0]
                // selectedCompnayPlan= filtered_compnay_plans[0]

              } else {
                //this.logger.log(products.length)
              }
            }
            console.log({ CCplanProduct, CCplan })
            let selectedCCplanProduct = CCplanProduct


            // //this.logger.log(selectedCCplanProduct.calculatedTax?.price)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.tax)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.total)


            // //this.logger.log("Delta")
            // //this.logger.log(selectedCCplanProduct.calculatedTax?.price-selectedBaseplanProduct.calculatedTax?.price)
            // //this.logger.log("EmployeeTax")
            // //this.logger.log(selectedCCplanProduct.calculatedTax.planProductInfos.length>0?selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.planProductInfos.length>0?selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)

            let selectedcompanyplanproduct
            let selectedCompanyplanProduct

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {

                //this.logger.log(planname)
                //this.logger.log(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname]

                if (products.length == 0) {

                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0]
                  // selectedCompnayPlan= filtered_compnay_plans[0]

                } else {
                  //this.logger.log(products.length)
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct

              //this.logger.log("CompanyTax")
              //this.logger.log(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.logger.log(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)

            }
            else {
              selectedCompanyplanProduct = {}
              selectedCompanyplanProduct.calculatedTax = {}
              selectedCompanyplanProduct.calculatedTax.planProductInfos = []
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction"
              upgradepaymentText = "using payroll deduction"
              //this.logger.log("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            }
            else {
              upgradeText = "Employee upgraded using Direct payment"
              upgradepaymentText = "using Direct payment"


            }
            console.log({ selectedCCplanProduct })
            let companyTax = selectedCompanyplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCompanyplanProduct.calculatedTax?.planProductInfos[0].taxRate : 0
            let companyTaxPercentage = selectedCompanyplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCompanyplanProduct.calculatedTax?.planProductInfos[0].taxRatePercentage : 0
            let baseplanPrice = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.price)
            let baseplanTaxorg = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.tax)
            let baseplanTax = adjustWith2DecimalsForUI(baseplanPrice * companyTax)
            let baseplanTotalorg = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.total)
            let baseplanTotal = adjustWith2DecimalsForUI(baseplanPrice + baseplanTax)
            let employeeTax = selectedCCplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRate : 0
            let employeeTaxPercentage = selectedCCplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCCplanProduct.calculatedTax?.planProductInfos[0].taxRatePercentage : 0

            let deltaplanPrice = adjustWith2DecimalsForUI(selectedCCplanProduct.calculatedTax?.price - selectedBaseplanProduct.calculatedTax?.price)
            if (selectedBaseplanProduct.name == 'NA') {
              //this.logger.log("No Base plan/product for this upgrade plans/product")
              companyTax = employeeTax
              companyTaxPercentage = employeeTaxPercentage
            }
            let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax))
            // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

            let deltaplanTotal = adjustWith2DecimalsForUI(deltaplanPrice + deltaplanTax)



            let combinedplanPrice = baseplanPrice + deltaplanPrice
            let combinedplanbasePrice = baseplanPrice
            let combinedplanDeltaprice = deltaplanPrice
            let combinedplanTax = adjustWith2DecimalsForUI(baseplanTax + deltaplanTax)
            let combinedplanCompanyTax = baseplanTax
            let combinedplanEmployeeTax = adjustWith2DecimalsForUI(deltaplanTax)
            let combinedplanCompanyTaxPercentage = companyTaxPercentage
            let combinedplanemployeeTaxPercentage = this.deltaCompanyTax ? companyTaxPercentage : employeeTaxPercentage
            let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage
            let combinedplanTotal = adjustWith2DecimalsForUI(baseplanTotal + deltaplanTotal)

            let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`
            let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`
            let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`
            let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`
            let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `
            let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `
            let type;

            if (payroll) {
              type = "Split with payroll deduction"
            } else {
              type = "Split with direct pay"

            }
            let basePlanDetails = {
              planId: selectedBasePlan.id || 0, //0
              planName: selectedBasePlan.name || "NA", //NA
              planLevelId: selectedBasePlan.planLevel || 0, //0
              amount: baseplanPrice || 0, //0
              amountUI: `$${baseplanPrice}` || 0, //0
              tax: baseplanTax,
              total: baseplanTotal,
              taxUI: `$${baseplanTax}`, //companyTaxpercentage
              totalUI: `$${baseplanTotal}`,
              planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
              planFrequencyID: selectedBasePlan.frqMonthly || "",
              planFusebillID: selectedBasePlan.fusebillId || "",
              products: [selectedBaseplanProduct],
              planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
              packageName: selectedBasePlan.packageName || "",
              packageId: selectedBasePlan.packageId || 0
            };
            let obj = {
              companyTax, companyTaxPercentage, baseplanPrice, baseplanTaxorg, baseplanTax, baseplanTotalorg, baseplanTotal, employeeTax, employeeTaxPercentage,
              deltaplanPrice, deltaplanTax, deltaplanTotal, combinedplanPrice, combinedplanbasePrice, combinedplanDeltaprice, combinedplanTax,
              combinedplanCompanyTax, combinedplanEmployeeTax, combinedplanCompanyTaxPercentage, combinedplanemployeeTaxPercentage, combinedplanTotal, payroll,
              scenario, planName, compnayShareStatement, employeeShareStatement, planDescription, planDescription2, type, basePlanDetails, combinedplanemployeeTaxPercentageorg
            }

            //this.logger.log(obj)
            modifiedCCplan.upgradeCalculation = obj

          }
          modifiedCCgroup.plans.push(modifiedCCplan)

        }
        modifiedCCPackage.groupsCC.push(modifiedCCgroup)


      }

      modifiedCCplanPackages.push(modifiedCCPackage)


    }

    this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages

    //this.logger.log(this.modifiedBlocksCoveredByCompany)
  }
  // calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

  //   //console.log(ccplanspackages)
  //   let modifiedCCplanPackages = [];
  //   //console.log(baseplans)
  //   for (let i = 0; i < ccplanspackages?.length; i++) {
  //     let modifiedCCPackage = ccplanspackages[i];
  //     //this.consoleMessage(ccplanspackages[i].name)
  //     //this.consoleMessage(ccplanspackages[i].id)
  //     let CCplansgroups = ccplanspackages[i].groupsCC;

  //     modifiedCCPackage.groupsCC = [];
  //     for (let CCplangroup of CCplansgroups) {
  //       let modifiedCCgroup = CCplangroup;

  //       let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

  //       let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"

  //       // let selectedCoverage = CCplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"

  //       if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
  //         selectedCoverage = "DIRECT"
  //       }
  //       if (selectedCoverage != "DIRECT") {
  //         selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
  //       }

  //       //console.log(selectedCoverage)
  //       let CCplans = CCplangroup.plans;
  //       //console.log(CCplangroup)

  //       modifiedCCgroup.plans = [];
  //       for (let CCplan of CCplans) {
  //         let modifiedCCplan = CCplan;
  //         //this.consoleMessage(CCplan.id);
  //         //this.consoleMessage(CCplan.isBundle);
  //         //this.consoleMessage(CCplan.name);

  //         CCplan.planLevel_parentId = CCplangroup.parentId;

  //         let payroll = true;
  //         let EmployeeChoice = 0;

  //         if (
  //           this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
  //         ) {
  //           if (EmployeeChoice == 2) {
  //             payroll = false;
  //           }
  //         } else {
  //           if (
  //             this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
  //               CCplan.planLevel
  //             )
  //           ) {
  //             if (EmployeeChoice == 2) {
  //               payroll = false;
  //             }
  //           }
  //         }
  //         let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
  //         //console.log(CCplan)
  //         //console.log(CCplan.productAddonss[CCplan.name])

  //         if (CCplan.isBundle) {
  //           //this.consoleMessage("BundlePlan")

  //           //this.consoleMessage(baseplans)
  //           //console.log(baseplans)
  //           var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



  //             return (
  //               CCplan.packageId == plan.packageId &&
  //               CCplan.planLevel_parentId == plan.planLevel_parentId &&
  //               CCplan.planLevel >= plan.planLevel &&
  //               plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
  //             );
  //           });

  //           var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {
  //             //this.consoleMessage(plan)
  //             //cp_plans

  //             //this.consoleMessage(CCplan.packageId,plan.packageId)
  //             //this.consoleMessage(CCplan.planLevel_parentId,plan.planLevel_parentId)
  //             //this.consoleMessage(CCplan.planLevel,plan.planLevel)

  //             return (
  //               CCplan.packageId == plan.packageId &&
  //               CCplan.planLevel_parentId == plan.planLevel_parentId &&
  //               CCplan.planLevel >= plan.planLevel &&
  //               plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
  //             );
  //           });

  //           //this.consoleMessage(filtered_base_plans);

  //           //this.consoleMessage(filtered_compnay_plans)
  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           let selectedBaseplanProduct: any;
  //           let selectedBaseplanProductsArray: any = [];
  //           let selectedCompanyplanProduct: any;
  //           let selectedCompanyplanProductsArray: any = [];


  //           //console.log("length" + filtered_base_plans.length)
  //           //console.log(filtered_base_plans)
  //           //console.log(filtered_compnay_plans)

  //           if (filtered_base_plans.length == 0) {
  //           } else if (filtered_base_plans.length == 1) {
  //             selectedBasePlan = filtered_base_plans[0];
  //             selectedCompnayPlan = filtered_compnay_plans[0];
  //           } else {


  //             var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
  //               return (
  //                 CCplan.id == plan.id
  //               );
  //             });
  //             var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


  //               return (
  //                 CCplan.id == plan.id
  //               );
  //             });
  //             selectedBasePlan = filtered_base_plans2[0];
  //             selectedCompnayPlan = filtered_compnay_plans2[0];
  //           }

  //           //console.log(selectedBasePlan)
  //           //console.log(selectedCompnayPlan)
  //           //console.log("name" + selectedBasePlan?.name)
  //           if (selectedBasePlan) {
  //             // //this.consoleMessage(selectedBasePlan)
  //             // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
  //             selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
  //             let selectedBaseplanProductsArray2 = [];
  //             //  //this.consoleMessage(CCplan.packageId)
  //             if (CCplan.packageId == 5 || CCplan.packageId == 10) {
  //               selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
  //               for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
  //                 selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
  //               }

  //               let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
  //               // //this.consoleMessage(selectedBaseplanProductsArray)

  //               if (remainigProdcuts > 0) {
  //                 for (let i = 0; i < remainigProdcuts; i++) {
  //                   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
  //                 }
  //               }
  //               selectedBaseplanProductsArray = selectedBaseplanProductsArray2
  //               // //this.consoleMessage(selectedBaseplanProductsArray)
  //             }
  //             else {

  //               // Direct Coverage Method
  //               // setTimeout(() => {
  //               if (selectedCoverage == "DIRECT") {
  //                 selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
  //                 //console.log(selectedBaseplanProductsArray)
  //               }

  //               // Selective single Coverage Method
  //               if (selectedCoverage == "SINGLE") {
  //                 selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
  //               }
  //               // Selective Couple Coverage Method

  //               if (selectedCoverage == "COUPLE") {
  //                 selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
  //               }
  //               //  // Selective Family Coverage Method
  //               if (selectedCoverage == "FAMILY") {
  //                 selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
  //               }

  //               //console.log(selectedBaseplanProductsArray)
  //               // }, 1000)

  //               // let productCoverageFound = false;
  //               // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //               //   for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

  //               //     if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
  //               //       productCoverageFound = true
  //               //       selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
  //               //       break;
  //               //     }


  //               //   }
  //               //   if (!productCoverageFound) {



  //               //     selectedBasePlan = {};
  //               //     selectedBaseplanProduct = {};
  //               //     selectedBaseplanProduct.calculatedTax = {};
  //               //     selectedBaseplanProduct.calculatedTax.price = 0;
  //               //     selectedBaseplanProduct.calculatedTax.tax = 0;
  //               //     selectedBaseplanProduct.calculatedTax.total = 0;
  //               //     selectedBaseplanProduct.name = "NA";
  //               //     selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
  //               //     selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



  //               //   }

  //               // }
  //               // //this.consoleMessage(selectedBaseplanProductsArray)
  //               // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
  //               //this.consoleMessage(selectedBaseplanProductsArray)
  //             }
  //           }
  //           else {
  //             //console.log("elseStatement")
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";

  //             for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //               selectedBaseplanProductsArray.push(selectedBaseplanProduct);
  //             }
  //           }


  //           //console.log(selectedBaseplanProductsArray)
  //           if (selectedCompnayPlan) {
  //             // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
  //             selectedCompanyplanProductsArray =
  //               selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
  //             // //this.consoleMessage(selectedCompanyplanProductsArray)
  //             // //this.consoleMessage(selectedCompnayPlan.name)

  //             let selectedCompanyplanProductsArray2 = [];

  //             if (CCplan.packageId == 5 || CCplan.packageId == 10) {
  //               selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
  //               for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
  //                 selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
  //               }
  //               //this.consoleMessage(selectedCompanyplanProductsArray)

  //               let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
  //               // //this.consoleMessage(selectedBaseplanProductsArray)

  //               if (remainigProdcuts > 0) {
  //                 for (let i = 0; i < remainigProdcuts; i++) {
  //                   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
  //                 }
  //               }
  //               selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
  //               //this.consoleMessage(selectedCompanyplanProductsArray)

  //             }
  //             else {

  //               //console.log(selectedCCplanProductarray)
  //               // let productCoverageFound = false;
  //               // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //               //   for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

  //               //     if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
  //               //       productCoverageFound = true
  //               //       selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
  //               //       break;
  //               //     }


  //               //   }
  //               //   if (!productCoverageFound) {


  //               //     selectedCompanyplanProduct = {};
  //               //     selectedCompanyplanProduct.calculatedTax = {};
  //               //     selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
  //               //     selectedCompanyplanProduct.name = "NA";
  //               //     selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
  //               //     selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



  //               //   }

  //               // }
  //               // selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

  //               // // setTimeout(() => {
  //               if (selectedCoverage == "DIRECT") {
  //                 selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
  //                 //console.log(selectedBaseplanProductsArray)
  //               }

  //               // Selective single Coverage Method
  //               if (selectedCoverage == "SINGLE") {
  //                 selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
  //               }
  //               // Selective Couple Coverage Method

  //               if (selectedCoverage == "COUPLE") {
  //                 selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
  //               }
  //               //  // Selective Family Coverage Method
  //               if (selectedCoverage == "FAMILY") {
  //                 selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
  //               }


  //               // // }, 1000)


  //               //console.log(selectedCompanyplanProductsArray)


  //             }


  //           } else {
  //             selectedCompanyplanProduct = {};
  //             selectedCompanyplanProduct.calculatedTax = {};
  //             selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
  //             for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //               selectedCompanyplanProductsArray.push(
  //                 selectedCompanyplanProduct
  //               );
  //             }
  //             //console.log(selectedCompanyplanProductsArray)
  //             //this.consoleMessage(selectedCompanyplanProductsArray)
  //           }


  //           let upgradeText;
  //           let upgradepaymentText;
  //           if (payroll) {
  //             upgradeText = "Employee upgraded using payroll deduction";
  //             upgradepaymentText = "using payroll deduction";
  //             //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //           } else {
  //             upgradeText = "Employee upgraded using Direct payment";
  //             upgradepaymentText = "using Direct payment";
  //           }

  //           modifiedCCplan.products = []



  //           for (let i = 0; i < selectedCCplanProductarray.length; i++) {
  //             let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
  //             //console.log(selectedBaseplanProduct)
  //             let selectedCompanyplanProduct =
  //               selectedCompanyplanProductsArray[i];
  //             let selectedCCplanProduct = selectedCCplanProductarray[i];
  //             //console.log(selectedCCplanProduct)
  //             //console.log(selectedCompanyplanProductsArray[i])
  //             let companyTax =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos
  //                 .length > 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos
  //                 .length > 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );


  //             let employeeTax =
  //               selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCCplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             //console.log(deltaplanPrice)


  //             //console.log(selectedBaseplanProduct.calculatedTax.price)

  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               // companyTax = employeeTax
  //               companyTax = 0  ////when there is no base planproduct
  //               // companyTaxPercentage = employeeTaxPercentage
  //               companyTaxPercentage = "0%" //when there is no base planproduct

  //             }
  //             //Delete plan Total Price and Total Combination
  //             if (deltaplanPrice < 0) {
  //               deltaplanPrice = 0
  //               baseplanPrice = adjustWith2DecimalsForUI(
  //                 selectedCCplanProduct.calculatedTax.price
  //               );
  //               baseplanTaxorg = adjustWith2DecimalsForUI(
  //                 selectedCCplanProduct.calculatedTax.tax
  //               );
  //               baseplanTax = adjustWith2DecimalsForUI(
  //                 baseplanPrice * companyTax
  //               );
  //               baseplanTotalorg = adjustWith2DecimalsForUI(
  //                 selectedCCplanProduct.calculatedTax.total
  //               );
  //               baseplanTotal = adjustWith2DecimalsForUI(
  //                 baseplanPrice + baseplanTax
  //               );
  //             }
  //             // let deltaplanTax = adjustWith2DecimalsForUI(
  //             //   deltaplanPrice *
  //             //   (this.deltaCompanyTax ? companyTax : employeeTax)
  //             // );
  //             let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );
  //             let combinedplanPrice = adjustWith2DecimalsForUI(
  //               baseplanPrice + deltaplanPrice
  //             );
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
  //             let planName = `${CCplan.name} (${upgradeText})`;
  //             let compnayShareStatement = `${CCplan.name} Contribution`;
  //             let employeeShareStatement = `${CCplan.name} upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id, //0
  //               planName: selectedBasePlan.name, //NA
  //               planLevelId: selectedBasePlan.planLevel, //0
  //               amount: baseplanPrice, //0
  //               amountUI: `$${baseplanPrice}`, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId,
  //               packageName: selectedBasePlan.packageName,
  //               packageId: selectedBasePlan.packageId,
  //             };





  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               selectedCoverage
  //             };

  //             //this.consoleMessage(obj)

  //             //console.log(obj)
  //             let ccProduct: any = {}
  //             ccProduct.upgradeCalculation = obj;
  //             modifiedCCplan.products.push(ccProduct)
  //             modifiedCCplan.upgradeCalculation = obj;

  //             //console.log(modifiedCCplan)
  //           }

  //         }
  //         else {

  //           var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


  //             return (
  //               CCplan.packageId == plan.packageId &&
  //               CCplan.planLevel_parentId == plan.planLevel_parentId &&
  //               CCplan.planLevel >= plan.planLevel &&
  //               plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
  //             );
  //           });

  //           var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


  //             return (
  //               CCplan.packageId == plan.packageId &&
  //               CCplan.planLevel_parentId == plan.planLevel_parentId &&
  //               CCplan.planLevel >= plan.planLevel &&
  //               plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
  //             );
  //           });

  //           //this.consoleMessage(filtered_base_plans)

  //           //this.consoleMessage(filtered_compnay_plans)
  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           //console.log("length" + filtered_base_plans.length)
  //           //console.log(filtered_base_plans)
  //           //console.log(filtered_compnay_plans)
  //           if (filtered_base_plans.length == 0) {
  //           } else if (filtered_base_plans.length == 1) {
  //             selectedBasePlan = filtered_base_plans[0];
  //             selectedCompnayPlan = filtered_compnay_plans[0];
  //           } else {
  //             //this.consoleMessage(filtered_base_plans.length)
  //           }

  //           let selectedbaseplanproduct: any;
  //           let selectedBaseplanProduct: any;

  //           if (selectedBasePlan) {
  //             for (let planname in selectedBasePlan.productAddonss) {
  //               //this.consoleMessage(planname)
  //               //this.consoleMessage(selectedBasePlan.productAddonss[planname])
  //               let products = selectedBasePlan.productAddonss[planname];
  //               //console.log("length" + products.length)
  //               if (products.length == 0) {
  //               } else if (products.length == 1) {
  //                 selectedbaseplanproduct = products[0];
  //                 // selectedCompnayPlan= filtered_compnay_plans[0]
  //               } else {
  //                 selectedbaseplanproduct = products[products.length - 1]; //
  //                 /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
  //                 Selecting last product(highest) in this case */
  //                 //this.consoleMessage(products.length)
  //               }
  //             }
  //             //this.consoleMessage(selectedbaseplanproduct)
  //             selectedBaseplanProduct = selectedbaseplanproduct;

  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.tax)
  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.total)
  //           } else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";
  //           }

  //           let CCplanProduct;

  //           for (let planname in CCplan.productAddonss) {
  //             let products = CCplan.productAddonss[planname];
  //             //console.log("length" + products.length)

  //             if (products.length == 0) {
  //             } else if (products.length == 1) {
  //               CCplanProduct = products[0];
  //               // selectedCompnayPlan= filtered_compnay_plans[0]
  //             } else {
  //               CCplanProduct = products[products.length - 1]; //
  //               /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
  //               Selecting last product(highest) in this case */
  //               //this.consoleMessage(products.length)
  //             }
  //           }
  //           let selectedCCplanProduct = CCplanProduct;


  //           let selectedcompanyplanproduct: any;
  //           let selectedCompanyplanProduct: any;

  //           if (selectedCompnayPlan) {
  //             for (let planname in selectedCompnayPlan.productAddonss) {
  //               //this.consoleMessage(planname)
  //               //this.consoleMessage(selectedCompnayPlan.productAddonss[planname])
  //               let products = selectedCompnayPlan.productAddonss[planname];

  //               if (products.length == 0) {
  //               } else if (products.length == 1) {
  //                 selectedcompanyplanproduct = products[0];
  //                 // selectedCompnayPlan= filtered_compnay_plans[0]
  //               } else {
  //                 selectedcompanyplanproduct = products[products.length - 1]; //
  //                 /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
  //                 Selecting last product(highest) in this case */
  //               }
  //             }
  //             selectedCompanyplanProduct = selectedcompanyplanproduct;

  //             //this.consoleMessage("CompanyTax")
  //             //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
  //             //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)
  //           } else {
  //             selectedCompanyplanProduct = {};
  //             selectedCompanyplanProduct.calculatedTax = {};
  //             selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
  //           }

  //           let upgradeText;
  //           let upgradepaymentText;
  //           if (payroll) {
  //             upgradeText = "Employee upgraded using payroll deduction";
  //             upgradepaymentText = "using payroll deduction";
  //             //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //           } else {
  //             upgradeText = "Employee upgraded using Direct payment";
  //             upgradepaymentText = "using Direct payment";
  //           }
  //           let companyTax =
  //             selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //               0
  //               ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                 .taxRate
  //               : 0;
  //           let companyTaxPercentage =
  //             selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //               0
  //               ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                 .taxRatePercentage
  //               : 0;
  //           let baseplanPrice = adjustWith2DecimalsForUI(
  //             selectedBaseplanProduct.calculatedTax.price
  //           );
  //           let baseplanTaxorg = adjustWith2DecimalsForUI(
  //             selectedBaseplanProduct.calculatedTax.tax
  //           );
  //           let baseplanTax = adjustWith2DecimalsForUI(
  //             baseplanPrice * companyTax
  //           );
  //           let baseplanTotalorg = adjustWith2DecimalsForUI(
  //             selectedBaseplanProduct.calculatedTax.total
  //           );
  //           let baseplanTotal = adjustWith2DecimalsForUI(
  //             baseplanPrice + baseplanTax
  //           );
  //           let employeeTax =
  //             selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //               ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                 .taxRate
  //               : 0;
  //           let employeeTaxPercentage =
  //             selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //               ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                 .taxRatePercentage
  //               : 0;

  //           let deltaplanPrice = adjustWith2DecimalsForUI(
  //             selectedCCplanProduct.calculatedTax.price -
  //             selectedBaseplanProduct.calculatedTax.price
  //           );

  //           //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
  //           //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
  //           //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
  //           if (selectedBaseplanProduct.name == 'NA') {
  //             //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //             companyTax = employeeTax
  //             companyTaxPercentage = employeeTaxPercentage
  //           }
  //           let deltaplanTax = adjustWith2DecimalsForUI(
  //             deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
  //           );
  //           // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

  //           let deltaplanTotal = adjustWith2DecimalsForUI(
  //             deltaplanPrice + deltaplanTax
  //           );

  //           let combinedplanPrice = baseplanPrice + deltaplanPrice;
  //           let combinedplanbasePrice = baseplanPrice;
  //           let combinedplanDeltaprice = deltaplanPrice;
  //           let combinedplanTax = adjustWith2DecimalsForUI(
  //             baseplanTax + deltaplanTax
  //           );
  //           let combinedplanCompanyTax = baseplanTax;
  //           let combinedplanEmployeeTax =
  //             adjustWith2DecimalsForUI(deltaplanTax);
  //           let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //           let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //             ? companyTaxPercentage
  //             : employeeTaxPercentage;
  //           let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
  //           let combinedplanTotal = adjustWith2DecimalsForUI(
  //             baseplanTotal + deltaplanTotal
  //           );

  //           let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
  //           let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
  //           let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
  //           let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
  //           let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //           let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //           let type;

  //           if (payroll) {
  //             type = "Split with payroll deduction";
  //           } else {
  //             type = "Split with direct pay";
  //           }
  //           let basePlanDetails = {
  //             planId: selectedBasePlan.id || 0, //0
  //             planName: selectedBasePlan.name || "NA", //NA
  //             planLevelId: selectedBasePlan.planLevel || 0, //0
  //             amount: baseplanPrice || 0, //0
  //             amountUI: `$${baseplanPrice}` || 0, //0
  //             tax: baseplanTax,
  //             total: baseplanTotal,
  //             taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //             totalUI: `$${baseplanTotal}`,
  //             planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //             planFrequencyID: selectedBasePlan.frqMonthly || "",
  //             planFusebillID: selectedBasePlan.fusebillId || "",
  //             products: [selectedBaseplanProduct],
  //             planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
  //             packageName: selectedBasePlan.packageName || "",
  //             packageId: selectedBasePlan.packageId || 0,
  //           };
  //           let obj = {
  //             companyTax,
  //             companyTaxPercentage,
  //             baseplanPrice,
  //             baseplanTaxorg,
  //             baseplanTax,
  //             baseplanTotalorg,
  //             baseplanTotal,
  //             employeeTax,
  //             employeeTaxPercentage,
  //             deltaplanPrice,
  //             deltaplanTax,
  //             deltaplanTotal,
  //             combinedplanPrice,
  //             combinedplanbasePrice,
  //             combinedplanDeltaprice,
  //             combinedplanTax,
  //             combinedplanCompanyTax,
  //             combinedplanEmployeeTax,
  //             combinedplanCompanyTaxPercentage,
  //             combinedplanemployeeTaxPercentage,
  //             combinedplanTotal,
  //             payroll,
  //             scenario,
  //             planName,
  //             compnayShareStatement,
  //             employeeShareStatement,
  //             planDescription,
  //             planDescription2,
  //             type,
  //             basePlanDetails,
  //             combinedplanemployeeTaxPercentageorg,
  //           };

  //           //this.consoleMessage(obj)
  //           modifiedCCplan.upgradeCalculation = obj;
  //         }
  //         modifiedCCgroup.plans.push(modifiedCCplan);
  //       }
  //       modifiedCCPackage.groupsCC.push(modifiedCCgroup);
  //     }

  //     modifiedCCplanPackages.push(modifiedCCPackage);
  //   }

  //   this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

  //   //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
  // }
  calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

    //console.log(ccplanspackages)
    let modifiedCCplanPackages = [];
    //console.log(baseplans)
    for (let i = 0; i < ccplanspackages?.length; i++) {
      let modifiedCCPackage = ccplanspackages[i];
      //this.consoleMessage(ccplanspackages[i].name)
      //this.consoleMessage(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC;

      modifiedCCPackage.groupsCC = [];
      for (let CCplangroup of CCplansgroups) {
        let modifiedCCgroup = CCplangroup;

        let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

        let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"

        // let selectedCoverage = CCplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"

        if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        //console.log(selectedCoverage)
        let CCplans = CCplangroup.plans;
        //console.log(CCplangroup)

        modifiedCCgroup.plans = [];
        for (let CCplan of CCplans) {
          let modifiedCCplan = CCplan;
          //this.consoleMessage(CCplan.id);
          //this.consoleMessage(CCplan.isBundle);
          //this.consoleMessage(CCplan.name);

          CCplan.planLevel_parentId = CCplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CCplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
          console.log(CCplan)
          console.log(CCplan.productAddonss[CCplan.name])

          if (CCplan.isBundle) {
            //this.consoleMessage("BundlePlan")

            //this.consoleMessage(baseplans)
            //console.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {
              //this.consoleMessage(plan)
              //cp_plans

              //this.consoleMessage(CCplan.packageId,plan.packageId)
              //this.consoleMessage(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.consoleMessage(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];


            //console.log("length" + filtered_base_plans.length)
            //console.log(filtered_base_plans)
            //console.log(filtered_compnay_plans)

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {


              var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
            }

            //console.log(selectedBasePlan)
            //console.log(selectedCompnayPlan)
            //console.log("name" + selectedBasePlan?.name)
            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
                  }
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method
                // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

                //console.log(selectedBaseplanProductsArray)
                // }, 1000)

                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {



                //     selectedBasePlan = {};
                //     selectedBaseplanProduct = {};
                //     selectedBaseplanProduct.calculatedTax = {};
                //     selectedBaseplanProduct.calculatedTax.price = 0;
                //     selectedBaseplanProduct.calculatedTax.tax = 0;
                //     selectedBaseplanProduct.calculatedTax.total = 0;
                //     selectedBaseplanProduct.name = "NA";
                //     selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                //   }

                // }
                // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                //this.consoleMessage(selectedBaseplanProductsArray)
              }
            }
            else {
              //console.log("elseStatement")
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }


            //console.log(selectedBaseplanProductsArray)
            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              // //this.consoleMessage(selectedCompanyplanProductsArray)
              // //this.consoleMessage(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                //this.consoleMessage(selectedCompanyplanProductsArray)

                let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
                  }
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
                //this.consoleMessage(selectedCompanyplanProductsArray)

              }
              else {

                //console.log(selectedCCplanProductarray)
                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {


                //     selectedCompanyplanProduct = {};
                //     selectedCompanyplanProduct.calculatedTax = {};
                //     selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                //     selectedCompanyplanProduct.name = "NA";
                //     selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                //   }

                // }
                // selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

                // // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }


                // // }, 1000)


                //console.log(selectedCompanyplanProductsArray)


              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
              //console.log(selectedCompanyplanProductsArray)
              //this.consoleMessage(selectedCompanyplanProductsArray)
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []



            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              //console.log(selectedBaseplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              //console.log(selectedCCplanProduct)
              //console.log(selectedCompanyplanProductsArray[i])
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );


              let employeeTax =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );
              //console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                // companyTax = employeeTax
                companyTax = 0  ////when there is no base planproduct
                // companyTaxPercentage = employeeTaxPercentage
                companyTaxPercentage = "0%" //when there is no base planproduct

              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice < 0) {
                deltaplanPrice = 0
                baseplanPrice = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.price
                );
                baseplanTaxorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.tax
                );
                baseplanTax = adjustWith2DecimalsForUI(
                  baseplanPrice * companyTax
                );
                baseplanTotalorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.total
                );
                baseplanTotal = adjustWith2DecimalsForUI(
                  baseplanPrice + baseplanTax
                );
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              console.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;


            }
            modifiedCCgroup.plans.push(modifiedCCplan);

          }
          else {
            let selectedCCplanNamearray = Object.keys(CCplan.productAddonss)

            let selectedCCplanProductarray: any = []
            for (let name of selectedCCplanNamearray) {
              selectedCCplanProductarray = selectedCCplanProductarray.concat(CCplan.productAddonss[name])
            }
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans)

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            console.log("length" + filtered_base_plans.length)
            console.log(filtered_base_plans)
            console.log(filtered_compnay_plans)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)

            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray = []
            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                console.log(planname)
                console.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  selectedBaseplanProductsArray.push(products[0]);

                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedbaseplanproduct = products[products.length - 1]; //

                  for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                    selectedBaseplanProductsArray.push(products[i]);
                  }
                  /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                  console.log(products.length)
                }
              }
              console.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.tax)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.total)
            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";


              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            let CCplanProduct;
            let CCproductslength

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname];
              CCproductslength = products.length
              console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                CCplanProduct = products[products.length - 1]; //
                /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                Selecting last product(highest) in this case */
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray = []

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname];

                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0];
                  selectedCompanyplanProductsArray.push(
                    products[0]
                  );
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedcompanyplanproduct = products[products.length - 1]; //
                  for (let i = 0; i < products.length; i++) {
                    selectedCompanyplanProductsArray.push(
                      products[i]
                    );
                  }

                  /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct;
              // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              //   selectedCompanyplanProductsArray.push(
              //     selectedCompanyplanProduct
              //   );
              // }
              //this.consoleMessage("CompanyTax")
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)
            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              console.log(selectedCCplanProductarray)
              console.log(selectedCompanyplanProduct)
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }


            }

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }



            if (CCproductslength == 1) {
              modifiedCCplan = this.singleCCCoverageProduct(selectedCompanyplanProduct, selectedBaseplanProduct, selectedCCplanProduct, CCplan, upgradeText, payroll, selectedBasePlan, upgradepaymentText, modifiedCCplan)

            }
            else {
              modifiedCCplan = this.multipleCCCoverageProduct(selectedCCplanProductarray, selectedBaseplanProductsArray, selectedCompanyplanProductsArray, selectedBasePlan, CCplan, upgradeText, payroll, upgradepaymentText, selectedCoverage, modifiedCCplan)

            }
            modifiedCCgroup.plans.push(modifiedCCplan);
          }
          //           modifiedCCgroup.plans = Array.from(new Set(modifiedCCgroup.plans.map((item:any) => JSON.stringify(item)))
          // ).map((str:any) => JSON.parse(str));
          modifiedCCPackage.groupsCC.push(modifiedCCgroup);
        }

        modifiedCCplanPackages.push(modifiedCCPackage);
      }
      modifiedCCplanPackages = Array.from(new Set(modifiedCCplanPackages.map((item: any) => JSON.stringify(item)))
      ).map((str: any) => JSON.parse(str));
      this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

      console.log(this.modifiedBlocksCoveredByCompany)
    }
  }
  public singleCCCoverageProduct(selectedCompanyplanProduct: any, selectedBaseplanProduct: any, selectedCCplanProduct: any, CCplan: any, upgradeText: any, payroll: any, selectedBasePlan: any, upgradepaymentText: any, modifiedCCplan: any) {
    let companyTax =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let companyTaxPercentage =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;
    let baseplanPrice = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.price
    );
    let baseplanTaxorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.tax
    );
    let baseplanTax = adjustWith2DecimalsForUI(
      baseplanPrice * companyTax
    );
    let baseplanTotalorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.total
    );
    let baseplanTotal = adjustWith2DecimalsForUI(
      baseplanPrice + baseplanTax
    );
    let employeeTax =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let employeeTaxPercentage =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;

    let deltaplanPrice = adjustWith2DecimalsForUI(
      selectedCCplanProduct.calculatedTax.price -
      selectedBaseplanProduct.calculatedTax.price
    );

    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
    if (selectedBaseplanProduct.name == 'NA') {
      //this.consoleMessage("No Base plan/product for this upgrade plans/product")
      companyTax = employeeTax
      companyTaxPercentage = employeeTaxPercentage
    }
    let deltaplanTax = adjustWith2DecimalsForUI(
      deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
    );
    // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

    let deltaplanTotal = adjustWith2DecimalsForUI(
      deltaplanPrice + deltaplanTax
    );

    let combinedplanPrice = baseplanPrice + deltaplanPrice;
    let combinedplanbasePrice = baseplanPrice;
    let combinedplanDeltaprice = deltaplanPrice;
    let combinedplanTax = adjustWith2DecimalsForUI(
      baseplanTax + deltaplanTax
    );
    let combinedplanCompanyTax = baseplanTax;
    let combinedplanEmployeeTax =
      adjustWith2DecimalsForUI(deltaplanTax);
    let combinedplanCompanyTaxPercentage = companyTaxPercentage;
    let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
      ? companyTaxPercentage
      : employeeTaxPercentage;
    let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
    let combinedplanTotal = adjustWith2DecimalsForUI(
      baseplanTotal + deltaplanTotal
    );

    let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
    let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
    let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
    let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
    let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
    let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
    let type;

    if (payroll) {
      type = "Split with payroll deduction";
    } else {
      type = "Split with direct pay";
    }
    let basePlanDetails = {
      planId: selectedBasePlan.id || 0, //0
      planName: selectedBasePlan.name || "NA", //NA
      planLevelId: selectedBasePlan.planLevel || 0, //0
      amount: baseplanPrice || 0, //0
      amountUI: `$${baseplanPrice}` || 0, //0
      tax: baseplanTax,
      total: baseplanTotal,
      taxUI: `$${baseplanTax}`, //companyTaxpercentage
      totalUI: `$${baseplanTotal}`,
      planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
      planFrequencyID: selectedBasePlan.frqMonthly || "",
      planFusebillID: selectedBasePlan.fusebillId || "",
      products: [selectedBaseplanProduct],
      planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
      packageName: selectedBasePlan.packageName || "",
      packageId: selectedBasePlan.packageId || 0,
    };
    let obj = {
      companyTax,
      companyTaxPercentage,
      baseplanPrice,
      baseplanTaxorg,
      baseplanTax,
      baseplanTotalorg,
      baseplanTotal,
      employeeTax,
      employeeTaxPercentage,
      deltaplanPrice,
      deltaplanTax,
      deltaplanTotal,
      combinedplanPrice,
      combinedplanbasePrice,
      combinedplanDeltaprice,
      combinedplanTax,
      combinedplanCompanyTax,
      combinedplanEmployeeTax,
      combinedplanCompanyTaxPercentage,
      combinedplanemployeeTaxPercentage,
      combinedplanTotal,
      payroll,
      scenario,
      planName,
      compnayShareStatement,
      employeeShareStatement,
      planDescription,
      planDescription2,
      type,
      basePlanDetails,
      combinedplanemployeeTaxPercentageorg,
    };

    console.log(obj)
    modifiedCCplan.upgradeCalculation = obj;
    return modifiedCCplan
  }

  public multipleCCCoverageProduct(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCompanyplanProductsArray: any, selectedBasePlan: any, CCplan: any, upgradeText: any, payroll: any, upgradepaymentText: any, selectedCoverage: any, modifiedCCplan: any) {

    console.log(selectedCCplanProductarray)
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
      console.log(selectedBaseplanProduct)
      let selectedCompanyplanProduct =
        selectedCompanyplanProductsArray[i];
      let selectedCCplanProduct = selectedCCplanProductarray[i];
      console.log(selectedCCplanProduct)
      console.log(selectedCompanyplanProductsArray[i])
      let companyTax =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let companyTaxPercentage =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;

      let baseplanPrice = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.price
      );
      let baseplanTaxorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.tax
      );
      let baseplanTax = adjustWith2DecimalsForUI(
        baseplanPrice * companyTax
      );
      let baseplanTotalorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.total
      );
      let baseplanTotal = adjustWith2DecimalsForUI(
        baseplanPrice + baseplanTax
      );


      let employeeTax =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let employeeTaxPercentage =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;
      let deltaplanPrice = adjustWith2DecimalsForUI(
        selectedCCplanProduct.calculatedTax.price -
        selectedBaseplanProduct.calculatedTax.price
      );
      //console.log(deltaplanPrice)


      //console.log(selectedBaseplanProduct.calculatedTax.price)

      if (selectedBaseplanProduct.name == 'NA') {
        //this.consoleMessage("No Base plan/product for this upgrade plans/product")
        // companyTax = employeeTax
        companyTax = 0  ////when there is no base planproduct
        // companyTaxPercentage = employeeTaxPercentage
        companyTaxPercentage = "0%" //when there is no base planproduct

      }
      //Delete plan Total Price and Total Combination
      if (deltaplanPrice < 0) {
        deltaplanPrice = 0
        baseplanPrice = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.price
        );
        baseplanTaxorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.tax
        );
        baseplanTax = adjustWith2DecimalsForUI(
          baseplanPrice * companyTax
        );
        baseplanTotalorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.total
        );
        baseplanTotal = adjustWith2DecimalsForUI(
          baseplanPrice + baseplanTax
        );
      }
      // let deltaplanTax = adjustWith2DecimalsForUI(
      //   deltaplanPrice *
      //   (this.deltaCompanyTax ? companyTax : employeeTax)
      // );
      let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

      let deltaplanTotal = adjustWith2DecimalsForUI(
        deltaplanPrice + deltaplanTax
      );
      let combinedplanPrice = adjustWith2DecimalsForUI(
        baseplanPrice + deltaplanPrice
      );
      let combinedplanbasePrice = baseplanPrice;
      let combinedplanDeltaprice = deltaplanPrice;
      let combinedplanTax = adjustWith2DecimalsForUI(
        baseplanTax + deltaplanTax
      );
      let combinedplanCompanyTax = baseplanTax;
      let combinedplanEmployeeTax =
        adjustWith2DecimalsForUI(deltaplanTax);
      let combinedplanCompanyTaxPercentage = companyTaxPercentage;
      let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
        ? companyTaxPercentage
        : employeeTaxPercentage;
      let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

      let combinedplanTotal = adjustWith2DecimalsForUI(
        baseplanTotal + deltaplanTotal
      );

      let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
      let planName = `${CCplan.name} (${upgradeText})`;
      let compnayShareStatement = `${CCplan.name} Contribution`;
      let employeeShareStatement = `${CCplan.name} upgrade cost`;
      let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
      let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
      let type;

      if (payroll) {
        type = "Split with payroll deduction";
      } else {
        type = "Split with direct pay";
      }
      let basePlanDetails = {
        planId: selectedBasePlan.id, //0
        planName: selectedBasePlan.name, //NA
        planLevelId: selectedBasePlan.planLevel, //0
        amount: baseplanPrice, //0
        amountUI: `$${baseplanPrice}`, //0
        tax: baseplanTax,
        total: baseplanTotal,
        taxUI: `$${baseplanTax}`, //companyTaxpercentage
        totalUI: `$${baseplanTotal}`,
        planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
        planFrequencyID: selectedBasePlan.frqMonthly || "",
        planFusebillID: selectedBasePlan.fusebillId || "",
        products: [selectedBaseplanProduct],
        planLevel_parentId: selectedBasePlan.planLevel_parentId,
        packageName: selectedBasePlan.packageName,
        packageId: selectedBasePlan.packageId,
      };





      let obj = {
        companyTax,
        companyTaxPercentage,
        baseplanPrice,
        baseplanTaxorg,
        baseplanTax,
        baseplanTotalorg,
        baseplanTotal,
        employeeTax,
        employeeTaxPercentage,
        deltaplanPrice,
        deltaplanTax,
        deltaplanTotal,
        combinedplanPrice,
        combinedplanbasePrice,
        combinedplanDeltaprice,
        combinedplanTax,
        combinedplanCompanyTax,
        combinedplanEmployeeTax,
        combinedplanCompanyTaxPercentage,
        combinedplanemployeeTaxPercentage,
        combinedplanTotal,
        payroll,
        scenario,
        planName,
        compnayShareStatement,
        employeeShareStatement,
        planDescription,
        planDescription2,
        type,
        basePlanDetails,
        combinedplanemployeeTaxPercentageorg,
        selectedCoverage
      };

      //this.consoleMessage(obj)

      console.log(obj)

      if (modifiedCCplan.products) {

      } else {
        modifiedCCplan.products = []
      }
      let ccProduct: any = {}
      ccProduct.upgradeCalculation = obj;
      modifiedCCplan.products.push(ccProduct)
      modifiedCCplan.upgradeCalculation = obj;

      //console.log(modifiedCCplan)
    }

    return modifiedCCplan
  }
  // calculateBasePlanCPplans(cpplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

  //   //console.log(cpplanspackages)


  //   let modifiedCPplanPackages: any = [];
  //   for (let i = 0; i < cpplanspackages?.length; i++) {
  //     let modifiedCPPackage = cpplanspackages[i];

  //     let CPplansgroups = cpplanspackages[i].groupsCP;

  //     modifiedCPPackage.groupsCP = [];
  //     for (let CPplangroup of CPplansgroups) {
  //       let modifiedCPgroup = CPplangroup;
  //       let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
  //       if (selectedCoverage == "null") {
  //         selectedCoverage = "DIRECT"
  //       }
  //       if (selectedCoverage != "DIRECT") {
  //         selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
  //       }

  //       //console.log(selectedCoverage)


  //       if (selectedCoverage == "DIRECT") {
  //         modifiedCPPackage.groupsCP.push(modifiedCPgroup)
  //         if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
  //           modifiedCPplanPackages.push(modifiedCPPackage)
  //         }
  //         continue;
  //       }
  //       let CPplans = CPplangroup.plans;

  //       //console.log(CPplangroup)

  //       modifiedCPgroup.plans = [];
  //       baseplans = []
  //       for (let CPplan of CPplans) {
  //         let modifiedCPplan = CPplan;


  //         CPplan.planLevel_parentId = CPplangroup.parentId;

  //         let payroll = true;
  //         let EmployeeChoice = 0;

  //         if (
  //           this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
  //         ) {
  //           if (EmployeeChoice == 2) {
  //             payroll = false;
  //           }
  //         } else {
  //           if (
  //             this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
  //               CPplan.planLevel
  //             )
  //           ) {
  //             if (EmployeeChoice == 2) {
  //               payroll = false;
  //             }
  //           }
  //         }
  //         console.log(CPplan)
  //         let selectedCPplanProductarray = CPplan.productAddonss[CPplan.name];
  //         //console.log(CPplan)
  //         //console.log(CPplan.productAddonss[CPplan.name])


  //         for (let i = 0; i < selectedCPplanProductarray.length; i++) {

  //           for (let j = 0; j < selectedCPplanProductarray.length; j++) {
  //             if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

  //               baseplans.push(selectedCPplanProductarray[i])
  //             }

  //           }

  //         }

  //         if (CPplan.isBundle) {

  //           //console.log(baseplans)
  //           var filtered_base_plans = baseplans



  //           //this.consoleMessage(filtered_base_plans);

  //           //this.consoleMessage(filtered_compnay_plans)
  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           let selectedBaseplanProduct: any;
  //           let selectedBaseplanProductsArray = [];
  //           let selectedCompanyplanProduct: any;
  //           let selectedCompanyplanProductsArray: any = [];

  //           //console.log("length" + filtered_base_plans.length)

  //           selectedBasePlan = filtered_base_plans[0];

  //           //console.log(selectedBasePlan)

  //           if (selectedBasePlan) {
  //             // //this.consoleMessage(selectedBasePlan)
  //             // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
  //             selectedBaseplanProductsArray = [selectedBasePlan];
  //             let selectedBaseplanProductsArray2 = [];
  //             //  //this.consoleMessage(CCplan.packageId)
  //             if (CPplan.packageId == 5 || CPplan.packageId == 10) {

  //               // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
  //               // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
  //               //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
  //               // }
  //               // // //this.consoleMessage(selectedBaseplanProductsArray)
  //               // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
  //               // //this.consoleMessage(selectedBaseplanProductsArray)
  //             }
  //             else {

  //               // Direct Coverage Method

  //               // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


  //               // Selective single Coverage Method

  //               //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

  //               // Selective Couple Coverage Method
  //               if (selectedCoverage != "DIRECT") {
  //                 selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
  //               }
  //               //  // Selective Family Coverage Method


  //             }
  //           }
  //           else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";

  //             for (let i = 0; i < selectedCPplanProductarray.length; i++) {
  //               selectedBaseplanProductsArray.push(selectedBaseplanProduct);
  //             }
  //           }



  //           let upgradeText;
  //           let upgradepaymentText;
  //           if (payroll) {
  //             upgradeText = "Employee upgraded using payroll deduction";
  //             upgradepaymentText = "using payroll deduction";
  //             //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //           } else {
  //             upgradeText = "Employee upgraded using Direct payment";
  //             upgradepaymentText = "using Direct payment";
  //           }

  //           modifiedCPplan.products = []

  //           for (let i = 0; i < selectedCPplanProductarray.length; i++) {
  //             let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
  //             //console.log(selectedBaseplanProduct)
  //             let selectedCPplanProduct = selectedCPplanProductarray[i];
  //             //console.log(selectedCPplanProduct)
  //             let coverage = selectedCPplanProduct.planCoverage


  //             if (selectedCoverage == coverage) {

  //               modifiedCPplan.products.push(selectedCPplanProduct)
  //               continue;
  //             }

  //             //console.log(selectedCPplanProduct)
  //             let selectedCompanyplanProduct =
  //               selectedCompanyplanProductsArray[i];


  //             let companyTax =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );



  //             let employeeTax =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCPplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             //console.log(deltaplanPrice)


  //             //console.log(selectedBaseplanProduct.calculatedTax.price)

  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               companyTax = employeeTax
  //               companyTaxPercentage = employeeTaxPercentage
  //             }
  //             //Delete plan Total Price and Total Combination
  //             if (deltaplanPrice <= 0) {
  //               deltaplanPrice = 0
  //               /*      baseplanPrice = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.price
  //                   );
  //                    baseplanTaxorg = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.tax
  //                   );
  //                    baseplanTax = adjustWith2DecimalsForUI(
  //                     baseplanPrice * companyTax
  //                   );
  //                    baseplanTotalorg = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.total
  //                   );
  //                    baseplanTotal = adjustWith2DecimalsForUI(
  //                     baseplanPrice + baseplanTax
  //                   ); */

  //               modifiedCPplan.products.push(selectedCPplanProduct)
  //               continue;

  //             }


  //             let deltaplanTax = adjustWith2DecimalsForUI(
  //               deltaplanPrice *
  //               (this.deltaCompanyTax ? companyTax : employeeTax)
  //             );
  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );
  //             let combinedplanPrice = adjustWith2DecimalsForUI(
  //               baseplanPrice + deltaplanPrice
  //             );
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
  //             let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
  //             let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
  //             let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id, //0
  //               planName: selectedBasePlan.name, //NA
  //               planLevelId: selectedBasePlan.planLevel, //0
  //               amount: baseplanPrice, //0
  //               amountUI: `$${baseplanPrice}`, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId,
  //               packageName: selectedBasePlan.packageName,
  //               packageId: selectedBasePlan.packageId,
  //             };





  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               coverage,
  //               selectedCoverage
  //             };

  //             //this.consoleMessage(obj)

  //             //console.log(selectedCoverage)
  //             //console.log(coverage)

  //             //console.log(obj)
  //             let cpProduct: any = {}
  //             cpProduct.upgradeCalculation = obj;
  //             modifiedCPplan.products.push(cpProduct)
  //             // modifiedCPplan.upgradeCalculation = obj;

  //             // if(selectedCoverage == coverage){

  //             // }else{
  //             //   cpProduct.upgradeCalculation = obj;
  //             //   modifiedCPplan.products.push(cpProduct)
  //             // }

  //             //console.log(modifiedCPplan)
  //           }

  //         }
  //         else {
  //           //this.consoleMessage("Not a BundlePlan")

  //           //this.consoleMessage(baseplans)



  //           filtered_base_plans = baseplans

  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           //console.log("length" + filtered_base_plans.length)
  //           if (filtered_base_plans.length == 0) {
  //           } else if (filtered_base_plans.length == 0) {
  //             selectedBasePlan = filtered_base_plans[0];
  //           } else {
  //             //this.consoleMessage(filtered_base_plans.length)
  //           }

  //           let selectedbaseplanproduct: any;
  //           let selectedBaseplanProduct: any;

  //           if (selectedBasePlan) {
  //             for (let planname in selectedBasePlan.productAddonss) {
  //               //this.consoleMessage(planname)
  //               //this.consoleMessage(selectedBasePlan.productAddonss[planname])
  //               let products = selectedBasePlan.productAddonss[planname];
  //               //console.log("length" + products.length)
  //               if (products.length == 0) {
  //               } else if (products.length == 1) {
  //                 selectedbaseplanproduct = products[0];
  //                 // selectedCompnayPlan= filtered_compnay_plans[0]
  //               } else {
  //                 //this.consoleMessage(products.length)
  //               }
  //             }
  //             //this.consoleMessage(selectedbaseplanproduct)
  //             selectedBaseplanProduct = selectedbaseplanproduct;

  //           } else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";
  //           }

  //           let CCplanProduct;

  //           for (let planname in CPplan.productAddonss) {
  //             let products = CPplan.productAddonss[planname];
  //             //console.log("length" + products.length)

  //             if (products.length == 0) {
  //             } else if (products.length == 1) {
  //               CCplanProduct = products[0];
  //               // selectedCompnayPlan= filtered_compnay_plans[0]
  //             } else {
  //               //this.consoleMessage(products.length)
  //             }
  //           }
  //           let selectedCCplanProduct = CCplanProduct;


  //           let selectedcompanyplanproduct: any;
  //           let selectedCompanyplanProduct: any;

  //           if (selectedCompnayPlan) {

  //             let upgradeText;
  //             let upgradepaymentText;
  //             if (payroll) {
  //               upgradeText = "Employee upgraded using payroll deduction";
  //               upgradepaymentText = "using payroll deduction";
  //               //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //             } else {
  //               upgradeText = "Employee upgraded using Direct payment";
  //               upgradepaymentText = "using Direct payment";
  //             }
  //             let companyTax =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //                 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //                 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );
  //             let coverage = selectedCCplanProduct.planCoverage
  //             let employeeTax =
  //               selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCCplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );

  //             //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               companyTax = employeeTax
  //               companyTaxPercentage = employeeTaxPercentage
  //             }
  //             let deltaplanTax = adjustWith2DecimalsForUI(
  //               deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
  //             );
  //             // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );

  //             let combinedplanPrice = baseplanPrice + deltaplanPrice;
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
  //             let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
  //             let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
  //             let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id || 0, //0
  //               planName: selectedBasePlan.name || "NA", //NA
  //               planLevelId: selectedBasePlan.planLevel || 0, //0
  //               amount: baseplanPrice || 0, //0
  //               amountUI: `$${baseplanPrice}` || 0, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
  //               packageName: selectedBasePlan.packageName || "",
  //               packageId: selectedBasePlan.packageId || 0,
  //             };
  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               coverage
  //             };

  //             //this.consoleMessage(obj)
  //             // modifiedCPplan.upgradeCalculation = obj;
  //           }
  //         }
  //         modifiedCPgroup.plans.push(modifiedCPplan);

  //         modifiedCPPackage.groupsCP.push(modifiedCPgroup);
  //       }
  //       //console.log(modifiedCPPackage)
  //       modifiedCPplanPackages.push(modifiedCPPackage);
  //     }

  //     this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

  //     console.log(this.modifiedBlocksPaidByCompany)

  //     //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
  //   }
  // }
  calculateBasePlanCPplans(cpplanspackages: string | any[], baseplansMain: any[], compnayplans: any[]) {

    console.log(cpplanspackages)
    console.log(baseplansMain)

    if (baseplansMain) {
      baseplansMain = baseplansMain.filter(name => name.productAddonssNames.length > 0)
    }



    let selectedbasePlanMain;
    console.log(baseplansMain)
    let modifiedCPplanPackages: any = [];
    for (let i = 0; i < cpplanspackages?.length; i++) {
      if (baseplansMain) {
        selectedbasePlanMain = baseplansMain.filter(name => name.packageId == cpplanspackages[i].id)
        if (selectedbasePlanMain.length > 0) {
          selectedbasePlanMain = selectedbasePlanMain[selectedbasePlanMain.length - 1]
        }

      }
      let modifiedCPPackage = cpplanspackages[i];

      let CPplansgroups = cpplanspackages[i].groupsCP;

      modifiedCPPackage.groupsCP = [];
      for (let CPplangroup of CPplansgroups) {
        let modifiedCPgroup = CPplangroup;
        let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
        if (selectedCoverage == "null") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        console.log(selectedCoverage)


        if (selectedCoverage == "DIRECT") {
          modifiedCPPackage.groupsCP.push(modifiedCPgroup)
          if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
            modifiedCPplanPackages.push(modifiedCPPackage)
          }
          continue;
        }
        let CPplans = CPplangroup.plans;

        //console.log(CPplangroup)

        modifiedCPgroup.plans = [];
        let baseplans = []
        for (let CPplan of CPplans) {
          let modifiedCPplan = CPplan;


          CPplan.planLevel_parentId = CPplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CPplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          console.log(CPplan)
          let selectedCPplanProductarray: any = CPplan.productAddonss[CPplan.name];


          // let selectedCPplanProductarray: any = Object.keys(CPplan.productAddonss)

          console.log(selectedCPplanProductarray)
          if (selectedbasePlanMain) {
            let selectedMainProductarray: any = selectedbasePlanMain.productAddonss[selectedbasePlanMain.name];

            console.log(selectedMainProductarray)
            //console.log(CPplan.productAddonss[CPplan.name])

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedMainProductarray.length; j++) {
                if (selectedMainProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedMainProductarray[i])
                }

              }
            }
          }
          else {
            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedCPplanProductarray.length; j++) {
                if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedCPplanProductarray[i])
                }

              }

            }

          }






          if (CPplan.isBundle) {

            console.log(baseplans)
            var filtered_base_plans = baseplans



            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];

            //console.log("length" + filtered_base_plans.length)

            selectedBasePlan = filtered_base_plans[0];

            console.log(selectedBasePlan)

            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = [selectedBasePlan];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CPplan.packageId == 5 || CPplan.packageId == 10) {

                // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                // }
                // // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method

                // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


                // Selective single Coverage Method

                //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

                // Selective Couple Coverage Method
                if (selectedCoverage != "DIRECT") {
                  selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
                }
                //  // Selective Family Coverage Method


              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCPplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }



            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCPplan.products = []

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              console.log(selectedBaseplanProduct)
              let selectedCPplanProduct = selectedCPplanProductarray[i];
              console.log(selectedCPplanProduct)
              let coverage = selectedCPplanProduct.planCoverage

              console.log(coverage)
              if (selectedCoverage == coverage) {

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;
              }

              console.log(selectedCPplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];

              let companyTax;
              let companyTaxPercentage;
              let employeeTax;
              let employeeTaxPercentage;

              if (selectedBaseplanProduct) {
                companyTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              } else {
                companyTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }




              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );



              console.log(selectedCPplanProduct)

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCPplanProduct?.calculatedTax?.price -
                selectedBaseplanProduct?.calculatedTax?.price
              );
              console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice <= 0) {
                deltaplanPrice = 0
                /*      baseplanPrice = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.price
                    );
                     baseplanTaxorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.tax
                    );
                     baseplanTax = adjustWith2DecimalsForUI(
                      baseplanPrice * companyTax
                    );
                     baseplanTotalorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.total
                    );
                     baseplanTotal = adjustWith2DecimalsForUI(
                      baseplanPrice + baseplanTax
                    ); */

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;

              }


              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
              let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
              let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              //console.log(selectedCoverage)
              //console.log(coverage)

              //console.log(obj)
              let cpProduct: any = {}
              cpProduct.upgradeCalculation = obj;
              modifiedCPplan.products.push(cpProduct)
              // modifiedCPplan.upgradeCalculation = obj;

              // if(selectedCoverage == coverage){

              // }else{
              //   cpProduct.upgradeCalculation = obj;
              //   modifiedCPplan.products.push(cpProduct)
              // }

              //console.log(modifiedCPplan)
            }

          }
          else {
            //this.consoleMessage("Not a BundlePlan")

            //this.consoleMessage(baseplans)



            filtered_base_plans = baseplans

            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            //console.log("length" + filtered_base_plans.length)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 0) {
              selectedBasePlan = filtered_base_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)
            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                //console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  //this.consoleMessage(products.length)
                }
              }
              //this.consoleMessage(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";
            }

            let CCplanProduct;

            for (let planname in CPplan.productAddonss) {
              let products = CPplan.productAddonss[planname];
              //console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;

            if (selectedCompnayPlan) {

              let upgradeText;
              let upgradepaymentText;
              if (payroll) {
                upgradeText = "Employee upgraded using payroll deduction";
                upgradepaymentText = "using payroll deduction";
                //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
              } else {
                upgradeText = "Employee upgraded using Direct payment";
                upgradepaymentText = "using Direct payment";
              }
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let coverage = selectedCCplanProduct.planCoverage
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );

              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );

              let combinedplanPrice = baseplanPrice + deltaplanPrice;
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
              let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
              let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id || 0, //0
                planName: selectedBasePlan.name || "NA", //NA
                planLevelId: selectedBasePlan.planLevel || 0, //0
                amount: baseplanPrice || 0, //0
                amountUI: `$${baseplanPrice}` || 0, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
                packageName: selectedBasePlan.packageName || "",
                packageId: selectedBasePlan.packageId || 0,
              };
              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage
              };

              //this.consoleMessage(obj)
              // modifiedCPplan.upgradeCalculation = obj;
            }
          }
          modifiedCPgroup.plans.push(modifiedCPplan);

          modifiedCPPackage.groupsCP.push(modifiedCPgroup);
        }
        //console.log(modifiedCPPackage)
        modifiedCPplanPackages.push(modifiedCPPackage);
      }

      this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

      console.log(this.modifiedBlocksPaidByCompany)

      //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
    }
  }
  public DirectCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

        //console.log(selectedCCplanProductarray[i])
        //console.log(selectedBaseplanProductsArray[j])

        if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        //console.log("ElseDirectCoveragemETHOD")
        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;

    //console.log(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        //console.log(selectedBaseplanProductsArray[j])
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public selectiveCPCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCoverage: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == selectedCoverage })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public CompanyDirectCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;



    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  public CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public capitalize(str: String) {
    if (str) {
      // return str.charAt(0).toUpperCase() + str.slice(1);
      const words = str.split(' ');

      let finalres: any = words.filter((v) => v != '');
      return finalres
        .map((word: any) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
    }
  }
  cobminedcommonfunction(cpPackages: any, ccPackages: any, epPackages: any) {

    // //console.log(cpPackages)
    let commonPackages: any = {};
    if (cpPackages) {
      for (let cpPackage of cpPackages) {
        let pckg = cpPackage;
        pckg.groups = pckg.groupsCP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups.push(pckg.groupsCP);
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    //this.consoleMessage(commonPackages)
    if (ccPackages) {
      for (let ccPackage of ccPackages) {
        let pckg = ccPackage;
        //this.consoleMessage(pckg)
        pckg.groups = pckg.groupsCC;

        //this.consoleMessage(pckg.groups)
        //this.consoleMessage(pckg.groupsCC)

        if (commonPackages && commonPackages[pckg.id]) {
          //this.consoleMessage(commonPackages[pckg.id])
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsCC
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (epPackages) {
      for (let epPackage of epPackages) {
        let pckg = epPackage;
        pckg.groups = pckg.groupsEP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsEP
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }

    return commonPackages;


  }


  public openplanoptions(elementcv: any) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");

    let modifiedOptions: any = [];
    let optionumber: any = [];
    // let optionumber = $("#optionumber").val();  //rakesh
    // jQuery("#showplanoptions-modal").modal("hide");

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
    let optionsValue = JSON.parse(sessionStorage.getItem('options') || '[]');

    for (let i = 0; i < planSummary.length; i++) {

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData


      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData

      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie") && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") || option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }
    }

    // this.plandetailsobjvalue = plandetailsobj;

    this.plandetailsobjvalue = plandetails;

    optionsValue.forEach((element: any) => {
      element.planOptionsValues.forEach((options: any) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    //this.consoleMessage("isexeccp:" + plandetailsobj[19]);
    this.isExecutiveCP = plandetailsobj[19]
      ? parseInt(plandetailsobj[19]) == 1
        ? true
        : false
      : false;
    this.planOptionsModel = true
    // alert("startrhetre")
    // jQuery("#showplanoptions-modal").modal("show");
  }
  // public planoptionselection(event, optionvalue, optionid, optionvalueid) {
  //   $(".optionselectionmethod-" + optionid)
  //     .not(this)
  //     .prop("checked", false);

  //   $("#planselectionvalue-" + optionvalueid + "-" + optionid).prop("checked", true);

  //   this.optionmessage = "";
  // }

  public closeplanoptions() { }

  public chooseplan() {
    this.isDisabledplan = true;
  }


  // public planCoverafeFunction() {
  //   this.paidEmployeeShare = 0;
  //   this.coveredEmployeeShare = 0;

  //   //this.logger.log("plancoverage");

  //   let planDetailsArray = JSON.parse(sessionStorage.getItem("planDetailsArray") || "[]");
  //   //this.logger.log(planDetailsArray);
  //   // var package_plans = this.convertpackagesToPlans(planDetailsArray);
  //   // var package_plans = this.convertpackagesToPlans2(this.packagesInBlocks);
  //   var package_plans = this.convertpackagesToPlans2(this.basepackages);


  //   //this.logger.log(package_plans);
  //   let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || "[]");
  //   //this.logger.log(planSummary);
  //   var all_selected_plans = [];
  //   var payrollCCplans = [];
  //   var directpayCCplans = [];
  //   var employeeDealingPlans = [];
  //   var companyDealingPlans = [];
  //   var alloptinplans = []
  //   var company_selected_plans = [];
  //   var employee_selected_plans = [];
  //   var company_paid_selected_plans = [];
  //   var company_covered_selected_plans = [];

  //   var selected_cc_plans = planSummary.filter(function (plan) {
  //     return plan.coveredByCompany == 1;
  //   });

  //   var selected_cp_plans = planSummary.filter(function (plan) {
  //     return plan.paidByCompany == 1;
  //   });

  //   var selected_ep_plans = planSummary.filter(function (plan) {
  //     return plan.paidByEmployee == 1;
  //   });


  //   // var selected_cc_plans = planSummary.forEach(element => {

  //   //   element.groups.forEach(group => {
  //   //     return group.categorization.coveredByCompany == 1;

  //   //   });

  //   // });


  //   // var selected_cp_plans = planSummary.forEach(element => {

  //   //   element.groups.forEach(group => {
  //   //     return group.categorization.paidByCompany == 1;

  //   //   });

  //   // });
  //   // var selected_ep_plans = planSummary.forEach(element => {

  //   //   element.groups.forEach(group => {
  //   //     return group.categorization.paidByEmployee == 1;

  //   //   });

  //   // });

  //   //this.logger.log(selected_cc_plans);
  //   //this.logger.log(selected_cp_plans);
  //   //this.logger.log(selected_ep_plans);


  //   for (var cp = 0; cp < selected_cp_plans.length; cp++) {
  //     var current_cp_plan: any = selected_cp_plans[cp];

  //     current_cp_plan.amount = parseFloat(
  //       this._decimalPipe.transform(current_cp_plan.amount, "1.2-2")
  //     );

  //     current_cp_plan["amounts"] = {
  //       company: current_cp_plan.amount,
  //       employee: 0,
  //       total: current_cp_plan.amount,
  //     };
  //     current_cp_plan["categorization"] = {
  //       paidByCompany: true,
  //       coveredByCompany: false,
  //       paidByEmployee: false,
  //     };

  //     current_cp_plan["type"] = "100% Corporate Paid"

  //     current_cp_plan["companyCoveredBasePlan"] = {
  //       planId: 0, //0
  //       planName: "NA", //NA
  //       planLevelId: 0, //0
  //       amount: 0, //0
  //       tax: 0,
  //       total: 0,
  //     };
  //     current_cp_plan["employeeAmount"] = current_cp_plan["amounts"].employee;
  //     current_cp_plan["employeeAmountUI"] = "$" + current_cp_plan["amounts"].employee;
  //     current_cp_plan["companyAmount"] = current_cp_plan["amounts"].company;
  //     current_cp_plan["companyAmountUI"] = "$" + current_cp_plan["amounts"].company;
  //     current_cp_plan["planLevelName"] = current_cp_plan.groupName || ""; //Here

  //     if (current_cp_plan.id == 429 || current_cp_plan.packageId == 8 || current_cp_plan.planLevel == 16) {
  //       alloptinplans.push(current_cp_plan)

  //     }
  //     else {
  //       all_selected_plans.push(current_cp_plan);
  //       company_selected_plans.push(current_cp_plan);
  //       company_paid_selected_plans.push(current_cp_plan);
  //     }




  //   }

  //   for (var cc = 0; cc < selected_cc_plans.length; cc++) {
  //     var current_cc_plan: any = selected_cc_plans[cc];

  //     current_cc_plan["amounts"] = {
  //       company: current_cc_plan.upgradeCalculation.baseplanPrice,
  //       employee: current_cc_plan.upgradeCalculation.deltaplanPrice,
  //       total: current_cc_plan.upgradeCalculation.combinedplanPrice,
  //     };



  //     current_cc_plan["companyCoveredBasePlan"] = current_cc_plan.upgradeCalculation.basePlanDetails


  //     current_cc_plan["companyCoveredBasePlan"].companyTax = current_cc_plan.upgradeCalculation.baseplanTax;
  //     current_cc_plan["companyCoveredBasePlan"].companyTaxPercentage = current_cc_plan.upgradeCalculation.companyTaxPercentage;

  //     current_cc_plan["companyCoveredBasePlan"].employeeTax = 0;
  //     current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentage = current_cc_plan.upgradeCalculation.employeeTaxPercentage;
  //     current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect = 0;
  //     current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentageEffect = "0%";
  //     current_cc_plan["companyCoveredBasePlan"].specialTax = current_cc_plan["companyCoveredBasePlan"].companyTax + current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect;
  //     current_cc_plan["companyCoveredBasePlan"].tax2 = current_cc_plan["companyCoveredBasePlan"].companyTax

  //     ///
  //     //deleta plan things
  //     current_cc_plan["employeeDeductions"] = {
  //       amount: current_cc_plan.upgradeCalculation.deltaplanPrice, //0
  //       amountUI: `$${current_cc_plan.upgradeCalculation.deltaplanPrice}`, //0
  //       tax: `${current_cc_plan.upgradeCalculation.deltaplanTax}`,
  //       total: `${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
  //       taxUI: `$${current_cc_plan.upgradeCalculation.deltaplanTax}`,
  //       totalUI: `$${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
  //     };

  //     // current_cc_plan["employeeDeductions"].amountUI =
  //     //   "$" + current_cc_plan["employeeDeductions"].amount;
  //     // current_cc_plan["employeeDeductions"].taxUI = current_cc_plan[
  //     //   "companyCoveredBasePlan"
  //     // ].taxUI.replace(
  //     //   current_cc_plan["companyCoveredBasePlan"].tax,
  //     //   current_cc_plan["employeeDeductions"].tax
  //     // );
  //     // current_cc_plan["employeeDeductions"].totalUI =
  //     //   "$" + current_cc_plan["employeeDeductions"].total;




  //     current_cc_plan["categorization"] = {
  //       paidByCompany: false,
  //       coveredByCompany: true,
  //       paidByEmployee: false,
  //     };


  //     current_cc_plan["type"] = current_cc_plan.upgradeCalculation.type

  //     current_cc_plan["planGrandTotal"] = {
  //       amount: current_cc_plan.upgradeCalculation.combinedplanPrice, //0
  //       amountUI: `$${current_cc_plan.upgradeCalculation.combinedplanPrice}`, //0
  //       tax: current_cc_plan.upgradeCalculation.combinedplanTax,
  //       total: current_cc_plan.upgradeCalculation.combinedplanTotal,
  //       taxUI: `$${current_cc_plan.upgradeCalculation.combinedplanTax}`,
  //       totalUI: `$${current_cc_plan.upgradeCalculation.combinedplanTotal}`,
  //     };
  //     // planid,planname,planlevelid,planlevename,amount
  //     current_cc_plan.amount = current_cc_plan["planGrandTotal"].amount
  //     current_cc_plan.amountUI = current_cc_plan["planGrandTotal"].amount
  //     current_cc_plan.tax = current_cc_plan["planGrandTotal"].tax
  //     current_cc_plan.taxUI = current_cc_plan["planGrandTotal"].taxUI
  //     current_cc_plan.total = current_cc_plan["planGrandTotal"].total
  //     current_cc_plan.totalUI = current_cc_plan["planGrandTotal"].totalUI
  //     current_cc_plan.skuTotalPrice = current_cc_plan["planGrandTotal"].total
  //     current_cc_plan.totalPrice = current_cc_plan["planGrandTotal"].total




  //     //this.logger.log(current_cc_plan);

  //     current_cc_plan["companyShareTotal"] = current_cc_plan["companyCoveredBasePlan"].total;
  //     current_cc_plan["employeeShareTotal"] = current_cc_plan["employeeDeductions"].total;

  //     current_cc_plan["companySharePlanAmountTotal"] = current_cc_plan["companyCoveredBasePlan"].amount;
  //     current_cc_plan["employeeSharePlanAmountTotal"] = current_cc_plan["employeeDeductions"].amount;

  //     current_cc_plan["companyShareTaxTotal"] = current_cc_plan["companyCoveredBasePlan"].tax;
  //     current_cc_plan["employeeShareTaxTotal"] = current_cc_plan["employeeDeductions"].tax;

  //     current_cc_plan["employeeAmount"] = current_cc_plan["amounts"].employee;
  //     current_cc_plan["employeeAmountUI"] = "$" + current_cc_plan["amounts"].employee;
  //     current_cc_plan["companyAmount"] = current_cc_plan["amounts"].company;
  //     current_cc_plan["companyAmountUI"] = "$" + current_cc_plan["amounts"].company;
  //     //this.logger.log(current_cc_plan["amounts"].employee);
  //     //this.logger.log(current_cc_plan["amounts"].company);
  //     //this.logger.log(current_cc_plan["amounts"].total);
  //     this.coveredEmployeeShare += parseFloat(current_cc_plan["amounts"].employee);

  //     this.coveredEmployeeShare = parseFloat(
  //       this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2")
  //     );

  //     all_selected_plans.push(current_cc_plan);
  //     company_selected_plans.push(current_cc_plan);
  //     company_covered_selected_plans.push(current_cc_plan);

  //     if (current_cc_plan.upgradeCalculation.payroll) {
  //       payrollCCplans.push(current_cc_plan)
  //     } else {
  //       directpayCCplans.push(current_cc_plan)
  //     }
  //     //this.logger.log("payrollCCplans",payrollCCplans)
  //     //this.logger.log("directpayCCplans",directpayCCplans)
  //   }


  //   for (var ep = 0; ep < selected_ep_plans.length; ep++) {
  //     var current_ep_plan: any = selected_ep_plans[ep];

  //     //this.logger.log(current_ep_plan)

  //     current_ep_plan.amount = parseFloat(current_ep_plan.products[0].price);

  //     current_ep_plan["amounts"] = {
  //       company: 0,
  //       employee: current_ep_plan.total, //current_ep_plan.amount,(+tax)
  //       total: current_ep_plan.total, //current_ep_plan.amount,(+tax)
  //     };

  //     current_ep_plan["categorization"] = {
  //       paidByCompany: false,
  //       coveredByCompany: false,
  //       paidByEmployee: true,
  //     };

  //     current_ep_plan["type"] = "Voluntary Opt-in"

  //     current_ep_plan["companyCoveredBasePlan"] = {
  //       planId: 0, //0
  //       planName: "NA", //NA
  //       planLevelId: 0, //0
  //       amount: 0, //0
  //       tax: 0,
  //       total: 0,
  //     };
  //     current_ep_plan["employeeAmount"] = current_ep_plan["amounts"].employee;
  //     current_ep_plan["employeeAmountUI"] = "$" + current_ep_plan["amounts"].employee;
  //     current_ep_plan["companyAmount"] = current_ep_plan["amounts"].company;
  //     current_ep_plan["companyAmountUI"] = "$" + current_ep_plan["amounts"].company;
  //     //  current_cp_plan["planLevelName"] = current_ep_plan.groupName || ""

  //     //this.logger.log(current_ep_plan)

  //     //this.logger.log(current_ep_plan["amounts"].employee);
  //     //this.logger.log(this.paidEmployeeShare);
  //     // this.paidEmployeeShare = +current_ep_plan["amounts"].employee;
  //     this.paidEmployeeShare += parseFloat(current_ep_plan["amounts"].total);
  //     //this.logger.log(this.paidEmployeeShare);
  //     // this.paidEmployeeShare = parseFloat(
  //     //   this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2")
  //     // );

  //     //this.logger.log(this.paidEmployeeShare);
  //     all_selected_plans.push(current_ep_plan);
  //     employee_selected_plans.push(current_ep_plan);
  //   }

  //   employeeDealingPlans = directpayCCplans.concat(employee_selected_plans)
  //   companyDealingPlans = company_paid_selected_plans.concat(payrollCCplans)


  //   //this.logger.log("employeeDealingPlans",employeeDealingPlans)
  //   //this.logger.log("companyDealingPlans",companyDealingPlans)

  //   this.alloptinplans = alloptinplans


  //   //this.logger.log(this.coveredEmployeeShare);
  //   //this.logger.log(this.paidEmployeeShare);


  //   sessionStorage.setItem("employeeshare", this.paidEmployeeShare)
  //   //this.logger.log(this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2"));
  //   //this.logger.log(this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2"));

  //   this.totalEmployeeShare = this.coveredEmployeeShare + this.paidEmployeeShare;
  //   this.cartDisplayAmount = this.paidEmployeeShare;
  //   this.totalEmployeeShare = parseFloat(
  //     this._decimalPipe.transform(this.totalEmployeeShare, "1.2-2")
  //   );
  //   this.cartDisplayAmount = this._decimalPipe.transform(this.cartDisplayAmount, "1.2-2");

  //   //this.cartDisplayAmount = floatWith2Decimals(this.cartDisplayAmount);

  //   //this.logger.log(this.totalEmployeeShare);



  //   /* if (employee_selected_plans.length > 0) {
  //      this.showPaymenthMethod = true;
  //      this.showPaymenthMethod1 = false;
  //      this.creditcardform = true;
  //      sessionStorage.setItem("paymentMethod", "CC");
  //      this.bankpaymentmethod = "CC";

  //    } else {


  //      this.showPaymenthMethod = false;
  //      this.showPaymenthMethod1 = true;
  //      this.creditcardform = false;
  //      sessionStorage.setItem("paymentMethod", "NONE");
  //    }*/
  //   if (employeeDealingPlans.length > 0) {
  //     this.showPaymenthMethod = true;
  //     this.showPaymenthMethod1 = false;
  //     this.creditcardform = true;
  //     sessionStorage.setItem("paymentMethod", "CC");
  //     this.bankpaymentmethod = "CC";

  //   } else {


  //     this.showPaymenthMethod = false;
  //     this.showPaymenthMethod1 = true;
  //     this.creditcardform = false;
  //     sessionStorage.setItem("paymentMethod", "NONE");
  //   }

  //   this.directpayCCplansarr = directpayCCplans
  //   this.payrollCCplansarr = payrollCCplans
  //   this.companyDealingPlans = companyDealingPlans
  //   this.employeeDealingPlansarr = employeeDealingPlans

  //   this.payrollCCplansarr = this.payrollCCplansarr.sort(function (a, b) {
  //     return (a.packageId - b.packageId);
  //   })
  //   this.companyDealingPlans = this.companyDealingPlans.sort(function (a, b) {
  //     return (a.packageId - b.packageId);
  //   })
  //   this.companyDealingPlans = this.companyDealingPlans.sort(function (a, b) {
  //     return (a.packageId - b.packageId);
  //   })
  //   //this.logger.log(this.companyDealingPlans)
  //   //this.logger.log(this.payrollCCplansarr)
  //   //this.logger.log(this.employeeDealingPlansarr)
  //   sessionStorage.setItem("allSelectedPlans", JSON.stringify(all_selected_plans));
  //   sessionStorage.setItem("allSelectedOptPlans", JSON.stringify(alloptinplans));
  //   //this.logger.log(all_selected_plans);
  //   //this.logger.log(company_selected_plans);

  //   //this.logger.log(company_paid_selected_plans);
  //   //this.logger.log(company_covered_selected_plans);
  //   //this.logger.log(employee_selected_plans);

  //   //company paid plans
  //   this.companySelectedPlans = company_paid_selected_plans;
  //   this.companyCoveredPlans = company_covered_selected_plans;
  //   this.EmployeeSelectedPlans = employee_selected_plans;



  //   this.allSelectedPlans = all_selected_plans;

  //   this.allSelectedPlans = this.allSelectedPlans.sort(function (a, b) {
  //     return (a.packageId - b.packageId);
  //   })

  //   this.allPlansAmountTotal = sumBy(this.allSelectedPlans, "amount");
  //   //     this.allPlansAmountTotal =  this._decimalPipe.transform(
  //   //   this.allPlansAmountTotal,
  //   //   "1.2-2"
  //   // );
  //   this.allPlansTotal = sumBy(this.allSelectedPlans, "total");
  //   // this.allPlansTotal =  this._decimalPipe.transform(
  //   //   this.allPlansTotal,
  //   //   "1.2-2"
  //   // );
  //   this.allPlansTotaltax = sumBy(this.allSelectedPlans, "tax");
  //   // this.allPlansTotaltax =  this._decimalPipe.transform(
  //   //   this.allPlansTotaltax,
  //   //   "1.2-2"
  //   // );

  //   this.allCPPlansAmountTotal = sumBy(this.companySelectedPlans, "amount");
  //   this.allCPTaxTotal = sumBy(this.companySelectedPlans, "tax");
  //   this.companyPaidTotal = sumBy(this.companySelectedPlans, "total");
  //   //this.logger.log(this.companyPaidTotal);
  //   // this.companyPaidTotal =  this._decimalPipe.transform(
  //   //   this.companyPaidTotal,
  //   //   "1.2-2"
  //   // );
  //   //this.logger.log(this.companyPaidTotal);
  //   // for(var i=0;i<this.companySelectedPlans.length;i++){
  //   //   this.companyPaidTotal += this.companySelectedPlans[i].total

  //   //   this.companyPaidTotal = parseFloat(this._decimalPipe.transform(this.companySelectedPlans[i].total, "1.2-2"))

  //   // }
  //   // for(var i=0;i<this.companyCoveredPlans.length;i++){
  //   //   this.companyCoveredTotal += this.companyCoveredPlans[i].total
  //   //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.companyCoveredTotal, "1.2-2"))

  //   // }
  //   this.allCCPlansAmountTotal = sumBy(this.companyCoveredPlans, "amount");
  //   this.allCCTaxTotal = sumBy(this.companyCoveredPlans, "tax");
  //   this.companyCoveredTotal = sumBy(this.companyCoveredPlans, "total");
  //   //this.logger.log(this.allCCPlansAmountTotal);
  //   //this.logger.log(this.allCCTaxTotal);
  //   //this.logger.log(this.companyCoveredTotal);
  //   this.companyCoveredCompanyShareTotal = sumBy(this.companyCoveredPlans, "companyShareTotal");
  //   this.companyCoveredCompanySharePlanAmountTotal = sumBy(this.companyCoveredPlans, "companySharePlanAmountTotal");
  //   this.companyCoveredCompanyShareTaxTotal = sumBy(this.companyCoveredPlans, "companyShareTaxTotal");
  //   this.companyCoveredEmployeeShareTotal = sumBy(this.companyCoveredPlans, "employeeShareTotal");
  //   this.companyCoveredEmployeeSharePlanAmountTotal = sumBy(this.companyCoveredPlans, "employeeSharePlanAmountTotal");
  //   this.companyCoveredEmployeeShareTaxTotal = sumBy(this.companyCoveredPlans, "employeeShareTaxTotal");

  //   this.payrollCCPlansAmountTotal = sumBy(payrollCCplans, "amount");
  //   this.payrollCCPlantaxTotal = sumBy(payrollCCplans, "tax");
  //   this.payrollCCPlangrandTotal = sumBy(payrollCCplans, "total");

  //   this.DirectCCpayPlanamountTotal = sumBy(directpayCCplans, "amount");
  //   this.DirectCCpayPlantaxTotal = sumBy(directpayCCplans, "tax");
  //   this.DirectCCpayPlangrandTotal = sumBy(directpayCCplans, "total");

  //   //The below includes Employee-voluntary-plans and company-covered-split with direct-pay-plans
  //   this.empDirectpayPlanamountTotal = sumBy(employeeDealingPlans, "amount");
  //   this.empDirectpayPlantaxTotal = sumBy(employeeDealingPlans, "tax");
  //   this.empDirectpayPlangrandTotal = sumBy(employeeDealingPlans, "total");

  //   //Company paid and company covered split with payroll
  //   this.companydealingplansTotal = sumBy(companyDealingPlans, "amount");
  //   this.companydealingplanstaxTotal = sumBy(companyDealingPlans, "tax");
  //   this.companydealingplansgrandTotal = sumBy(companyDealingPlans, "total");


  //   // for(var i=0;i<this.EmployeeSelectedPlans.length;i++){
  //   //   this.companyCoveredTotal += this.EmployeeSelectedPlans[i].total
  //   //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.EmployeeSelectedPlans[i].total, "1.2-2"))

  //   // }
  //   //cp+cc(company)
  //   this.effectiveCompanyPlansAmountTotal = parseFloat(this.allCPPlansAmountTotal) + parseFloat(this.companyCoveredCompanySharePlanAmountTotal)
  //   this.effectiveCompanyPlansAmountTotal = this._decimalPipe.transform(
  //     this.effectiveCompanyPlansAmountTotal,
  //     "1.2-2"
  //   );
  //   this.effectiveCompanyTaxTotal = parseFloat(this.allCPTaxTotal) + parseFloat(this.companyCoveredCompanyShareTaxTotal)
  //   this.effectiveCompanyTaxTotal = this._decimalPipe.transform(
  //     this.effectiveCompanyTaxTotal,
  //     "1.2-2"
  //   );
  //   this.effectiveCompanyTotalContibution = parseFloat(this.companyPaidTotal) + parseFloat(this.companyCoveredCompanyShareTotal)
  //   this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
  //     this.effectiveCompanyTotalContibution,
  //     "1.2-2"
  //   );

  //   this.allEPPlansAmountTotal = sumBy(this.EmployeeSelectedPlans, "amount");
  //   this.allEPTaxTotal = sumBy(this.EmployeeSelectedPlans, "tax");
  //   this.paidEmployeedTotal = sumBy(this.EmployeeSelectedPlans, "total");
  //   //this.logger.log(this.paidEmployeedTotal);
  //   // this.paidEmployeedTotal = this._decimalPipe.transform(
  //   //   this.paidEmployeedTotal,
  //   //   "1.2-2"
  //   // );
  //   // //this.logger.log(this.companyPaidTotal)
  //   // //this.logger.log(this.companyCoveredTotal)
  //   // //this.logger.log(this.paidEmployeedTotal)

  //   // this.effectiveEmployeeTotalContibution =
  //   //   parseFloat(this.companyCoveredEmployeeShareTotal) + parseFloat(this.paidEmployeedTotal);
  //   // this.effectiveEmployeeTotalContibution = this._decimalPipe.transform(
  //   //   this.effectiveEmployeeTotalContibution,
  //   //   "1.2-2"
  //   // );


  //   this.effectiveEmployeeTotalContibution =
  //     parseFloat(this.companyCoveredEmployeeShareTotal) +
  //     parseFloat(this.paidEmployeedTotal);

  //   this.effectiveEmployeeTotalContibution = adjustWith2DecimalsForUI(
  //     this.effectiveEmployeeTotalContibution
  //   );
  //   // this.effectiveEmployeeTotalContibution = this._decimalPipe.transform(
  //   //   this.effectiveEmployeeTotalContibution,
  //   //   "1.2-2"
  //   // );

  //   this.effectiveCompanyTotalContibution = parseFloat(
  //     this.companyCoveredCompanyShareTotal,
  //   ) + parseFloat(
  //     this.companyPaidTotal,
  //   );

  //   this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
  //     this.effectiveCompanyTotalContibution,
  //     "1.2-2"
  //   );




  //   //this.logger.log(this.companyCoveredPlans)
  //   //payrollDeduction setting

  //   let payrollDeduction = sessionStorage.getItem("payrollDeduction") ? sessionStorage.getItem("payrollDeduction") : "EMPLOYEE_CHOICE"

  //   if (this.companyCoveredPlans.length > 0 && payrollDeduction == "EMPLOYEE_CHOICE") {



  //     // $("payrolldeduction-modal").show()
  //     // jQuery("#payrolldeduction-modal").modal("show");


  //   }




  // }
  public planCoverafeFunction() {
    this.paidEmployeeShare = 0;
    this.coveredEmployeeShare = 0;

    //this.consoleMessage("plancoverage");

    let planDetailsArray = JSON.parse(
      sessionStorage.getItem("planDetailsArray") || "[]"
    );
    //this.consoleMessage(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans2(this.packagesInBlocks);
    var package_plans = this.convertpackagesToPlans2(this.basepackages);

    //this.consoleMessage(package_plans);
    let planSummaryMain = JSON.parse(sessionStorage.getItem("plansummary") || "[]");
    let planSummaryLife = JSON.parse(sessionStorage.getItem("plansummaryLife") || "[]");
    // let iafgplansCheck = JSON.parse(
    //   sessionStorage.getItem('plansummaryLife') || '[]'
    // );

    this.iafgplansCheck = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );
    //console.log(planSummaryMain)

    // let planSummary;
    // if(planSummaryMain.length>0){
    //  let planSummary = planSummaryMain.concat(planSummaryLife)
    // }else{
    //    planSummary = planSummaryLife
    // }
    let planSummary = planSummaryMain.concat(planSummaryLife)

    //console.log(planSummary)
    //this.consoleMessage(planSummary);
    var all_selected_plans = [];
    var payrollCCplans = [];
    var directpayCCplans = [];
    var employeeDealingPlans = [];
    var companyDealingPlans = [];
    var alloptinplans = [];
    var company_selected_plans = [];
    var employee_selected_plans = [];
    var company_paid_selected_plans = [];
    var company_covered_selected_plans = [];


    var selected_cp_plans = planSummary.filter(function (plan: any) {
      return plan.paidByCompany == 1 || plan.categorization?.paidByCompany == true;;
    });

    var selected_cc_plans = planSummary.filter(function (plan: any) {
      return plan.coveredByCompany == 1 || plan.categorization?.coveredByCompany == true;;
    });

    var selected_ep_plans = planSummary.filter(function (plan: any) {
      return plan.paidByEmployee == 1 || plan.categorization?.paidByEmployee == true;
    });

    // var selected_cc_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.coveredByCompany == 1;

    //   });

    // });

    // var selected_cp_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByCompany == 1;

    //   });

    // });
    // var selected_ep_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByEmployee == 1;

    //   });

    // });

    //this.consoleMessage(selected_cc_plans);
    //this.consoleMessage(selected_cp_plans);
    //this.consoleMessage(selected_ep_plans);

    //console.log(selected_cp_plans)

    for (var cp = 0; cp < selected_cp_plans.length; cp++) {
      var current_cp_plan: any = selected_cp_plans[cp];

      // current_cp_plan.amount = parseFloat(
      //   this._decimalPipe.transform(current_cp_plan.amount, "1.2-2")
      // );
      current_cp_plan.amount = adjustWith2DecimalsForUI(current_cp_plan.amount)

      // //this.consoleMessage("rakesh",current_cp_plan.amount)
      current_cp_plan["amounts"] = {
        company: current_cp_plan.amount,
        employee: 0,
        total: current_cp_plan.amount,
      };
      current_cp_plan["categorization"] = {
        paidByCompany: true,
        coveredByCompany: false,
        paidByEmployee: false,
      };

      current_cp_plan["type"] = this.lang["100_Company_Paid"];

      current_cp_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_cp_plan["employeeAmount"] = current_cp_plan["amounts"].employee;
      current_cp_plan["employeeAmountUI"] =
        "$" + current_cp_plan["amounts"].employee;
      current_cp_plan["companyAmount"] = current_cp_plan["amounts"].company;
      current_cp_plan["companyAmountUI"] =
        "$" + current_cp_plan["amounts"].company;
      current_cp_plan["planLevelName"] = current_cp_plan.groupName || ""; //Here

      if (
        current_cp_plan.id == 429 ||
        current_cp_plan.packageId == 8 ||
        current_cp_plan.planLevel == 16
      ) {
        alloptinplans.push(current_cp_plan);
      } else {
        all_selected_plans.push(current_cp_plan);
        company_selected_plans.push(current_cp_plan);
        company_paid_selected_plans.push(current_cp_plan);
      }
    }

    for (var cc = 0; cc < selected_cc_plans.length; cc++) {
      var current_cc_plan: any = selected_cc_plans[cc];

      current_cc_plan["amounts"] = {
        company: current_cc_plan.upgradeCalculation.baseplanPrice,
        employee: current_cc_plan.upgradeCalculation.deltaplanPrice,
        total: current_cc_plan.upgradeCalculation.combinedplanPrice,
      };

      current_cc_plan["companyCoveredBasePlan"] =
        current_cc_plan.upgradeCalculation.basePlanDetails;

      current_cc_plan["companyCoveredBasePlan"].companyTax =
        current_cc_plan.upgradeCalculation.baseplanTax;
      current_cc_plan["companyCoveredBasePlan"].companyTaxPercentage =
        current_cc_plan.upgradeCalculation.companyTaxPercentage;

      current_cc_plan["companyCoveredBasePlan"].employeeTax = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentage =
        current_cc_plan.upgradeCalculation.employeeTaxPercentage;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentageEffect =
        "0%";
      current_cc_plan["companyCoveredBasePlan"].specialTax =
        current_cc_plan["companyCoveredBasePlan"].companyTax +
        current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect;
      current_cc_plan["companyCoveredBasePlan"].tax2 =
        current_cc_plan["companyCoveredBasePlan"].companyTax;

      //this.consoleMessage(current_cc_plan);
      ///
      //deleta plan things
      current_cc_plan["employeeDeductions"] = {
        amount: current_cc_plan.upgradeCalculation.deltaplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.deltaplanPrice}`, //0
        tax: `${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        total: `${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
        taxUI: `$${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
      };

      // current_cc_plan["employeeDeductions"].amountUI =
      //   "$" + current_cc_plan["employeeDeductions"].amount;
      // current_cc_plan["employeeDeductions"].taxUI = current_cc_plan[
      //   "companyCoveredBasePlan"
      // ].taxUI.replace(
      //   current_cc_plan["companyCoveredBasePlan"].tax,
      //   current_cc_plan["employeeDeductions"].tax
      // );
      // current_cc_plan["employeeDeductions"].totalUI =
      //   "$" + current_cc_plan["employeeDeductions"].total;

      current_cc_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: true,
        paidByEmployee: false,
      };

      current_cc_plan["type"] = current_cc_plan.upgradeCalculation.type;

      current_cc_plan["planGrandTotal"] = {
        amount: current_cc_plan.upgradeCalculation.combinedplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.combinedplanPrice}`, //0
        tax: current_cc_plan.upgradeCalculation.combinedplanTax,
        total: current_cc_plan.upgradeCalculation.combinedplanTotal,
        taxUI: `$${current_cc_plan.upgradeCalculation.combinedplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.combinedplanTotal}`,
      };
      // planid,planname,planlevelid,planlevename,amount
      current_cc_plan.amount = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.amountUI = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.tax = current_cc_plan["planGrandTotal"].tax;
      current_cc_plan.taxUI = current_cc_plan["planGrandTotal"].taxUI;
      current_cc_plan.total = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalUI = current_cc_plan["planGrandTotal"].totalUI;
      current_cc_plan.skuTotalPrice = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalPrice = current_cc_plan["planGrandTotal"].total;

      //this.consoleMessage(current_cc_plan);

      current_cc_plan["companyShareTotal"] =
        current_cc_plan["companyCoveredBasePlan"].total;
      current_cc_plan["employeeShareTotal"] =
        current_cc_plan["employeeDeductions"].total;

      current_cc_plan["companySharePlanAmountTotal"] =
        current_cc_plan["companyCoveredBasePlan"].amount;
      current_cc_plan["employeeSharePlanAmountTotal"] =
        current_cc_plan["employeeDeductions"].amount;

      current_cc_plan["companyShareTaxTotal"] =
        current_cc_plan["companyCoveredBasePlan"].tax;
      current_cc_plan["employeeShareTaxTotal"] =
        current_cc_plan["employeeDeductions"].tax;

      current_cc_plan["employeeAmount"] = current_cc_plan["amounts"].employee;
      current_cc_plan["employeeAmountUI"] =
        "$" + current_cc_plan["amounts"].employee;
      current_cc_plan["companyAmount"] = current_cc_plan["amounts"].company;
      current_cc_plan["companyAmountUI"] =
        "$" + current_cc_plan["amounts"].company;
      //this.consoleMessage(current_cc_plan["amounts"].employee);
      //this.consoleMessage(current_cc_plan["amounts"].company);
      //this.consoleMessage(current_cc_plan["amounts"].total);
      this.coveredEmployeeShare += parseFloat(
        current_cc_plan["amounts"].employee
      );

      // this.coveredEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2" ||)
      // );
      this.coveredEmployeeShare = parseFloat(this.coveredEmployeeShare)
      all_selected_plans.push(current_cc_plan);
      company_selected_plans.push(current_cc_plan);
      company_covered_selected_plans.push(current_cc_plan);

      if (current_cc_plan.upgradeCalculation.payroll) {
        payrollCCplans.push(current_cc_plan);
      } else {
        directpayCCplans.push(current_cc_plan);
      }
      //this.consoleMessage("payrollCCplans",payrollCCplans)
      //this.consoleMessage("directpayCCplans",directpayCCplans)
    }

    for (var ep = 0; ep < selected_ep_plans.length; ep++) {
      var current_ep_plan: any = selected_ep_plans[ep];

      //this.consoleMessage(current_ep_plan)

      current_ep_plan.amount = adjustWith2DecimalsForUI(current_ep_plan.products[0].price);

      current_ep_plan["amounts"] = {
        company: 0,
        employee: current_ep_plan.total, //current_ep_plan.amount,(+tax)
        total: current_ep_plan.total, //current_ep_plan.amount,(+tax)
      };

      current_ep_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: false,
        paidByEmployee: true,
      };

      current_ep_plan["type"] = this.lang["Voluntary_Opt_In"];

      current_ep_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_ep_plan["employeeAmount"] = current_ep_plan["amounts"].employee;
      current_ep_plan["employeeAmountUI"] =
        "$" + current_ep_plan["amounts"].employee;
      current_ep_plan["companyAmount"] = current_ep_plan["amounts"].company;
      current_ep_plan["companyAmountUI"] =
        "$" + current_ep_plan["amounts"].company;
      //  current_cp_plan["planLevelName"] = current_ep_plan.groupName || ""

      //this.consoleMessage(current_ep_plan)

      //console.log(current_ep_plan)

      //this.consoleMessage(current_ep_plan["amounts"].employee);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = +current_ep_plan["amounts"].employee;
      this.paidEmployeeShare += parseFloat(current_ep_plan["amounts"].total);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2")
      // );

      //this.consoleMessage(this.paidEmployeeShare);
      all_selected_plans.push(current_ep_plan);
      employee_selected_plans.push(current_ep_plan);
    }

    employeeDealingPlans = directpayCCplans.concat(employee_selected_plans);

    //console.log(employeeDealingPlans)
    companyDealingPlans = company_paid_selected_plans.concat(payrollCCplans);
    //console.log(this.iafgplansCheck)
    // employeeDealingPlans = employeeDealingPlans.concat(this.iafgplansCheck)  //hererakesh
    //console.log(employeeDealingPlans)

    //this.consoleMessage("employeeDealingPlans",employeeDealingPlans)
    //this.consoleMessage("companyDealingPlans",companyDealingPlans)

    this.alloptinplans = alloptinplans;

    //this.consoleMessage(this.coveredEmployeeShare);
    //this.consoleMessage(this.paidEmployeeShare);

    sessionStorage.setItem("employeeshare", this.paidEmployeeShare);
    //this.consoleMessage(this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2"));
    //this.consoleMessage(this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2"));

    var totalIAFG = 0;
    for (let i = 0; i < this.iafgplansCheck.length; i++) {
      totalIAFG += parseFloat(this.iafgplansCheck[i].skuTotalPrice);
    }



    this.totalEmployeeShare =
      this.coveredEmployeeShare + this.paidEmployeeShare;
    // this.cartDisplayAmount = this.paidEmployeeShare + totalIAFG;
    this.cartDisplayAmount = this.paidEmployeeShare;
    // this.totalEmployeeShare = parseFloat(
    //   this._decimalPipe.transform(this.totalEmployeeShare, "1.2-2")
    // );
    this.totalEmployeeShare = parseFloat(this.totalEmployeeShare)
    this.cartDisplayAmount = this._decimalPipe.transform(
      this.cartDisplayAmount,
      "1.2-2"
    );

    //this.cartDisplayAmount = floatWith2Decimals(this.cartDisplayAmount);

    //this.consoleMessage(this.totalEmployeeShare);

    /* if (employee_selected_plans.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";

    } else {


      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      sessionStorage.setItem("paymentMethod", "NONE");
    }*/

    //console.log(this.iafgplansCheck)
    //console.log(this.iafgplansCheck.length)
    if (employeeDealingPlans.length > 0 || this.iafgplansCheck.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";
      this.voluntryplansCheck = true
      // this.paymentForm.get('paymentRadioCheck')?.setValue("CC");
    } else {
      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      this.voluntryplansCheck = false
      // this.bankpay =false;  //rakesh
      // this.paymentForm.get('paymentRadioCheck')?.setValue('');
      sessionStorage.setItem("paymentMethod", "NONE");
    }

    this.directpayCCplansarr = directpayCCplans;
    this.payrollCCplansarr = payrollCCplans;
    this.companyDealingPlans = companyDealingPlans;
    this.employeeDealingPlansarr = employeeDealingPlans;

    //console.log(this.employeeDealingPlansarr)


    this.payrollCCplansarr = this.payrollCCplansarr.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    if (this.payrollCCplansarr.length > 0) {
      this.upgradeplansCheck = true
    }
    //this.consoleMessage(this.companyDealingPlans)
    //this.consoleMessage(this.payrollCCplansarr)
    sessionStorage.setItem(
      "allSelectedPlans",
      JSON.stringify(all_selected_plans)
    );
    sessionStorage.setItem(
      "allSelectedOptPlans",
      JSON.stringify(alloptinplans)
    );
    //this.consoleMessage(all_selected_plans);
    //this.consoleMessage(company_selected_plans);

    //this.consoleMessage(company_paid_selected_plans);
    //this.consoleMessage(company_covered_selected_plans);
    //this.consoleMessage(employee_selected_plans);

    //company paid plans

    this.companySelectedPlans = company_paid_selected_plans;
    this.companyCoveredPlans = company_covered_selected_plans;
    // this.EmployeeSelectedPlans = employee_selected_plans.concat(this.iafgplansCheck);
    this.EmployeeSelectedPlans = employee_selected_plans
    this.allSelectedPlans = all_selected_plans;

    this.allSelectedPlans = this.allSelectedPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    this.allPlansAmountTotal = sumBy(this.allSelectedPlans, "amount");
    //     this.allPlansAmountTotal =  this._decimalPipe.transform(
    //   this.allPlansAmountTotal,
    //   "1.2-2"
    // );
    this.allPlansTotal = sumBy(this.allSelectedPlans, "total");
    // this.allPlansTotal =  this._decimalPipe.transform(
    //   this.allPlansTotal,
    //   "1.2-2"
    // );
    this.allPlansTotaltax = sumBy(this.allSelectedPlans, "tax");
    // this.allPlansTotaltax =  this._decimalPipe.transform(
    //   this.allPlansTotaltax,
    //   "1.2-2"
    // );

    this.allCPPlansAmountTotal = sumBy(this.companySelectedPlans, "amount");
    this.allCPTaxTotal = sumBy(this.companySelectedPlans, "tax");
    this.companyPaidTotal = sumBy(this.companySelectedPlans, "total");
    //this.consoleMessage(this.companyPaidTotal);
    // this.companyPaidTotal =  this._decimalPipe.transform(
    //   this.companyPaidTotal,
    //   "1.2-2"
    // );
    //this.consoleMessage(this.companyPaidTotal);
    // for(var i=0;i<this.companySelectedPlans.length;i++){
    //   this.companyPaidTotal += this.companySelectedPlans[i].total

    //   this.companyPaidTotal = parseFloat(this._decimalPipe.transform(this.companySelectedPlans[i].total, "1.2-2"))

    // }
    // for(var i=0;i<this.companyCoveredPlans.length;i++){
    //   this.companyCoveredTotal += this.companyCoveredPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.companyCoveredTotal, "1.2-2"))

    // }
    this.allCCPlansAmountTotal = sumBy(this.companyCoveredPlans, "amount");
    this.allCCTaxTotal = sumBy(this.companyCoveredPlans, "tax");
    this.companyCoveredTotal = sumBy(this.companyCoveredPlans, "total");
    //this.consoleMessage(this.allCCPlansAmountTotal);
    //this.consoleMessage(this.allCCTaxTotal);
    //this.consoleMessage(this.companyCoveredTotal);
    this.companyCoveredCompanyShareTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTotal"
    );
    this.companyCoveredCompanySharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "companySharePlanAmountTotal"
    );
    this.companyCoveredCompanyShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTaxTotal"
    );
    this.companyCoveredEmployeeShareTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTotal"
    );
    this.companyCoveredEmployeeSharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "employeeSharePlanAmountTotal"
    );
    this.companyCoveredEmployeeShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTaxTotal"
    );

    this.payrollCCPlansAmountTotal = sumBy(payrollCCplans, "amount");
    this.payrollCCPlantaxTotal = sumBy(payrollCCplans, "tax");
    this.payrollCCPlangrandTotal = sumBy(payrollCCplans, "total");

    this.DirectCCpayPlanamountTotal = sumBy(directpayCCplans, "amount");
    this.DirectCCpayPlantaxTotal = sumBy(directpayCCplans, "tax");
    this.DirectCCpayPlangrandTotal = sumBy(directpayCCplans, "total");

    //The below includes Employee-voluntary-plans and company-covered-split with direct-pay-plans
    this.empDirectpayPlanamountTotal = sumBy(employeeDealingPlans, "amount");
    this.empDirectpayPlantaxTotal = sumBy(employeeDealingPlans, "tax");
    this.empDirectpayPlangrandTotal = sumBy(employeeDealingPlans, "total");

    //Company paid and company covered split with payroll
    this.companydealingplansTotal = sumBy(companyDealingPlans, "amount");
    this.companydealingplanstaxTotal = sumBy(companyDealingPlans, "tax");
    this.companydealingplansgrandTotal = sumBy(companyDealingPlans, "total");

    // for(var i=0;i<this.EmployeeSelectedPlans.length;i++){
    //   this.companyCoveredTotal += this.EmployeeSelectedPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.EmployeeSelectedPlans[i].total, "1.2-2"))

    // }
    //cp+cc(company)
    this.effectiveCompanyPlansAmountTotal =
      parseFloat(this.allCPPlansAmountTotal) +
      parseFloat(this.companyCoveredCompanySharePlanAmountTotal);
    this.effectiveCompanyPlansAmountTotal = this._decimalPipe.transform(
      this.effectiveCompanyPlansAmountTotal,
      "1.2-2"
    );
    this.effectiveCompanyTaxTotal =
      parseFloat(this.allCPTaxTotal) +
      parseFloat(this.companyCoveredCompanyShareTaxTotal);
    this.effectiveCompanyTaxTotal = this._decimalPipe.transform(
      this.effectiveCompanyTaxTotal,
      "1.2-2"
    );
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyPaidTotal) +
      parseFloat(this.companyCoveredCompanyShareTotal);
    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );


    this.allEPPlansAmountTotal = sumBy(this.EmployeeSelectedPlans, "amount");
    this.allEPTaxTotal = sumBy(this.EmployeeSelectedPlans, "tax");
    this.paidEmployeedTotal = sumBy(this.EmployeeSelectedPlans, "total");
    //this.consoleMessage(this.paidEmployeedTotal);
    // this.paidEmployeedTotal = this._decimalPipe.transform(
    //   this.paidEmployeedTotal,
    //   "1.2-2"
    // );
    // //this.consoleMessage(this.companyPaidTotal)
    // //this.consoleMessage(this.companyCoveredTotal)
    // //this.consoleMessage(this.paidEmployeedTotal)



    this.planssummarymainLife = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );

    //console.log(this.planssummarymainLife)
    let total: any = 0;
    for (let i = 0; i < this.planssummarymainLife.length; i++) {
      total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
    }

    //console.log(total)
    this.effectiveEmployeeTotalContibution =
      parseFloat(this.companyCoveredEmployeeShareTotal) +
      parseFloat(this.paidEmployeedTotal);
    this.effectiveEmployeeTotalContibution = adjustWith2DecimalsForUI(
      this.effectiveEmployeeTotalContibution
    );

    //console.log(this.effectiveEmployeeTotalContibution)
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyCoveredCompanyShareTotal) +
      parseFloat(this.companyPaidTotal);

    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );

    //this.consoleMessage(this.companyCoveredPlans)
    //payrollDeduction setting

    let payrollDeduction = sessionStorage.getItem("payrollDeduction")
      ? sessionStorage.getItem("payrollDeduction")
      : "EMPLOYEE_CHOICE";

    if (
      this.companyCoveredPlans.length > 0 &&
      payrollDeduction == "EMPLOYEE_CHOICE"
    ) {
      // $("payrolldeduction-modal").show()
      // jQuery("#payrolldeduction-modal").modal("show");
    }
  }
  public calculateTaxforPlan(plan: any) {
    let plandetails;
    //this.logger.log(plan)
    //this.logger.log($(`#plancheck${plan.id}`))
    for (const cpPlan of plan) {
      //this.logger.log(plan)
      for (const product1 in cpPlan.productAddonss) {

        //this.logger.log(cpPlan.productAddonss[product1][0].id)

        plandetails = $("#plancheck" + cpPlan.productAddonss[product1][0].id).attr("data");


        //this.logger.log(plandetails)
        let plandetailsobj = plandetails.split("##");

        let obj = {
          // enrollmentDate:this.datePipe.transform(
          //   this.userForm.value.planenrollmentdate,
          //   'yyyy-MM-dd'
          // ),
          enrollmentDate: sessionStorage.getItem('enrollmentdate'),

          // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
          name: plandetailsobj[14],
          details: plandetailsobj[0],
          packagename: plandetailsobj[0],
          groupName: plandetailsobj[1],
          amount: parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          planCoverage: plandetailsobj[2],
          planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          gst:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? 0
              : parseFloat(plandetailsobj[4]),
          hst:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? 0
              : parseFloat(plandetailsobj[5]),
          pst:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? 0
              : parseFloat(plandetailsobj[6]),
          qst:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? 0
              : parseFloat(plandetailsobj[17]),
          gstCheck:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? false
              : true,
          hstCheck:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? false
              : true,
          pstCheck:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? false
              : true,
          qstCheck:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? false
              : true,
          id: parseFloat(plandetailsobj[7]),
          fusebillPlanID:
            plandetailsobj[8] == null ||
              plandetailsobj[8] == "" ||
              plandetailsobj[8] == undefined ||
              plandetailsobj[8] == "null"
              ? 0
              : parseFloat(plandetailsobj[8]),
          planFrequencyID:
            plandetailsobj[9] == null ||
              plandetailsobj[9] == "" ||
              plandetailsobj[9] == undefined ||
              plandetailsobj[9] == "null"
              ? 0
              : parseFloat(plandetailsobj[9]),
          optIn: plandetailsobj[10] == "true" ? true : false,
          planname: plandetailsobj[14],
          planLevel: parseInt(plandetailsobj[15]),
          packageId: parseInt(plandetailsobj[16]),
          options: [],
          paidByCompany1: plandetailsobj[19],
          coveredByCompany1: plandetailsobj[20],
          paidByEmployee1: plandetailsobj[21],
          planLevel_parentId: plandetailsobj[12],
          disallowedPlanLevels: plandetailsobj[11],
        };

        ////this.logger.log(obj)
        let gstprice = 0;
        let hstprice = 0;
        let pstprice = 0;
        let qstprice = 0;

        if (obj.gst > 0) {
          gstprice = obj.planPrice * obj.gst;
          obj["gstPrice"] = parseFloat(this._decimalPipe.transform(gstprice, "1.2-2"));
        } else {
          obj["gstPrice"] = 0;
        }

        if (obj.hst > 0) {
          hstprice = obj.planPrice * obj.hst;

          obj["hstPrice"] = parseFloat(this._decimalPipe.transform(hstprice, "1.2-2"));
        } else {
          obj["hstPrice"] = 0;
        }

        if (obj.pst > 0) {
          pstprice = obj.planPrice * obj.pst;
          obj["pstPrice"] = parseFloat(this._decimalPipe.transform(pstprice, "1.2-2"));
        } else {
          obj["pstPrice"] = 0;
        }

        if (obj.qst > 0) {
          qstprice = obj.planPrice * obj.qst;
          obj["qstPrice"] = parseFloat(this._decimalPipe.transform(qstprice, "1.2-2"));
        } else {
          obj["qstPrice"] = 0;
        }

        obj["taxUI"] = "";
        if (obj["gstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["gstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["gstPrice"], "1.2-2") + "&nbsp;(GST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["pstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["pstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["pstPrice"], "1.2-2") + "&nbsp;(PST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["qstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["qstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["qstPrice"], "1.2-2") + "&nbsp;(QST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["hstCheck"]) {
          obj["taxUI"] += "<span> ";
          if (obj["hstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["hstPrice"], "1.2-2") + "&nbsp;(HST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (!obj["hstCheck"] && !obj["gstCheck"] && !obj["pstCheck"] && !obj["qstCheck"]) {
          obj["taxUI"] += "<span>-";

          obj["taxUI"] += "</span>";
        }

        // ////this.logger.log(object["taxUI"])

        obj["tax"] = parseFloat(
          this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, "1.2-2")
        );

        //this.logger.log(obj.planPrice);
        //this.logger.log(gstprice);
        //this.logger.log(hstprice);
        //this.logger.log(pstprice);

        //this.logger.log(qstprice);
        let pricecal = obj.planPrice + gstprice + hstprice + pstprice + qstprice;
        obj["totalPrice"] = pricecal;

        obj["totalUI"] = "$" + pricecal;

        obj["total"] = pricecal;
        //this.logger.log(obj)
        return obj;


      }

    }


  }

  public convertpackagesToPlans2(packages: { paidByCompany: any[]; }) {
    //this.consoleMessage("pacakges");
    //all_plans
    var plans: any[] = [];
    var cp_plans: any[] = [];
    var cc_plans: any[] = [];
    var ep_plans: any[] = [];

    packages?.paidByCompany.forEach((pack: { groupsCP: any[]; name: any; }, index: any) => {
      pack.groupsCP.forEach((group: { plans: any[]; parentId: any; name: any; id: any; categorization: { paidByCompany: any; coveredByCompany: any; paidByEmployee: any; companyPaidCoverage: any }; }, index1: any) => {
        group.plans.forEach((plan: { [x: string]: any; }, index2: any) => {
          if (plan) {
            plan["planLevel_parentId"] = group.parentId;
            plan["packageName"] = pack.name;
            plan["groupName"] = group.name;
            plan["groupId"] = group.id;
            plan["groupparentId"] = group.parentId;
            plan["companyPaidCoverage"] = group.categorization?.companyPaidCoverage ?? "DIRECT";
            plans.push(plan);

            if (group.categorization.paidByCompany) {
              cp_plans.push(plan);
            }
            if (group.categorization.coveredByCompany) {
              cc_plans.push(plan);
            }
            if (group.categorization.paidByEmployee) {
              ep_plans.push(plan);
            }
          } else {
            //this.consoleMessage("else");
          }
        });
      });
    });



    return [plans, cp_plans, cc_plans, ep_plans];
  }

  checkrequiredPlan(plan) {


    let newplan: any = [];

    for (let product1 in plan.productAddonss) {
      //this.logger.log(product1)
      //this.logger.log(plan.productAddonss[product1])
      let product = plan.productAddonss[product1].reduce(function (prev, current) {
        if (+current.id > +prev.id) {
          return current;
        } else {
          return prev;
        }
      });
      // newplan.productAddonss[product1]= []

      let coverage = product.planCoverage

      coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage) ? coverage : null
      ////this.logger.log(obj)
      let productobj = {

        id: product.id,
        productId: product.productId,
        name: product.name,


        planProductId: product.planProductId,
        //  price: product.price1 || product.price,
        //  tax: product.calculatedTax ? product.calculatedTax.tax : 0,
        //  total: product.calculatedTax ? product.calculatedTax.total : 0,
        price: adjustWith2DecimalsForUI(product.price1 || product.price),
        tax: adjustWith2DecimalsForUI(product.calculatedTax ? product.calculatedTax.tax : 0),
        total: adjustWith2DecimalsForUI(product.calculatedTax ? product.calculatedTax.total : 0),
        //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
        //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
        //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),
        tax_details:

          product.bundledTaxes && product.bundledTaxes.length > 0

            ? product.bundledTaxes

            : product.taxesDataJSON,
        calculatedTax: product.calculatedTax,
        bundledProducts: product.bundledProducts,
        planCoverage: product.planCoverage,
        planLevel: product.planlevel ? product.planlevel.id : '',
        planLevelParent: product.planlevel ? product.planlevel.parentId : "",
        description: product.description,
        coverage: coverage
      };
      let obj1 = {

        packageId: plan.packageId,
        packageName: plan.packageName,

        planproductname: productobj.name,

        groupid: plan.planLevel,
        groupName: plan.groupName,
        id: plan.id,
        name: plan.name,
        planLevel: plan.planLevel ? plan.planLevel : plan.groupId,
        planLevelParent: plan.groupparentId,
        fusebillPlanID: plan.fusebillId,
        planFrequencyID: plan.frqMonthly,
        isBundle: plan.isBundle,
        coverage: coverage,
        planCoverage: product.planCoverage,
        bundledProducts: [],
        products: [],
        upgradeCalculation: plan.upgradeCalculation,
        paidByCompany: "NA",//group.categorization.paidByCompany,
        coveredByCompany: "NA",//group.categorization.coveredByCompany,
        paidByEmployee: "NA" //group.categorization.paidByEmployee

      };
      obj1.products.push(productobj);
      newplan.push(obj1)

    }
    if (newplan.length > 1) {
      let reduced = newplan.reduce(function (prev, current) {
        if (+current.products[0].total > +prev.products[0].total) {
          return current;
        } else {
          return prev;
        }
      });
      return reduced.products[0]
    }
    else {
      return newplan[0].products[0]
    }



  }

  setDateOfHire() {
    let dateOfBirth = this.userForm.get('dateofbirth').value;
    this.logger.log(dateOfBirth);
    this.minDateHire = new Date(dateOfBirth)
  }

  TextToLowerCase(form: FormGroup, id: any) {
    let value = form.get(id).value.toLowerCase();
    form.get(id).setValue(value);
    form.get(id).updateValueAndValidity();
  }




}



export function apt_suitecheck(
  control: AbstractControl
): { [key: string]: any } | null {
  var Regexp = /^[a-zA-Z0-9]{1,50}$/;
  if (control.value && !Regexp.test(control.value)) {
    return { aptexpression: true };
  }
  return null;
}

export function postalcodeValidator(control: FormControl): {
  [key: string]: any;
} {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return String;
}
export function diff_years(dt2: any) {
  let dt1 = new Date();
  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60 * 60 * 24;
  return Math.abs(Math.round(diff / 365.25));
}


export function dateofbirthvalidation(
  control: AbstractControl
): { [key: string]: any } | null {
  let minDate = moment().subtract(74, "years").calendar();
  let maxDate = moment().subtract(16, "years").calendar();

  let minDatevalue = new Date(minDate);

  let maxDatevalue = new Date(maxDate);

  if (new Date(control.value) > maxDatevalue) {
    return { mindateofbirth: true };
  } else if (new Date(control.value) < minDatevalue) {
    return { maxdateofbirth: true };
  }

  return null;
}



export function creditcardvalidation(
  control: AbstractControl
): { [key: string]: any } | null {
  this.logger.log("creditcardvalidation: " + control.value);
  var creditcardRegexp = /^[0-9]{13,19}$/;
  if (control.value && !creditcardRegexp.test(control.value)) {
    return { invalidcreditcarddetails: true };
  }
  return null;
}

export function validatehoursperweek(
  control: AbstractControl
): { [key: string]: any } | null {
  if (control.value && control.value < 20) {
    return { mininvalidhours: true };
  } else if (control.value && control.value >= 81) {
    return { maxinvalidhours: true };
  }
}




